import * as React from "react";
import React__default, { useState, useRef, useEffect } from "react";
const pxToRem = (...e) => e.map((t) => `${t / 16}rem`).join(" "), pxToEm = (...e) => e.map((t) => `${t / 16}em`).join(" ");
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var e = React__default, t = Symbol.for("react.element"), s = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function r(l, d, u) {
    var c, m = {}, h = null, _ = null;
    u !== void 0 && (h = "" + u), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (_ = d.ref);
    for (c in d)
      i.call(d, c) && !a.hasOwnProperty(c) && (m[c] = d[c]);
    if (l && l.defaultProps)
      for (c in d = l.defaultProps, d)
        m[c] === void 0 && (m[c] = d[c]);
    return { $$typeof: t, type: l, key: h, ref: _, props: m, _owner: n.current };
  }
  return reactJsxRuntime_production_min.Fragment = s, reactJsxRuntime_production_min.jsx = r, reactJsxRuntime_production_min.jsxs = r, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var e = React__default, t = Symbol.for("react.element"), s = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), b = Symbol.iterator, j = "@@iterator";
    function I(o) {
      if (o === null || typeof o != "object")
        return null;
      var g = b && o[b] || o[j];
      return typeof g == "function" ? g : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(o) {
      {
        for (var g = arguments.length, p = new Array(g > 1 ? g - 1 : 0), x = 1; x < g; x++)
          p[x - 1] = arguments[x];
        y("error", o, p);
      }
    }
    function y(o, g, p) {
      {
        var x = E.ReactDebugCurrentFrame, P = x.getStackAddendum();
        P !== "" && (g += "%s", p = p.concat([P]));
        var C = p.map(function(T) {
          return String(T);
        });
        C.unshift("Warning: " + g), Function.prototype.apply.call(console[o], console, C);
      }
    }
    var A = !1, f = !1, w = !1, N = !1, V = !1, q;
    q = Symbol.for("react.module.reference");
    function J(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === i || o === a || V || o === n || o === u || o === c || N || o === _ || A || f || w || typeof o == "object" && o !== null && (o.$$typeof === h || o.$$typeof === m || o.$$typeof === r || o.$$typeof === l || o.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === q || o.getModuleId !== void 0));
    }
    function K(o, g, p) {
      var x = o.displayName;
      if (x)
        return x;
      var P = g.displayName || g.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function W(o) {
      return o.displayName || "Context";
    }
    function z(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case i:
          return "Fragment";
        case s:
          return "Portal";
        case a:
          return "Profiler";
        case n:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case l:
            var g = o;
            return W(g) + ".Consumer";
          case r:
            var p = o;
            return W(p._context) + ".Provider";
          case d:
            return K(o, o.render, "ForwardRef");
          case m:
            var x = o.displayName || null;
            return x !== null ? x : z(o.type) || "Memo";
          case h: {
            var P = o, C = P._payload, T = P._init;
            try {
              return z(T(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, U = 0, Z, $, B, Q, O, H, Y;
    function ee() {
    }
    ee.__reactDisabledLog = !0;
    function pe() {
      {
        if (U === 0) {
          Z = console.log, $ = console.info, B = console.warn, Q = console.error, O = console.group, H = console.groupCollapsed, Y = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        U++;
      }
    }
    function ve() {
      {
        if (U--, U === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, o, {
              value: Z
            }),
            info: L({}, o, {
              value: $
            }),
            warn: L({}, o, {
              value: B
            }),
            error: L({}, o, {
              value: Q
            }),
            group: L({}, o, {
              value: O
            }),
            groupCollapsed: L({}, o, {
              value: H
            }),
            groupEnd: L({}, o, {
              value: Y
            })
          });
        }
        U < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = E.ReactCurrentDispatcher, ue;
    function te(o, g, p) {
      {
        if (ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var x = P.stack.trim().match(/\n( *(at )?)/);
            ue = x && x[1] || "";
          }
        return `
` + ue + o;
      }
    }
    var ce = !1, ie;
    {
      var _e = typeof WeakMap == "function" ? WeakMap : Map;
      ie = new _e();
    }
    function v(o, g) {
      if (!o || ce)
        return "";
      {
        var p = ie.get(o);
        if (p !== void 0)
          return p;
      }
      var x;
      ce = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = le.current, le.current = null, pe();
      try {
        if (g) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (G) {
              x = G;
            }
            Reflect.construct(o, [], T);
          } else {
            try {
              T.call();
            } catch (G) {
              x = G;
            }
            o.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (G) {
            x = G;
          }
          o();
        }
      } catch (G) {
        if (G && x && typeof G.stack == "string") {
          for (var k = G.stack.split(`
`), M = x.stack.split(`
`), R = k.length - 1, F = M.length - 1; R >= 1 && F >= 0 && k[R] !== M[F]; )
            F--;
          for (; R >= 1 && F >= 0; R--, F--)
            if (k[R] !== M[F]) {
              if (R !== 1 || F !== 1)
                do
                  if (R--, F--, F < 0 || k[R] !== M[F]) {
                    var D = `
` + k[R].replace(" at new ", " at ");
                    return o.displayName && D.includes("<anonymous>") && (D = D.replace("<anonymous>", o.displayName)), typeof o == "function" && ie.set(o, D), D;
                  }
                while (R >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ce = !1, le.current = C, ve(), Error.prepareStackTrace = P;
      }
      var oe = o ? o.displayName || o.name : "", ze = oe ? te(oe) : "";
      return typeof o == "function" && ie.set(o, ze), ze;
    }
    function me(o, g, p) {
      return v(o, !1);
    }
    function ne(o) {
      var g = o.prototype;
      return !!(g && g.isReactComponent);
    }
    function X(o, g, p) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return v(o, ne(o));
      if (typeof o == "string")
        return te(o);
      switch (o) {
        case u:
          return te("Suspense");
        case c:
          return te("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case d:
            return me(o.render);
          case m:
            return X(o.type);
          case h: {
            var x = o, P = x._payload, C = x._init;
            try {
              return X(C(P));
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, ke = {}, we = E.ReactDebugCurrentFrame;
    function he(o) {
      if (o) {
        var g = X(o.type);
        we.setExtraStackFrame(g);
      } else
        we.setExtraStackFrame(null);
    }
    function Me(o, g, p, x, P) {
      {
        var C = Function.call.bind(fe);
        for (var T in o)
          if (C(o, T)) {
            var k = void 0;
            try {
              if (typeof o[T] != "function") {
                var M = Error((x || "React class") + ": " + p + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw M.name = "Invariant Violation", M;
              }
              k = o[T](g, T, x, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              k = R;
            }
            k && !(k instanceof Error) && (he(P), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", x || "React class", p, T, typeof k), he(null)), k instanceof Error && !(k.message in ke) && (ke[k.message] = !0, he(P), S("Failed %s type: %s", p, k.message), he(null));
          }
      }
    }
    var Le = Array.isArray;
    function ye(o) {
      return Le(o);
    }
    function Oe(o) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, p = g && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return p;
      }
    }
    function De(o) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function Be(o) {
      return "" + o;
    }
    function Te(o) {
      if (De())
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Oe(o)), Be(o);
    }
    var ge = E.ReactCurrentOwner, He = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Ae, be;
    be = {};
    function Ue(o) {
      if (fe.call(o, "ref")) {
        var g = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function Ge(o) {
      if (fe.call(o, "key")) {
        var g = Object.getOwnPropertyDescriptor(o, "key").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function Ve(o, g) {
      if (typeof o.ref == "string" && ge.current && g && ge.current.stateNode !== g) {
        var p = z(ge.current.type);
        be[p] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(ge.current.type), o.ref), be[p] = !0);
      }
    }
    function qe(o, g) {
      {
        var p = function() {
          je || (je = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        p.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function We(o, g) {
      {
        var p = function() {
          Ae || (Ae = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        p.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var $e = function(o, g, p, x, P, C, T) {
      var k = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: g,
        ref: p,
        props: T,
        // Record the component responsible for creating this element.
        _owner: C
      };
      return k._store = {}, Object.defineProperty(k._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(k, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.defineProperty(k, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(k.props), Object.freeze(k)), k;
    };
    function Ye(o, g, p, x, P) {
      {
        var C, T = {}, k = null, M = null;
        p !== void 0 && (Te(p), k = "" + p), Ge(g) && (Te(g.key), k = "" + g.key), Ue(g) && (M = g.ref, Ve(g, P));
        for (C in g)
          fe.call(g, C) && !He.hasOwnProperty(C) && (T[C] = g[C]);
        if (o && o.defaultProps) {
          var R = o.defaultProps;
          for (C in R)
            T[C] === void 0 && (T[C] = R[C]);
        }
        if (k || M) {
          var F = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          k && qe(T, F), M && We(T, F);
        }
        return $e(o, k, M, P, x, ge.current, T);
      }
    }
    var xe = E.ReactCurrentOwner, Pe = E.ReactDebugCurrentFrame;
    function ae(o) {
      if (o) {
        var g = X(o.type);
        Pe.setExtraStackFrame(g);
      } else
        Pe.setExtraStackFrame(null);
    }
    var Ee;
    Ee = !1;
    function Se(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function Ne() {
      {
        if (xe.current) {
          var o = z(xe.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function Ke(o) {
      {
        if (o !== void 0) {
          var g = o.fileName.replace(/^.*[\\\/]/, ""), p = o.lineNumber;
          return `

Check your code at ` + g + ":" + p + ".";
        }
        return "";
      }
    }
    var Ie = {};
    function Ze(o) {
      {
        var g = Ne();
        if (!g) {
          var p = typeof o == "string" ? o : o.displayName || o.name;
          p && (g = `

Check the top-level render call using <` + p + ">.");
        }
        return g;
      }
    }
    function Ce(o, g) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var p = Ze(g);
        if (Ie[p])
          return;
        Ie[p] = !0;
        var x = "";
        o && o._owner && o._owner !== xe.current && (x = " It was passed a child from " + z(o._owner.type) + "."), ae(o), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, x), ae(null);
      }
    }
    function Re(o, g) {
      {
        if (typeof o != "object")
          return;
        if (ye(o))
          for (var p = 0; p < o.length; p++) {
            var x = o[p];
            Se(x) && Ce(x, g);
          }
        else if (Se(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var P = I(o);
          if (typeof P == "function" && P !== o.entries)
            for (var C = P.call(o), T; !(T = C.next()).done; )
              Se(T.value) && Ce(T.value, g);
        }
      }
    }
    function Xe(o) {
      {
        var g = o.type;
        if (g == null || typeof g == "string")
          return;
        var p;
        if (typeof g == "function")
          p = g.propTypes;
        else if (typeof g == "object" && (g.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        g.$$typeof === m))
          p = g.propTypes;
        else
          return;
        if (p) {
          var x = z(g);
          Me(p, o.props, "prop", x, o);
        } else if (g.PropTypes !== void 0 && !Ee) {
          Ee = !0;
          var P = z(g);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof g.getDefaultProps == "function" && !g.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Je(o) {
      {
        for (var g = Object.keys(o.props), p = 0; p < g.length; p++) {
          var x = g[p];
          if (x !== "children" && x !== "key") {
            ae(o), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", x), ae(null);
            break;
          }
        }
        o.ref !== null && (ae(o), S("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Fe(o, g, p, x, P, C) {
      {
        var T = J(o);
        if (!T) {
          var k = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var M = Ke(P);
          M ? k += M : k += Ne();
          var R;
          o === null ? R = "null" : ye(o) ? R = "array" : o !== void 0 && o.$$typeof === t ? (R = "<" + (z(o.type) || "Unknown") + " />", k = " Did you accidentally export a JSX literal instead of a component?") : R = typeof o, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, k);
        }
        var F = Ye(o, g, p, P, C);
        if (F == null)
          return F;
        if (T) {
          var D = g.children;
          if (D !== void 0)
            if (x)
              if (ye(D)) {
                for (var oe = 0; oe < D.length; oe++)
                  Re(D[oe], o);
                Object.freeze && Object.freeze(D);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Re(D, o);
        }
        return o === i ? Je(F) : Xe(F), F;
      }
    }
    function Qe(o, g, p) {
      return Fe(o, g, p, !0);
    }
    function et(o, g, p) {
      return Fe(o, g, p, !1);
    }
    var tt = et, it = Qe;
    reactJsxRuntime_development.Fragment = i, reactJsxRuntime_development.jsx = tt, reactJsxRuntime_development.jsxs = it;
  }()), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const Fragment = jsxRuntimeExports.Fragment, jsx = jsxRuntimeExports.jsx, jsxs = jsxRuntimeExports.jsxs, theme_css_ts_vanilla = "", button_css_ts_vanilla = "";
function _toPrimitive$1(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var s = e[Symbol.toPrimitive];
  if (s !== void 0) {
    var i = s.call(e, t || "default");
    if (typeof i != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _toPropertyKey$1(e) {
  var t = _toPrimitive$1(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function _defineProperty$1(e, t, s) {
  return t = _toPropertyKey$1(t), t in e ? Object.defineProperty(e, t, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = s, e;
}
function ownKeys$1(e, t) {
  var s = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), s.push.apply(s, i);
  }
  return s;
}
function _objectSpread2$1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$1(Object(s), !0).forEach(function(i) {
      _defineProperty$1(e, i, s[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : ownKeys$1(Object(s)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(s, i));
    });
  }
  return e;
}
function mapValues(e, t) {
  var s = {};
  for (var i in e)
    s[i] = t(e[i], i);
  return s;
}
var shouldApplyCompound = (e, t, s) => {
  for (var i of Object.keys(e)) {
    var n;
    if (e[i] !== ((n = t[i]) !== null && n !== void 0 ? n : s[i]))
      return !1;
  }
  return !0;
}, createRuntimeFn = (e) => {
  var t = (s) => {
    var i = e.defaultClassName, n = _objectSpread2$1(_objectSpread2$1({}, e.defaultVariants), s);
    for (var a in n) {
      var r, l = (r = n[a]) !== null && r !== void 0 ? r : e.defaultVariants[a];
      if (l != null) {
        var d = l;
        typeof d == "boolean" && (d = d === !0 ? "true" : "false");
        var u = (
          // @ts-expect-error
          e.variantClassNames[a][d]
        );
        u && (i += " " + u);
      }
    }
    for (var [c, m] of e.compoundVariants)
      shouldApplyCompound(c, n, e.defaultVariants) && (i += " " + m);
    return i;
  };
  return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
    get base() {
      return e.defaultClassName.split(" ")[0];
    },
    get variants() {
      return mapValues(e.variantClassNames, (s) => mapValues(s, (i) => i.split(" ")[0]));
    }
  }, t;
}, buttonStyle = createRuntimeFn({ defaultClassName: "ory_elements__button__hm2git0", variantClassNames: { size: { medium: "ory_elements__button_size_medium__hm2git1", small: "ory_elements__button_size_small__hm2git2", large: "ory_elements__button_size_large__hm2git3" }, variant: { regular: "ory_elements__button_variant_regular__hm2git4", semibold: "ory_elements__button_variant_semibold__hm2git5", outline: "ory_elements__button_variant_outline__hm2git6", error: "ory_elements__button_variant_error__hm2git7" } }, defaultVariants: { size: "medium", variant: "regular" }, compoundVariants: [] });
const Button = ({
  header: e,
  size: t,
  variant: s,
  fullWidth: i,
  className: n,
  ...a
}) => /* @__PURE__ */ jsx("div", { className: n, children: /* @__PURE__ */ jsx(
  "button",
  {
    className: buttonStyle({ size: t, variant: s }),
    style: { width: i ? "100%" : "auto" },
    ...a,
    children: e
  }
) });
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function s() {
      for (var i = [], n = 0; n < arguments.length; n++) {
        var a = arguments[n];
        if (a) {
          var r = typeof a;
          if (r === "string" || r === "number")
            i.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var l = s.apply(null, a);
              l && i.push(l);
            }
          } else if (r === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              i.push(a.toString());
              continue;
            }
            for (var d in a)
              t.call(a, d) && a[d] && i.push(d);
          }
        }
      }
      return i.join(" ");
    }
    e.exports ? (s.default = s, e.exports = s) : window.classNames = s;
  })();
})(classnames);
var classnamesExports = classnames.exports;
const cn = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports), buttonLink_css_ts_vanilla = "";
var buttonLinkContainerStyle = createRuntimeFn({ defaultClassName: "ory_elements__button_link__1kxba131", variantClassNames: { position: { inline: "ory_elements__button_link_position_inline__1kxba132", left: "ory_elements__button_link_position_left__1kxba133", center: "ory_elements__button_link_position_center__1kxba134", right: "ory_elements__button_link_position_right__1kxba135" } }, defaultVariants: { position: "inline" }, compoundVariants: [] }), buttonLinkIconStyle = "ory_elements__button_link__1kxba136", buttonLinkStyle = createRuntimeFn({ defaultClassName: "ory_elements__button_link__1kxba130", variantClassNames: {}, defaultVariants: {}, compoundVariants: [] });
const buttonSocial_css_ts_vanilla = "";
var buttonSocialIconEndStyle = createRuntimeFn({ defaultClassName: "ory_elements__button_social__i8n2ika", variantClassNames: { size: { small: "ory_elements__button_social_size_small__i8n2ikb", medium: "ory_elements__button_social_size_medium__i8n2ikc", large: "ory_elements__button_social_size_large__i8n2ikd" } }, defaultVariants: {}, compoundVariants: [] }), buttonSocialIconStartStyle = createRuntimeFn({ defaultClassName: "ory_elements__button_social__i8n2ik6", variantClassNames: { size: { small: "ory_elements__button_social_size_small__i8n2ik7", medium: "ory_elements__button_social_size_medium__i8n2ik8", large: "ory_elements__button_social_size_large__i8n2ik9" } }, defaultVariants: {}, compoundVariants: [] }), buttonSocialStyle = createRuntimeFn({ defaultClassName: "ory_elements__button_social__i8n2ik0", variantClassNames: { size: { small: "ory_elements__button_social_size_small__i8n2ik1", medium: "ory_elements__button_social_size_medium__i8n2ik2", large: "ory_elements__button_social_size_large__i8n2ik3" }, variant: { regular: "ory_elements__button_social_variant_regular__i8n2ik4", semibold: "ory_elements__button_social_variant_semibold__i8n2ik5" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
const card_css_ts_vanilla = "";
var cardStyle = createRuntimeFn({ defaultClassName: "ory_elements__card__1xqjo9i3 ory_elements__card__1xqjo9i0", variantClassNames: { size: { default: "ory_elements__card_size_default__1xqjo9i4", wide: "ory_elements__card_size_wide__1xqjo9i5" } }, defaultVariants: { size: "default" }, compoundVariants: [] }), cardTitleImage = "ory_elements__card__1xqjo9i2", cardTitleStyle = "ory_elements__card__1xqjo9i1";
const checkbox_css_ts_vanilla = "";
var checkboxInputStyle = "ory_elements__checkbox__13ulsr11", checkboxStyle = "ory_elements__checkbox__13ulsr10";
const codebox_css_ts_vanilla = "";
var codeboxContentStyle = "ory_elements__codebox__gasiv42", codeboxHeaderStyle = "ory_elements__codebox__gasiv41", codeboxStyle = "ory_elements__codebox__gasiv40";
const colors_css_ts_vanilla = "";
function _toPrimitive(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var s = e[Symbol.toPrimitive];
  if (s !== void 0) {
    var i = s.call(e, t || "default");
    if (typeof i != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function _defineProperty(e, t, s) {
  return t = _toPropertyKey(t), t in e ? Object.defineProperty(e, t, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = s, e;
}
function ownKeys(e, t) {
  var s = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), s.push.apply(s, i);
  }
  return s;
}
function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys(Object(s), !0).forEach(function(i) {
      _defineProperty(e, i, s[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : ownKeys(Object(s)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(s, i));
    });
  }
  return e;
}
var createSprinkles$1 = (e) => function() {
  for (var t = arguments.length, s = new Array(t), i = 0; i < t; i++)
    s[i] = arguments[i];
  var n = Object.assign({}, ...s.map((d) => d.styles)), a = Object.keys(n), r = a.filter((d) => "mappings" in n[d]), l = (d) => {
    var u = [], c = {}, m = _objectSpread2({}, d), h = !1;
    for (var _ of r) {
      var b = d[_];
      if (b != null) {
        var j = n[_];
        h = !0;
        for (var I of j.mappings)
          c[I] = b, m[I] == null && delete m[I];
      }
    }
    var E = h ? _objectSpread2(_objectSpread2({}, c), m) : d, S = function() {
      var w = E[y], N = n[y];
      try {
        if (N.mappings)
          return "continue";
        if (typeof w == "string" || typeof w == "number") {
          if (process.env.NODE_ENV !== "production" && !N.values[w].defaultClass)
            throw new Error();
          u.push(N.values[w].defaultClass);
        } else if (Array.isArray(w))
          for (var V = 0; V < w.length; V++) {
            var q = w[V];
            if (q != null) {
              var J = N.responsiveArray[V];
              if (process.env.NODE_ENV !== "production" && !N.values[q].conditions[J])
                throw new Error();
              u.push(N.values[q].conditions[J]);
            }
          }
        else
          for (var K in w) {
            var W = w[K];
            if (W != null) {
              if (process.env.NODE_ENV !== "production" && !N.values[W].conditions[K])
                throw new Error();
              u.push(N.values[W].conditions[K]);
            }
          }
      } catch (Q) {
        if (process.env.NODE_ENV !== "production") {
          class O extends Error {
            constructor(Y) {
              super(Y), this.name = "SprinklesError";
            }
          }
          var z = (H) => typeof H == "string" ? '"'.concat(H, '"') : H, L = (H, Y, ee) => {
            throw new O('"'.concat(H, '" has no value ').concat(z(Y), ". Possible values are ").concat(Object.keys(ee).map(z).join(", ")));
          };
          if (!N)
            throw new O('"'.concat(y, '" is not a valid sprinkle'));
          if ((typeof w == "string" || typeof w == "number") && (w in N.values || L(y, w, N.values), !N.values[w].defaultClass))
            throw new O('"'.concat(y, '" has no default condition. You must specify which conditions to target explicitly. Possible options are ').concat(Object.keys(N.values[w].conditions).map(z).join(", ")));
          if (typeof w == "object") {
            if (!("conditions" in N.values[Object.keys(N.values)[0]]))
              throw new O('"'.concat(y, '" is not a conditional property'));
            if (Array.isArray(w)) {
              if (!("responsiveArray" in N))
                throw new O('"'.concat(y, '" does not support responsive arrays'));
              var U = N.responsiveArray.length;
              if (U < w.length)
                throw new O('"'.concat(y, '" only supports up to ').concat(U, " breakpoints. You passed ").concat(w.length));
              for (var Z of w)
                N.values[Z] || L(y, Z, N.values);
            } else
              for (var $ in w) {
                var B = w[$];
                if (B != null && (N.values[B] || L(y, B, N.values), !N.values[B].conditions[$]))
                  throw new O('"'.concat(y, '" has no condition named ').concat(z($), ". Possible values are ").concat(Object.keys(N.values[B].conditions).map(z).join(", ")));
              }
          }
        }
        throw Q;
      }
    };
    for (var y in E)
      var A = S();
    return e(u.join(" "));
  };
  return Object.assign(l, {
    properties: new Set(a)
  });
}, composeStyles = (e) => e, createSprinkles = function() {
  return createSprinkles$1(composeStyles)(...arguments);
}, colorProperties = { conditions: void 0, styles: { color: { values: { accentDisabled: { defaultClass: "ory_elements__colors_color_accentDisabled__8awkg00" }, accentDefault: { defaultClass: "ory_elements__colors_color_accentDefault__8awkg01" }, accentMuted: { defaultClass: "ory_elements__colors_color_accentMuted__8awkg02" }, accentSubtle: { defaultClass: "ory_elements__colors_color_accentSubtle__8awkg03" }, accentEmphasis: { defaultClass: "ory_elements__colors_color_accentEmphasis__8awkg04" }, foregroundDefault: { defaultClass: "ory_elements__colors_color_foregroundDefault__8awkg05" }, foregroundMuted: { defaultClass: "ory_elements__colors_color_foregroundMuted__8awkg06" }, foregroundSubtle: { defaultClass: "ory_elements__colors_color_foregroundSubtle__8awkg07" }, foregroundDisabled: { defaultClass: "ory_elements__colors_color_foregroundDisabled__8awkg08" }, foregroundOnDisabled: { defaultClass: "ory_elements__colors_color_foregroundOnDisabled__8awkg09" }, foregroundOnDark: { defaultClass: "ory_elements__colors_color_foregroundOnDark__8awkg0a" }, foregroundOnAccent: { defaultClass: "ory_elements__colors_color_foregroundOnAccent__8awkg0b" }, backgroundSurface: { defaultClass: "ory_elements__colors_color_backgroundSurface__8awkg0c" }, backgroundCanvas: { defaultClass: "ory_elements__colors_color_backgroundCanvas__8awkg0d" }, backgroundSubtle: { defaultClass: "ory_elements__colors_color_backgroundSubtle__8awkg0e" }, errorDefault: { defaultClass: "ory_elements__colors_color_errorDefault__8awkg0f" }, errorSubtle: { defaultClass: "ory_elements__colors_color_errorSubtle__8awkg0g" }, errorMuted: { defaultClass: "ory_elements__colors_color_errorMuted__8awkg0h" }, errorEmphasis: { defaultClass: "ory_elements__colors_color_errorEmphasis__8awkg0i" }, successEmphasis: { defaultClass: "ory_elements__colors_color_successEmphasis__8awkg0j" }, borderDefault: { defaultClass: "ory_elements__colors_color_borderDefault__8awkg0k" }, textDefault: { defaultClass: "ory_elements__colors_color_textDefault__8awkg0l" }, textDisabled: { defaultClass: "ory_elements__colors_color_textDisabled__8awkg0m" }, inputBackground: { defaultClass: "ory_elements__colors_color_inputBackground__8awkg0n" }, inputDisabled: { defaultClass: "ory_elements__colors_color_inputDisabled__8awkg0o" }, inputPlaceholder: { defaultClass: "ory_elements__colors_color_inputPlaceholder__8awkg0p" }, inputText: { defaultClass: "ory_elements__colors_color_inputText__8awkg0q" } } } } }, colorSprinkle = createSprinkles(colorProperties);
const defaultBreakpoints = {
  // using em here as it is more consistent across browsers
  xs: pxToEm(390),
  sm: pxToEm(640),
  md: pxToEm(768),
  lg: pxToEm(1024),
  xl: pxToEm(1280),
  xl2: pxToEm(1536)
}, defaultFont = {
  fontFamily: "Inter",
  fontFamilyMono: "JetBrainsMono",
  fontStyle: "normal"
}, defaultLightTheme = {
  fontFamily: "Inter",
  fontFamilyMono: "JetBrainsMono",
  fontStyle: "normal",
  accent: {
    def: "#3D53F5",
    muted: "#6475F7",
    emphasis: "#3142C4",
    disabled: "#E0E0E0",
    subtle: "#eceefe"
  },
  foreground: {
    def: "#171717",
    muted: "#616161",
    subtle: "#9E9E9E",
    disabled: "#BDBDBD",
    onDark: "#FFFFFF",
    onAccent: "#FFFFFF",
    onDisabled: "#e0e0e0"
  },
  background: {
    surface: "#FFFFFF",
    canvas: "#FCFCFC",
    subtle: "#EEEEEE"
  },
  error: {
    def: "#9c0f2e",
    subtle: "#fce8ec",
    muted: "#e95c7b",
    emphasis: "#DF1642"
  },
  success: {
    emphasis: "#18A957"
  },
  border: {
    def: "#EEEEEE"
  },
  text: {
    def: "#FFFFFF",
    disabled: "#757575"
  },
  input: {
    background: "#FFFFFF",
    disabled: "#E0E0E0",
    placeholder: "#9E9E9E",
    text: "#424242"
  }
}, defaultDarkTheme = {
  fontFamily: "Inter",
  fontFamilyMono: "JetBrainsMono",
  fontStyle: "normal",
  accent: {
    def: "#6475f7",
    disabled: "#757575",
    muted: "#3142c4",
    emphasis: "#3d53f5",
    subtle: "#0c1131"
  },
  foreground: {
    def: "#FFFFFF",
    muted: "#ddd9f7",
    subtle: "#9a8ce8",
    onDark: "#FFFFFF",
    onAccent: "#FFFFFF",
    onDisabled: "#e0e0e0",
    disabled: "#bdbdbd"
  },
  background: {
    surface: "#110d2b",
    canvas: "#090616",
    subtle: "#221C56"
  },
  border: {
    def: "#221956"
  },
  error: {
    def: "#e95c7b",
    subtle: "#2d040d",
    muted: "#9c0f2e",
    emphasis: "#df1642"
  },
  success: {
    emphasis: "#18a957"
  },
  input: {
    background: "#FFFFFF",
    text: "#424242",
    placeholder: "#9e9e9e",
    disabled: "#eeeeee"
  },
  text: {
    def: "#FFFFFF",
    disabled: "#757575"
  }
}, divider_css_ts_vanilla = "";
var dividerStyle = createRuntimeFn({ defaultClassName: "ory_elements__divider__15i54991", variantClassNames: { sizes: { fullWidth: "ory_elements__divider_sizes_fullWidth__15i54992" } }, defaultVariants: {}, compoundVariants: [] }), dividerTextStyle = "ory_elements__divider__15i54990";
const form_css_ts_vanilla = "";
var formStyle = "ory_elements__form__1pmqm1m0";
const grid_css_ts_vanilla = "";
var gridStyle = createRuntimeFn({ defaultClassName: "ory_elements__grid__v30igv0", variantClassNames: { direction: { row: "ory_elements__grid_direction_row__v30igv1", column: "ory_elements__grid_direction_column__v30igv2" }, gap: { 4: "ory_elements__grid_gap_4__v30igv3", 8: "ory_elements__grid_gap_8__v30igv4", 16: "ory_elements__grid_gap_16__v30igv5", 24: "ory_elements__grid_gap_24__v30igv6", 32: "ory_elements__grid_gap_32__v30igv7", 64: "ory_elements__grid_gap_64__v30igv8" } }, defaultVariants: {}, compoundVariants: [] });
const inputField_css_ts_vanilla = "";
var inputFieldStyle = "ory_elements__input_field__db4loq1", inputFieldTitleStyle = "ory_elements__input_field__db4loq0", inputFieldVisibilityToggleLabelStyle = "ory_elements__input_field__db4loq2";
const menuLink_css_ts_vanilla = "";
var menuLinkIconLeftStyle = "ory_elements__menu_link__1p4e0o41", menuLinkStyle = "ory_elements__menu_link__1p4e0o40", menuLinkTextStyle = "ory_elements__menu_link__1p4e0o42";
const message_css_ts_vanilla = "";
var messageStyle = createRuntimeFn({ defaultClassName: "ory_elements__message__5sut1r0", variantClassNames: { textPosition: { start: "ory_elements__message_textPosition_start__5sut1r1", center: "ory_elements__message_textPosition_center__5sut1r2", end: "ory_elements__message_textPosition_end__5sut1r3" }, severity: { error: "ory_elements__message_severity_error__5sut1r4", success: "ory_elements__message_severity_success__5sut1r5", info: "ory_elements__message_severity_info__5sut1r6", disabled: "ory_elements__message_severity_disabled__5sut1r7", default: "ory_elements__message_severity_default__5sut1r8" } }, defaultVariants: { textPosition: "center", severity: "default" }, compoundVariants: [] });
const nav_css_ts_vanilla = "";
var navMainSectionStyle = "ory_elements__nav__946e774", navMenuLinkSelectedStyle = "ory_elements__nav__946e773", navMenuSectionStyle = "ory_elements__nav__946e772", navSectionBottom = "ory_elements__nav__946e775", navSectionTitleStyle = "ory_elements__nav__946e771", navStyle = "ory_elements__nav__946e770", oryTheme = { fontFamily: "var(--ory-theme-font-family)", fontFamilyMono: "var(--ory-theme-font-family-mono)", fontStyle: "var(--ory-theme-font-style)", accent: { def: "var(--ory-theme-accent-def)", muted: "var(--ory-theme-accent-muted)", emphasis: "var(--ory-theme-accent-emphasis)", disabled: "var(--ory-theme-accent-disabled)", subtle: "var(--ory-theme-accent-subtle)" }, foreground: { def: "var(--ory-theme-foreground-def)", muted: "var(--ory-theme-foreground-muted)", subtle: "var(--ory-theme-foreground-subtle)", disabled: "var(--ory-theme-foreground-disabled)", onDark: "var(--ory-theme-foreground-on-dark)", onAccent: "var(--ory-theme-foreground-on-accent)", onDisabled: "var(--ory-theme-foreground-on-disabled)" }, background: { surface: "var(--ory-theme-background-surface)", canvas: "var(--ory-theme-background-canvas)", subtle: "var(--ory-theme-background-subtle)" }, error: { def: "var(--ory-theme-error-def)", subtle: "var(--ory-theme-error-subtle)", muted: "var(--ory-theme-error-muted)", emphasis: "var(--ory-theme-error-emphasis)" }, success: { emphasis: "var(--ory-theme-success-emphasis)" }, border: { def: "var(--ory-theme-border-def)" }, text: { def: "var(--ory-theme-text-def)", disabled: "var(--ory-theme-text-disabled)" }, input: { background: "var(--ory-theme-input-background)", disabled: "var(--ory-theme-input-disabled)", placeholder: "var(--ory-theme-input-placeholder)", text: "var(--ory-theme-input-text)" } };
const typography_css_ts_vanilla = "";
var inputTypographyStyle = createRuntimeFn({ defaultClassName: "ory_elements__typography__1nljf820", variantClassNames: { size: { 16: "ory_elements__typography_size_16__1nljf821", 18: "ory_elements__typography_size_18__1nljf822" }, type: { regular: "ory_elements__typography_type_regular__1nljf823", semiBold: "ory_elements__typography_type_semiBold__1nljf824" } }, defaultVariants: { size: 16, type: "regular" }, compoundVariants: [] }), typographyStyle = createRuntimeFn({ defaultClassName: "ory_elements__typography__1nljf825", variantClassNames: { size: { tiny: "ory_elements__typography_size_tiny__1nljf826", xsmall: "ory_elements__typography_size_xsmall__1nljf827", small: "ory_elements__typography_size_small__1nljf828", caption: "ory_elements__typography_size_caption__1nljf829", body: "ory_elements__typography_size_body__1nljf82a", lead: "ory_elements__typography_size_lead__1nljf82b", headline21: "ory_elements__typography_size_headline21__1nljf82c", headline26: "ory_elements__typography_size_headline26__1nljf82d", headline31: "ory_elements__typography_size_headline31__1nljf82e", headline37: "ory_elements__typography_size_headline37__1nljf82f", headline48: "ory_elements__typography_size_headline48__1nljf82g", display: "ory_elements__typography_size_display__1nljf82h", hero: "ory_elements__typography_size_hero__1nljf82i", uber: "ory_elements__typography_size_uber__1nljf82j", colossus: "ory_elements__typography_size_colossus__1nljf82k", monoCaption: "ory_elements__typography_size_monoCaption__1nljf82l" }, type: { regular: "ory_elements__typography_type_regular__1nljf82m", bold: "ory_elements__typography_type_bold__1nljf82n" } }, defaultVariants: { type: "regular" }, compoundVariants: [] });
const isCustomHref = (e) => e !== void 0 && e.handler !== void 0, ButtonLink = ({
  href: e,
  className: t,
  icon: s,
  children: i,
  position: n,
  ...a
}) => {
  let r = {
    ...a
  };
  return isCustomHref(e) ? r = {
    ...r,
    href: e.href ?? "",
    onClick: (l) => {
      l.preventDefault(), e.handler();
    }
  } : r = {
    ...r,
    href: e
  }, /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        t,
        typographyStyle({ size: "caption", type: "regular" }),
        buttonLinkContainerStyle({ position: n })
      ),
      children: /* @__PURE__ */ jsxs("a", { className: buttonLinkStyle(), ...r, children: [
        s && /* @__PURE__ */ jsx("i", { className: cn(`fa fa-${s}`, buttonLinkIconStyle) }),
        i
      ] })
    }
  );
}, ButtonSocial = ({
  header: e,
  brand: t,
  size: s,
  variant: i,
  fullWidth: n,
  className: a,
  ...r
}) => {
  const l = t !== "generic" ? `fa-brands fa-${t}` : "fa-solid fa-layer-group";
  return /* @__PURE__ */ jsx("div", { className: a, children: /* @__PURE__ */ jsxs(
    "button",
    {
      className: buttonSocialStyle({ size: s, variant: i }),
      style: { width: n ? "100%" : "auto" },
      ...r,
      children: [
        /* @__PURE__ */ jsx("i", { className: cn(l, buttonSocialIconStartStyle({ size: s })) }),
        e,
        /* @__PURE__ */ jsx(
          "i",
          {
            className: cn(l, buttonSocialIconEndStyle({ size: s })),
            style: { visibility: "hidden", opacity: 0 }
          }
        )
      ]
    }
  ) });
}, Card = ({
  heading: e,
  image: t,
  className: s,
  children: i,
  size: n,
  ...a
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      cardStyle({
        size: n
      }),
      typographyStyle({ type: "regular", size: "small" }),
      s
    ),
    ...a,
    children: /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
      t && /* @__PURE__ */ jsx(Fragment, { children: typeof t == "string" ? /* @__PURE__ */ jsx(
        "img",
        {
          className: cardTitleImage,
          src: t,
          alt: t,
          width: "100%",
          height: "100%"
        }
      ) : t }),
      /* @__PURE__ */ jsx("div", { className: cardTitleStyle, children: typeof e == "string" ? /* @__PURE__ */ jsx("h3", { className: typographyStyle({ type: "regular", size: "small" }), children: e }) : e }),
      /* @__PURE__ */ jsx("div", { children: i })
    ] })
  }
), cardGradient_css_ts_vanilla = "";
var cardContainer = "ory_elements__card_gradient__ut7kc70", cardGradientActionStyle = createRuntimeFn({ defaultClassName: "ory_elements__card_gradient__ut7kc74", variantClassNames: { disabled: { true: "ory_elements__card_gradient_disabled_true__ut7kc75", false: "ory_elements__card_gradient_disabled_false__ut7kc76" } }, defaultVariants: { disabled: !1 }, compoundVariants: [] }), cardGradientOverlayStyle = createRuntimeFn({ defaultClassName: "ory_elements__card_gradient__ut7kc71", variantClassNames: { disabled: { true: "ory_elements__card_gradient_disabled_true__ut7kc72", false: "ory_elements__card_gradient_disabled_false__ut7kc73" } }, defaultVariants: { disabled: !1 }, compoundVariants: [] });
const CardGradient = ({
  heading: e,
  content: t,
  action: s,
  target: i,
  disabled: n,
  className: a,
  ...r
}) => /* @__PURE__ */ jsxs(
  "a",
  {
    className: cn(cardContainer, cardGradientOverlayStyle({ disabled: n })),
    target: i,
    "aria-disabled": n,
    ...!n && { href: s },
    ...r,
    children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            colorSprinkle({
              color: n ? "foregroundOnDisabled" : "foregroundOnDark"
            }),
            a
          ),
          children: /* @__PURE__ */ jsxs("div", { className: cn(gridStyle({ gap: 16 })), children: [
            typeof e == "string" ? /* @__PURE__ */ jsx(
              "div",
              {
                className: typographyStyle({ size: "headline21", type: "bold" }),
                children: e
              }
            ) : e,
            typeof t == "string" ? /* @__PURE__ */ jsx("div", { className: typographyStyle({ size: "small", type: "regular" }), children: t }) : t
          ] })
        }
      ),
      /* @__PURE__ */ jsx(
        "i",
        {
          className: cn("fa fa-arrow-right", cardGradientActionStyle({ disabled: n }))
        }
      )
    ]
  }
), Message = ({
  severity: e,
  textPosition: t,
  className: s,
  children: i,
  ...n
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      messageStyle({ severity: e, textPosition: t }),
      typographyStyle({ size: "caption", type: "regular" }),
      s
    ),
    ...n,
    children: i
  }
), fallback = () => Math.random().toString(36).substring(2), useIdWithFallback = () => {
  try {
    return React["useId".toString()]() ?? fallback();
  } catch {
    return fallback();
  }
}, Checkbox = ({
  className: e,
  label: t,
  helperMessage: s,
  messageTestId: i,
  dataTestid: n,
  ...a
}) => {
  const r = a.id ?? useIdWithFallback();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": n,
      className: gridStyle({ gap: 4, direction: "column" }),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn(
              e,
              typographyStyle({ type: "regular", size: "caption" }),
              checkboxStyle
            ),
            children: [
              /* @__PURE__ */ jsx(
                "input",
                {
                  className: checkboxInputStyle,
                  id: r,
                  type: "checkbox",
                  value: 1,
                  ...a
                }
              ),
              t && /* @__PURE__ */ jsx("label", { htmlFor: r, children: /* @__PURE__ */ jsx("span", { children: t }) })
            ]
          }
        ),
        typeof s == "string" ? /* @__PURE__ */ jsx(
          Message,
          {
            "data-testid": i,
            severity: a.severity,
            textPosition: "start",
            children: s
          }
        ) : s
      ]
    }
  );
}, CodeBox = ({
  children: e,
  className: t,
  toggleText: s,
  ...i
}) => {
  const n = useIdWithFallback();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(t, gridStyle({ gap: 16 }), codeboxStyle),
      ...i,
      children: [
        /* @__PURE__ */ jsx("input", { id: n, type: "checkbox" }),
        /* @__PURE__ */ jsxs(
          "label",
          {
            htmlFor: n,
            className: cn(typographyStyle({ size: "small" }), codeboxHeaderStyle),
            children: [
              /* @__PURE__ */ jsx("div", { children: s ?? "Toggle content" }),
              /* @__PURE__ */ jsxs("span", { children: [
                /* @__PURE__ */ jsx(
                  "i",
                  {
                    className: cn(
                      "fa fa-caret-down",
                      colorSprinkle({ color: "accentDefault" })
                    )
                  }
                ),
                /* @__PURE__ */ jsx(
                  "i",
                  {
                    className: cn(
                      "fa fa-caret-up",
                      colorSprinkle({ color: "accentDefault" })
                    )
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "pre",
          {
            className: cn(
              colorSprinkle({ color: "accentEmphasis" }),
              codeboxContentStyle
            ),
            children: e
          }
        )
      ]
    }
  );
}, Divider = ({
  className: e,
  fullWidth: t,
  text: s,
  ...i
}) => s ? /* @__PURE__ */ jsx("div", { className: cn(dividerTextStyle, e), ...i, children: s }) : /* @__PURE__ */ jsx(
  "hr",
  {
    className: cn(
      dividerStyle(t ? { sizes: "fullWidth" } : {}),
      e
    ),
    ...i
  }
), InputField = ({
  header: e,
  helperMessage: t,
  messageTestId: s,
  className: i,
  dataTestid: n,
  id: a,
  ...r
}) => {
  const l = a ?? useIdWithFallback(), [d, u] = useState(!1), c = useRef(null);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": n,
      className: cn(i, gridStyle({ gap: 4 })),
      children: [
        e && r.type !== "hidden" && /* @__PURE__ */ jsxs(
          "label",
          {
            htmlFor: l,
            className: typographyStyle({ size: "small", type: "regular" }),
            children: [
              e,
              " ",
              r.required && /* @__PURE__ */ jsx("span", { className: inputFieldTitleStyle, children: "*" })
            ]
          }
        ),
        r.type === "password" ? /* @__PURE__ */ jsxs("div", { style: { position: "relative" }, children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              className: cn(
                inputFieldStyle,
                typographyStyle({ size: "small", type: "regular" })
              ),
              placeholder: " ",
              id: l,
              ...r,
              type: d ? "text" : "password"
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              ref: c,
              onClick: (m) => {
                u(!d), m.currentTarget.dataset.checked = m.currentTarget.dataset.checked === "true" ? "false" : "true";
              },
              onKeyDown: (m) => {
                (m.key === "Enter" || m.key === " ") && (u(!d), m.currentTarget.dataset.checked = m.currentTarget.dataset.checked === "true" ? "false" : "true");
              },
              "data-checked": "false",
              className: inputFieldVisibilityToggleLabelStyle,
              tabIndex: 0,
              "aria-label": "Toggle password visibility",
              children: [
                /* @__PURE__ */ jsx(
                  "svg",
                  {
                    width: "22",
                    height: "20",
                    viewBox: "0 0 22 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ jsx(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11 0C15.2909 0 18.8627 2.4287 21.6646 7.15399L21.8844 7.53293L21.9302 7.63283L21.9591 7.71602L21.9736 7.77062L21.988 7.853L21.999 7.95346L21.9982 8.0639L21.9849 8.17441C21.9784 8.21115 21.9698 8.24773 21.9591 8.28398L21.9203 8.39157L21.8844 8.46707L21.8682 8.49616C19.1039 13.3334 15.5685 15.8773 11.3127 15.9957L11 16C6.6044 16 2.96348 13.4514 0.131768 8.49616C-0.0439228 8.18872 -0.0439228 7.81128 0.131768 7.50384C2.96348 2.54862 6.6044 0 11 0ZM11 2C7.59033 2 4.69918 3.89478 2.27859 7.80591L2.161 8L2.27859 8.19409C4.63002 11.9935 7.42551 13.8901 10.709 13.9954L11 14C14.4097 14 17.3008 12.1052 19.7214 8.19409L19.838 8L19.7214 7.80591C17.37 4.00652 14.5745 2.10992 11.291 2.00464L11 2ZM11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5ZM11 7C11.5523 7 12 7.44772 12 8C12 8.55228 11.5523 9 11 9C10.4477 9 10 8.55228 10 8C10 7.44772 10.4477 7 11 7Z",
                        fill: "#0F172A"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsx(
                  "svg",
                  {
                    width: "22",
                    height: "20",
                    viewBox: "0 0 22 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ jsx(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.29289 0.292893C1.65338 -0.0675907 2.22061 -0.0953203 2.6129 0.209705L2.70711 0.292893L16.9832 14.569C17.0385 14.6134 17.0897 14.6643 17.1356 14.7214L20.7071 18.2929C21.0976 18.6834 21.0976 19.3166 20.7071 19.7071C20.3466 20.0676 19.7794 20.0953 19.3871 19.7903L19.2929 19.7071L16.206 16.6203C14.6021 17.5382 12.8623 18 11 18C6.6044 18 2.96348 15.4514 0.131768 10.4962C-0.0439426 10.1887 -0.0439215 9.8112 0.131824 9.50374C1.32272 7.42032 2.65271 5.76402 4.12709 4.5413L1.29289 1.70711C0.902369 1.31658 0.902369 0.683418 1.29289 0.292893ZM5.54861 5.96282C4.40937 6.87487 3.34586 8.11002 2.3617 9.67319L2.161 10L2.27859 10.1941C4.63002 13.9935 7.42551 15.8901 10.709 15.9954L11 16C12.326 16 13.5644 15.7155 14.7281 15.1423L12.2945 12.7087C11.1784 13.2434 9.80013 13.048 8.87564 12.1229C7.95169 11.1982 7.75698 9.82091 8.29127 8.70548L5.54861 5.96282ZM10.2356 10.6498L10.3502 10.7644C10.3297 10.7469 10.3097 10.7285 10.2904 10.7091C10.2712 10.6899 10.2529 10.6701 10.2356 10.6498ZM11 1.99994C15.3956 1.99994 19.0365 4.54859 21.8682 9.50384C22.0439 9.81133 22.0439 10.1888 21.8682 10.4963C21.0533 11.9217 20.1753 13.1455 19.2314 14.1668C18.8565 14.5723 18.2238 14.5972 17.8182 14.2224C17.4127 13.8475 17.3878 13.2148 17.7626 12.8092C18.413 12.1056 19.0355 11.283 19.6296 10.3407L19.839 10L19.7214 9.8059C17.37 6.00649 14.5743 4.10986 11.2878 4.00458L10.9965 3.99993C10.1988 3.99716 9.40484 4.10708 8.63803 4.32643C8.10705 4.47833 7.55346 4.17102 7.40157 3.64003C7.24967 3.10905 7.55698 2.55546 8.08797 2.40357C9.0359 2.1324 10.0174 1.99652 11 1.99994Z",
                        fill: "#0F172A"
                      }
                    )
                  }
                )
              ]
            }
          )
        ] }) : /* @__PURE__ */ jsx(
          "input",
          {
            className: cn(
              inputFieldStyle,
              typographyStyle({ size: "small", type: "regular" })
            ),
            placeholder: " ",
            id: l,
            ...r
          }
        ),
        typeof t == "string" ? /* @__PURE__ */ jsx(Message, { "data-testid": s, severity: r.severity, children: t }) : t
      ]
    }
  );
}, MenuLink = ({
  href: e,
  children: t,
  target: s,
  disabled: i,
  iconLeft: n,
  iconRight: a,
  className: r,
  ...l
}) => /* @__PURE__ */ jsxs("div", { className: cn(r, menuLinkStyle), ...l, children: [
  /* @__PURE__ */ jsxs(
    "a",
    {
      className: cn(
        typographyStyle({ size: "small", type: "regular" }),
        colorSprinkle({
          color: i ? "foregroundDisabled" : "foregroundMuted"
        }),
        menuLinkTextStyle
      ),
      "aria-disabled": i,
      ...!i && { href: e },
      ...s && { target: s },
      children: [
        n && /* @__PURE__ */ jsx("i", { className: cn("fa", `fa-${n}`, menuLinkIconLeftStyle) }),
        t
      ]
    }
  ),
  a && /* @__PURE__ */ jsx(
    "i",
    {
      className: cn(
        "fa",
        `fa-${a}`,
        colorSprinkle({
          color: i ? "foregroundDisabled" : "foregroundMuted"
        })
      )
    }
  )
] }), Nav = ({
  navTitle: e,
  navSections: t,
  className: s,
  ...i
}) => {
  const n = `collapse-ory-elements-nav-${useIdWithFallback()}`;
  return /* @__PURE__ */ jsxs("nav", { role: "navigation", className: cn(navStyle, s), ...i, children: [
    /* @__PURE__ */ jsx("input", { id: n, type: "checkbox" }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: cn(
          navSectionTitleStyle,
          typographyStyle({ size: "caption" }),
          colorSprinkle({ color: "accentDefault" })
        ),
        children: [
          e,
          /* @__PURE__ */ jsxs("label", { htmlFor: n, children: [
            /* @__PURE__ */ jsx("i", { className: cn("fa", "fa-bars") }),
            /* @__PURE__ */ jsx("i", { className: cn("fa", "fa-xmark") })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "ul",
      {
        className: cn(
          navMainSectionStyle,
          navMenuSectionStyle,
          gridStyle({ gap: 24 })
        ),
        children: t.map((a, r) => /* @__PURE__ */ jsxs(
          "li",
          {
            ...a.floatBottom && { className: navSectionBottom },
            children: [
              a.title && /* @__PURE__ */ jsxs(
                "div",
                {
                  className: cn(
                    typographyStyle({ size: "xsmall", type: "bold" }),
                    colorSprinkle({ color: "foregroundDefault" }),
                    navSectionTitleStyle
                  ),
                  children: [
                    a.title,
                    /* @__PURE__ */ jsx("i", { className: `fa fa-${a.titleIcon}` })
                  ]
                }
              ),
              /* @__PURE__ */ jsx("ul", { className: navMenuSectionStyle, children: a.links.map(({ testId: l, ...d }, u) => /* @__PURE__ */ jsx(
                "li",
                {
                  ...d.selected && {
                    className: navMenuLinkSelectedStyle
                  },
                  children: /* @__PURE__ */ jsx(MenuLink, { "data-testid": l, ...d, children: d.name })
                },
                u
              )) })
            ]
          },
          r
        ))
      }
    )
  ] });
}, MessageSection = ({
  text: e,
  url: t,
  buttonText: s,
  dataTestId: i
}) => /* @__PURE__ */ jsxs(Message, { className: colorSprinkle({ color: "foregroundMuted" }), children: [
  e,
  " ",
  /* @__PURE__ */ jsx(ButtonLink, { "data-testid": i, href: t, children: s })
] });
var extendStatics = function(e, t) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, i) {
    s.__proto__ = i;
  } || function(s, i) {
    for (var n in i)
      Object.prototype.hasOwnProperty.call(i, n) && (s[n] = i[n]);
  }, extendStatics(e, t);
};
function __extends(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  extendStatics(e, t);
  function s() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (s.prototype = t.prototype, new s());
}
var __assign = function() {
  return __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var a in s)
        Object.prototype.hasOwnProperty.call(s, a) && (t[a] = s[a]);
    }
    return t;
  }, __assign.apply(this, arguments);
};
function __rest(e, t) {
  var s = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (s[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (s[i[n]] = e[i[n]]);
  return s;
}
function __spreadArray(e, t, s) {
  if (s || arguments.length === 2)
    for (var i = 0, n = t.length, a; i < n; i++)
      (a || !(i in t)) && (a || (a = Array.prototype.slice.call(t, 0, i)), a[i] = t[i]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, s = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, r = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, j = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function y(f) {
    if (typeof f == "object" && f !== null) {
      var w = f.$$typeof;
      switch (w) {
        case t:
          switch (f = f.type, f) {
            case d:
            case u:
            case i:
            case a:
            case n:
            case m:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case l:
                case c:
                case b:
                case _:
                case r:
                  return f;
                default:
                  return w;
              }
          }
        case s:
          return w;
      }
    }
  }
  function A(f) {
    return y(f) === u;
  }
  return reactIs_production_min.AsyncMode = d, reactIs_production_min.ConcurrentMode = u, reactIs_production_min.ContextConsumer = l, reactIs_production_min.ContextProvider = r, reactIs_production_min.Element = t, reactIs_production_min.ForwardRef = c, reactIs_production_min.Fragment = i, reactIs_production_min.Lazy = b, reactIs_production_min.Memo = _, reactIs_production_min.Portal = s, reactIs_production_min.Profiler = a, reactIs_production_min.StrictMode = n, reactIs_production_min.Suspense = m, reactIs_production_min.isAsyncMode = function(f) {
    return A(f) || y(f) === d;
  }, reactIs_production_min.isConcurrentMode = A, reactIs_production_min.isContextConsumer = function(f) {
    return y(f) === l;
  }, reactIs_production_min.isContextProvider = function(f) {
    return y(f) === r;
  }, reactIs_production_min.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === t;
  }, reactIs_production_min.isForwardRef = function(f) {
    return y(f) === c;
  }, reactIs_production_min.isFragment = function(f) {
    return y(f) === i;
  }, reactIs_production_min.isLazy = function(f) {
    return y(f) === b;
  }, reactIs_production_min.isMemo = function(f) {
    return y(f) === _;
  }, reactIs_production_min.isPortal = function(f) {
    return y(f) === s;
  }, reactIs_production_min.isProfiler = function(f) {
    return y(f) === a;
  }, reactIs_production_min.isStrictMode = function(f) {
    return y(f) === n;
  }, reactIs_production_min.isSuspense = function(f) {
    return y(f) === m;
  }, reactIs_production_min.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === i || f === u || f === a || f === n || f === m || f === h || typeof f == "object" && f !== null && (f.$$typeof === b || f.$$typeof === _ || f.$$typeof === r || f.$$typeof === l || f.$$typeof === c || f.$$typeof === I || f.$$typeof === E || f.$$typeof === S || f.$$typeof === j);
  }, reactIs_production_min.typeOf = y, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, s = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, r = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, j = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function y(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === i || v === u || v === a || v === n || v === m || v === h || typeof v == "object" && v !== null && (v.$$typeof === b || v.$$typeof === _ || v.$$typeof === r || v.$$typeof === l || v.$$typeof === c || v.$$typeof === I || v.$$typeof === E || v.$$typeof === S || v.$$typeof === j);
    }
    function A(v) {
      if (typeof v == "object" && v !== null) {
        var me = v.$$typeof;
        switch (me) {
          case t:
            var ne = v.type;
            switch (ne) {
              case d:
              case u:
              case i:
              case a:
              case n:
              case m:
                return ne;
              default:
                var X = ne && ne.$$typeof;
                switch (X) {
                  case l:
                  case c:
                  case b:
                  case _:
                  case r:
                    return X;
                  default:
                    return me;
                }
            }
          case s:
            return me;
        }
      }
    }
    var f = d, w = u, N = l, V = r, q = t, J = c, K = i, W = b, z = _, L = s, U = a, Z = n, $ = m, B = !1;
    function Q(v) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(v) || A(v) === d;
    }
    function O(v) {
      return A(v) === u;
    }
    function H(v) {
      return A(v) === l;
    }
    function Y(v) {
      return A(v) === r;
    }
    function ee(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function pe(v) {
      return A(v) === c;
    }
    function ve(v) {
      return A(v) === i;
    }
    function le(v) {
      return A(v) === b;
    }
    function ue(v) {
      return A(v) === _;
    }
    function te(v) {
      return A(v) === s;
    }
    function ce(v) {
      return A(v) === a;
    }
    function ie(v) {
      return A(v) === n;
    }
    function _e(v) {
      return A(v) === m;
    }
    reactIs_development.AsyncMode = f, reactIs_development.ConcurrentMode = w, reactIs_development.ContextConsumer = N, reactIs_development.ContextProvider = V, reactIs_development.Element = q, reactIs_development.ForwardRef = J, reactIs_development.Fragment = K, reactIs_development.Lazy = W, reactIs_development.Memo = z, reactIs_development.Portal = L, reactIs_development.Profiler = U, reactIs_development.StrictMode = Z, reactIs_development.Suspense = $, reactIs_development.isAsyncMode = Q, reactIs_development.isConcurrentMode = O, reactIs_development.isContextConsumer = H, reactIs_development.isContextProvider = Y, reactIs_development.isElement = ee, reactIs_development.isForwardRef = pe, reactIs_development.isFragment = ve, reactIs_development.isLazy = le, reactIs_development.isMemo = ue, reactIs_development.isPortal = te, reactIs_development.isProfiler = ce, reactIs_development.isStrictMode = ie, reactIs_development.isSuspense = _e, reactIs_development.isValidElementType = y, reactIs_development.typeOf = A;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? requireReactIs_production_min() : requireReactIs_development();
function invariant(e, t, s) {
  if (s === void 0 && (s = Error), !e)
    throw new s(t);
}
var ErrorKind;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));
var TYPE;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(e) {
  return e.type === TYPE.literal;
}
function isArgumentElement(e) {
  return e.type === TYPE.argument;
}
function isNumberElement(e) {
  return e.type === TYPE.number;
}
function isDateElement(e) {
  return e.type === TYPE.date;
}
function isTimeElement(e) {
  return e.type === TYPE.time;
}
function isSelectElement(e) {
  return e.type === TYPE.select;
}
function isPluralElement(e) {
  return e.type === TYPE.plural;
}
function isPoundElement(e) {
  return e.type === TYPE.pound;
}
function isTagElement(e) {
  return e.type === TYPE.tag;
}
function isNumberSkeleton(e) {
  return !!(e && typeof e == "object" && e.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(e) {
  return !!(e && typeof e == "object" && e.type === SKELETON_TYPE.dateTime);
}
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(e) {
  var t = {};
  return e.replace(DATE_TIME_REGEX, function(s) {
    var i = s.length;
    switch (s[0]) {
      case "G":
        t.era = i === 4 ? "long" : i === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = i === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][i - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][i - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = i === 4 ? "short" : i === 5 ? "narrow" : "short";
        break;
      case "e":
        if (i < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][i - 4];
        break;
      case "c":
        if (i < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][i - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][i - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][i - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][i - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][i - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][i - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][i - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = i < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function parseNumberSkeletonFromString(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(WHITE_SPACE_REGEX).filter(function(h) {
    return h.length > 0;
  }), s = [], i = 0, n = t; i < n.length; i++) {
    var a = n[i], r = a.split("/");
    if (r.length === 0)
      throw new Error("Invalid number skeleton");
    for (var l = r[0], d = r.slice(1), u = 0, c = d; u < c.length; u++) {
      var m = c[u];
      if (m.length === 0)
        throw new Error("Invalid number skeleton");
    }
    s.push({ stem: l, options: d });
  }
  return s;
}
function icuUnitToEcma(e) {
  return e.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g, INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g, CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(SIGNIFICANT_PRECISION_REGEX, function(s, i, n) {
    return typeof n != "string" ? (t.minimumSignificantDigits = i.length, t.maximumSignificantDigits = i.length) : n === "+" ? t.minimumSignificantDigits = i.length : i[0] === "#" ? t.maximumSignificantDigits = i.length : (t.minimumSignificantDigits = i.length, t.maximumSignificantDigits = i.length + (typeof n == "string" ? n.length : 0)), "";
  }), t;
}
function parseSign(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function parseConciseScientificAndEngineeringStem(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var s = e.slice(0, 2);
    if (s === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : s === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !CONCISE_INTEGER_WIDTH_REGEX.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function parseNotationOptions(e) {
  var t = {}, s = parseSign(e);
  return s || t;
}
function parseNumberSkeleton(e) {
  for (var t = {}, s = 0, i = e; s < i.length; s++) {
    var n = i[s];
    switch (n.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = n.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = icuUnitToEcma(n.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = __assign(__assign(__assign({}, t), { notation: "scientific" }), n.options.reduce(function(d, u) {
          return __assign(__assign({}, d), parseNotationOptions(u));
        }, {}));
        continue;
      case "engineering":
        t = __assign(__assign(__assign({}, t), { notation: "engineering" }), n.options.reduce(function(d, u) {
          return __assign(__assign({}, d), parseNotationOptions(u));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(n.options[0]);
        continue;
      case "integer-width":
        if (n.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        n.options[0].replace(INTEGER_WIDTH_REGEX, function(d, u, c, m, h, _) {
          if (u)
            t.minimumIntegerDigits = c.length;
          else {
            if (m && h)
              throw new Error("We currently do not support maximum integer digits");
            if (_)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (CONCISE_INTEGER_WIDTH_REGEX.test(n.stem)) {
      t.minimumIntegerDigits = n.stem.length;
      continue;
    }
    if (FRACTION_PRECISION_REGEX.test(n.stem)) {
      if (n.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      n.stem.replace(FRACTION_PRECISION_REGEX, function(d, u, c, m, h, _) {
        return c === "*" ? t.minimumFractionDigits = u.length : m && m[0] === "#" ? t.maximumFractionDigits = m.length : h && _ ? (t.minimumFractionDigits = h.length, t.maximumFractionDigits = h.length + _.length) : (t.minimumFractionDigits = u.length, t.maximumFractionDigits = u.length), "";
      });
      var a = n.options[0];
      a === "w" ? t = __assign(__assign({}, t), { trailingZeroDisplay: "stripIfInteger" }) : a && (t = __assign(__assign({}, t), parseSignificantPrecision(a)));
      continue;
    }
    if (SIGNIFICANT_PRECISION_REGEX.test(n.stem)) {
      t = __assign(__assign({}, t), parseSignificantPrecision(n.stem));
      continue;
    }
    var r = parseSign(n.stem);
    r && (t = __assign(__assign({}, t), r));
    var l = parseConciseScientificAndEngineeringStem(n.stem);
    l && (t = __assign(__assign({}, t), l));
  }
  return t;
}
var timeData = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "h",
    "K"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function getBestPattern(e, t) {
  for (var s = "", i = 0; i < e.length; i++) {
    var n = e.charAt(i);
    if (n === "j") {
      for (var a = 0; i + 1 < e.length && e.charAt(i + 1) === n; )
        a++, i++;
      var r = 1 + (a & 1), l = a < 2 ? 1 : 3 + (a >> 1), d = "a", u = getDefaultHourSymbolFromLocale(t);
      for ((u == "H" || u == "k") && (l = 0); l-- > 0; )
        s += d;
      for (; r-- > 0; )
        s = u + s;
    } else
      n === "J" ? s += "H" : s += n;
  }
  return s;
}
function getDefaultHourSymbolFromLocale(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var s = e.language, i;
  s !== "root" && (i = e.maximize().region);
  var n = timeData[i || ""] || timeData[s || ""] || timeData["".concat(s, "-001")] || timeData["001"];
  return n[0];
}
var _a, SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*")), SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(e, t) {
  return { start: e, end: t };
}
var hasNativeStartsWith = !!String.prototype.startsWith, hasNativeFromCodePoint = !!String.fromCodePoint, hasNativeFromEntries = !!Object.fromEntries, hasNativeCodePointAt = !!String.prototype.codePointAt, hasTrimStart = !!String.prototype.trimStart, hasTrimEnd = !!String.prototype.trimEnd, hasNativeIsSafeInteger = !!Number.isSafeInteger, isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, REGEX_SUPPORTS_U_AND_Y = !0;
try {
  var re = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec("a")) === null || _a === void 0 ? void 0 : _a[0]) === "a";
} catch {
  REGEX_SUPPORTS_U_AND_Y = !1;
}
var startsWith = hasNativeStartsWith ? (
  // Native
  function(t, s, i) {
    return t.startsWith(s, i);
  }
) : (
  // For IE11
  function(t, s, i) {
    return t.slice(i, i + s.length) === s;
  }
), fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], s = 0; s < arguments.length; s++)
      t[s] = arguments[s];
    for (var i = "", n = t.length, a = 0, r; n > a; ) {
      if (r = t[a++], r > 1114111)
        throw RangeError(r + " is not a valid code point");
      i += r < 65536 ? String.fromCharCode(r) : String.fromCharCode(((r -= 65536) >> 10) + 55296, r % 1024 + 56320);
    }
    return i;
  }
), fromEntries = (
  // native
  hasNativeFromEntries ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var s = {}, i = 0, n = t; i < n.length; i++) {
        var a = n[i], r = a[0], l = a[1];
        s[r] = l;
      }
      return s;
    }
  )
), codePointAt = hasNativeCodePointAt ? (
  // Native
  function(t, s) {
    return t.codePointAt(s);
  }
) : (
  // IE 11
  function(t, s) {
    var i = t.length;
    if (!(s < 0 || s >= i)) {
      var n = t.charCodeAt(s), a;
      return n < 55296 || n > 56319 || s + 1 === i || (a = t.charCodeAt(s + 1)) < 56320 || a > 57343 ? n : (n - 55296 << 10) + (a - 56320) + 65536;
    }
  }
), trimStart = hasTrimStart ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(SPACE_SEPARATOR_START_REGEX, "");
  }
), trimEnd = hasTrimEnd ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(SPACE_SEPARATOR_END_REGEX, "");
  }
);
function RE(e, t) {
  return new RegExp(e, t);
}
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
  var IDENTIFIER_PREFIX_RE_1 = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  matchIdentifierAtIndex = function(t, s) {
    var i;
    IDENTIFIER_PREFIX_RE_1.lastIndex = s;
    var n = IDENTIFIER_PREFIX_RE_1.exec(t);
    return (i = n[1]) !== null && i !== void 0 ? i : "";
  };
} else
  matchIdentifierAtIndex = function(t, s) {
    for (var i = []; ; ) {
      var n = codePointAt(t, s);
      if (n === void 0 || _isWhiteSpace(n) || _isPatternSyntax(n))
        break;
      i.push(n), s += n >= 65536 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, i);
  };
var Parser = (
  /** @class */
  function() {
    function e(t, s) {
      s === void 0 && (s = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!s.ignoreTag, this.locale = s.locale, this.requiresOtherClause = !!s.requiresOtherClause, this.shouldParseSkeletons = !!s.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, s, i) {
      for (var n = []; !this.isEOF(); ) {
        var a = this.char();
        if (a === 123) {
          var r = this.parseArgument(t, i);
          if (r.err)
            return r;
          n.push(r.val);
        } else {
          if (a === 125 && t > 0)
            break;
          if (a === 35 && (s === "plural" || s === "selectordinal")) {
            var l = this.clonePosition();
            this.bump(), n.push({
              type: TYPE.pound,
              location: createLocation(l, this.clonePosition())
            });
          } else if (a === 60 && !this.ignoreTag && this.peek() === 47) {
            if (i)
              break;
            return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
          } else if (a === 60 && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
            var r = this.parseTag(t, s);
            if (r.err)
              return r;
            n.push(r.val);
          } else {
            var r = this.parseLiteral(t, s);
            if (r.err)
              return r;
            n.push(r.val);
          }
        }
      }
      return { val: n, err: null };
    }, e.prototype.parseTag = function(t, s) {
      var i = this.clonePosition();
      this.bump();
      var n = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: TYPE.literal,
            value: "<".concat(n, "/>"),
            location: createLocation(i, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var a = this.parseMessage(t + 1, s, !0);
        if (a.err)
          return a;
        var r = a.val, l = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !_isAlpha(this.char()))
            return this.error(ErrorKind.INVALID_TAG, createLocation(l, this.clonePosition()));
          var d = this.clonePosition(), u = this.parseTagName();
          return n !== u ? this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(d, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: TYPE.tag,
              value: n,
              children: r,
              location: createLocation(i, this.clonePosition())
            },
            err: null
          } : this.error(ErrorKind.INVALID_TAG, createLocation(l, this.clonePosition())));
        } else
          return this.error(ErrorKind.UNCLOSED_TAG, createLocation(i, this.clonePosition()));
      } else
        return this.error(ErrorKind.INVALID_TAG, createLocation(i, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && _isPotentialElementNameChar(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, s) {
      for (var i = this.clonePosition(), n = ""; ; ) {
        var a = this.tryParseQuote(s);
        if (a) {
          n += a;
          continue;
        }
        var r = this.tryParseUnquoted(t, s);
        if (r) {
          n += r;
          continue;
        }
        var l = this.tryParseLeftAngleBracket();
        if (l) {
          n += l;
          continue;
        }
        break;
      }
      var d = createLocation(i, this.clonePosition());
      return {
        val: { type: TYPE.literal, value: n, location: d },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !_isAlphaOrSlash(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var s = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var i = this.char();
        if (i === 39)
          if (this.peek() === 39)
            s.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          s.push(i);
        this.bump();
      }
      return fromCodePoint.apply(void 0, s);
    }, e.prototype.tryParseUnquoted = function(t, s) {
      if (this.isEOF())
        return null;
      var i = this.char();
      return i === 60 || i === 123 || i === 35 && (s === "plural" || s === "selectordinal") || i === 125 && t > 0 ? null : (this.bump(), fromCodePoint(i));
    }, e.prototype.parseArgument = function(t, s) {
      var i = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(i, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(i, this.clonePosition()));
      var n = this.parseIdentifierIfPossible().value;
      if (!n)
        return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(i, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(i, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: TYPE.argument,
              // value does not include the opening and closing braces.
              value: n,
              location: createLocation(i, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(i, this.clonePosition())) : this.parseArgumentOptions(t, s, n, i);
        default:
          return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(i, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), s = this.offset(), i = matchIdentifierAtIndex(this.message, s), n = s + i.length;
      this.bumpTo(n);
      var a = this.clonePosition(), r = createLocation(t, a);
      return { value: i, location: r };
    }, e.prototype.parseArgumentOptions = function(t, s, i, n) {
      var a, r = this.clonePosition(), l = this.parseIdentifierIfPossible().value, d = this.clonePosition();
      switch (l) {
        case "":
          return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(r, d));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var u = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var c = this.clonePosition(), m = this.parseSimpleArgStyleIfPossible();
            if (m.err)
              return m;
            var h = trimEnd(m.val);
            if (h.length === 0)
              return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
            var _ = createLocation(c, this.clonePosition());
            u = { style: h, styleLocation: _ };
          }
          var b = this.tryParseArgumentClose(n);
          if (b.err)
            return b;
          var j = createLocation(n, this.clonePosition());
          if (u && startsWith(u?.style, "::", 0)) {
            var I = trimStart(u.style.slice(2));
            if (l === "number") {
              var m = this.parseNumberSkeletonFromString(I, u.styleLocation);
              return m.err ? m : {
                val: { type: TYPE.number, value: i, location: j, style: m.val },
                err: null
              };
            } else {
              if (I.length === 0)
                return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, j);
              var E = I;
              this.locale && (E = getBestPattern(I, this.locale));
              var h = {
                type: SKELETON_TYPE.dateTime,
                pattern: E,
                location: u.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? parseDateTimeSkeleton(E) : {}
              }, S = l === "date" ? TYPE.date : TYPE.time;
              return {
                val: { type: S, value: i, location: j, style: h },
                err: null
              };
            }
          }
          return {
            val: {
              type: l === "number" ? TYPE.number : l === "date" ? TYPE.date : TYPE.time,
              value: i,
              location: j,
              style: (a = u?.style) !== null && a !== void 0 ? a : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var y = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(y, __assign({}, y)));
          this.bumpSpace();
          var A = this.parseIdentifierIfPossible(), f = 0;
          if (l !== "select" && A.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var m = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (m.err)
              return m;
            this.bumpSpace(), A = this.parseIdentifierIfPossible(), f = m.val;
          }
          var w = this.tryParsePluralOrSelectOptions(t, l, s, A);
          if (w.err)
            return w;
          var b = this.tryParseArgumentClose(n);
          if (b.err)
            return b;
          var N = createLocation(n, this.clonePosition());
          return l === "select" ? {
            val: {
              type: TYPE.select,
              value: i,
              options: fromEntries(w.val),
              location: N
            },
            err: null
          } : {
            val: {
              type: TYPE.plural,
              value: i,
              options: fromEntries(w.val),
              offset: f,
              pluralType: l === "plural" ? "cardinal" : "ordinal",
              location: N
            },
            err: null
          };
        }
        default:
          return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(r, d));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, s = this.clonePosition(); !this.isEOF(); ) {
        var i = this.char();
        switch (i) {
          case 39: {
            this.bump();
            var n = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(n, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(s.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(s.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, s) {
      var i = [];
      try {
        i = parseNumberSkeletonFromString(t);
      } catch {
        return this.error(ErrorKind.INVALID_NUMBER_SKELETON, s);
      }
      return {
        val: {
          type: SKELETON_TYPE.number,
          tokens: i,
          location: s,
          parsedOptions: this.shouldParseSkeletons ? parseNumberSkeleton(i) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, s, i, n) {
      for (var a, r = !1, l = [], d = /* @__PURE__ */ new Set(), u = n.value, c = n.location; ; ) {
        if (u.length === 0) {
          var m = this.clonePosition();
          if (s !== "select" && this.bumpIf("=")) {
            var h = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (h.err)
              return h;
            c = createLocation(m, this.clonePosition()), u = this.message.slice(m.offset, this.offset());
          } else
            break;
        }
        if (d.has(u))
          return this.error(s === "select" ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, c);
        u === "other" && (r = !0), this.bumpSpace();
        var _ = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(s === "select" ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
        var b = this.parseMessage(t + 1, s, i);
        if (b.err)
          return b;
        var j = this.tryParseArgumentClose(_);
        if (j.err)
          return j;
        l.push([
          u,
          {
            value: b.val,
            location: createLocation(_, this.clonePosition())
          }
        ]), d.add(u), this.bumpSpace(), a = this.parseIdentifierIfPossible(), u = a.value, c = a.location;
      }
      return l.length === 0 ? this.error(s === "select" ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !r ? this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition())) : { val: l, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, s) {
      var i = 1, n = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (i = -1);
      for (var a = !1, r = 0; !this.isEOF(); ) {
        var l = this.char();
        if (l >= 48 && l <= 57)
          a = !0, r = r * 10 + (l - 48), this.bump();
        else
          break;
      }
      var d = createLocation(n, this.clonePosition());
      return a ? (r *= i, isSafeInteger(r) ? { val: r, err: null } : this.error(s, d)) : this.error(t, d);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var s = codePointAt(this.message, t);
      if (s === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return s;
    }, e.prototype.error = function(t, s) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: s
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (startsWith(this.message, t, this.offset())) {
        for (var s = 0; s < t.length; s++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var s = this.offset(), i = this.message.indexOf(t, s);
      return i >= 0 ? (this.bumpTo(i), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var s = this.offset();
        if (s === t)
          break;
        if (s > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && _isWhiteSpace(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), s = this.offset(), i = this.message.charCodeAt(s + (t >= 65536 ? 2 : 1));
      return i ?? null;
    }, e;
  }()
);
function _isAlpha(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function _isAlphaOrSlash(e) {
  return _isAlpha(e) || e === 47;
}
function _isPotentialElementNameChar(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function _isWhiteSpace(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function _isPatternSyntax(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function pruneLocation(e) {
  e.forEach(function(t) {
    if (delete t.location, isSelectElement(t) || isPluralElement(t))
      for (var s in t.options)
        delete t.options[s].location, pruneLocation(t.options[s].value);
    else
      isNumberElement(t) && isNumberSkeleton(t.style) || (isDateElement(t) || isTimeElement(t)) && isDateTimeSkeleton(t.style) ? delete t.style.location : isTagElement(t) && pruneLocation(t.children);
  });
}
function parse(e, t) {
  t === void 0 && (t = {}), t = __assign({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var s = new Parser(e, t).parse();
  if (s.err) {
    var i = SyntaxError(ErrorKind[s.err.kind]);
    throw i.location = s.err.location, i.originalMessage = s.err.message, i;
  }
  return t?.captureLocation || pruneLocation(s.val), s.val;
}
function memoize(e, t) {
  var s = t && t.cache ? t.cache : cacheDefault, i = t && t.serializer ? t.serializer : serializerDefault, n = t && t.strategy ? t.strategy : strategyDefault;
  return n(e, {
    cache: s,
    serializer: i
  });
}
function isPrimitive(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function monadic(e, t, s, i) {
  var n = isPrimitive(i) ? i : s(i), a = t.get(n);
  return typeof a > "u" && (a = e.call(this, i), t.set(n, a)), a;
}
function variadic(e, t, s) {
  var i = Array.prototype.slice.call(arguments, 3), n = s(i), a = t.get(n);
  return typeof a > "u" && (a = e.apply(this, i), t.set(n, a)), a;
}
function assemble(e, t, s, i, n) {
  return s.bind(t, e, i, n);
}
function strategyDefault(e, t) {
  var s = e.length === 1 ? monadic : variadic;
  return assemble(e, this, s, t.cache.create(), t.serializer);
}
function strategyVariadic(e, t) {
  return assemble(e, this, variadic, t.cache.create(), t.serializer);
}
function strategyMonadic(e, t) {
  return assemble(e, this, monadic, t.cache.create(), t.serializer);
}
var serializerDefault = function() {
  return JSON.stringify(arguments);
};
function ObjectWithoutPrototypeCache() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function(e) {
  return this.cache[e];
};
ObjectWithoutPrototypeCache.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var cacheDefault = {
  create: function() {
    return new ObjectWithoutPrototypeCache();
  }
}, strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
}, ErrorCode;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i, n) {
      var a = e.call(this, s) || this;
      return a.code = i, a.originalMessage = n, a;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), InvalidValueError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i, n, a) {
      return e.call(this, 'Invalid values for "'.concat(s, '": "').concat(i, '". Options are "').concat(Object.keys(n).join('", "'), '"'), ErrorCode.INVALID_VALUE, a) || this;
    }
    return t;
  }(FormatError)
), InvalidValueTypeError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i, n) {
      return e.call(this, 'Value for "'.concat(s, '" must be of type ').concat(i), ErrorCode.INVALID_VALUE, n) || this;
    }
    return t;
  }(FormatError)
), MissingValueError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i) {
      return e.call(this, 'The intl string context variable "'.concat(s, '" was not provided to the string "').concat(i, '"'), ErrorCode.MISSING_VALUE, i) || this;
    }
    return t;
  }(FormatError)
), PART_TYPE;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(e) {
  return e.length < 2 ? e : e.reduce(function(t, s) {
    var i = t[t.length - 1];
    return !i || i.type !== PART_TYPE.literal || s.type !== PART_TYPE.literal ? t.push(s) : i.value += s.value, t;
  }, []);
}
function isFormatXMLElementFn(e) {
  return typeof e == "function";
}
function formatToParts(e, t, s, i, n, a, r) {
  if (e.length === 1 && isLiteralElement(e[0]))
    return [
      {
        type: PART_TYPE.literal,
        value: e[0].value
      }
    ];
  for (var l = [], d = 0, u = e; d < u.length; d++) {
    var c = u[d];
    if (isLiteralElement(c)) {
      l.push({
        type: PART_TYPE.literal,
        value: c.value
      });
      continue;
    }
    if (isPoundElement(c)) {
      typeof a == "number" && l.push({
        type: PART_TYPE.literal,
        value: s.getNumberFormat(t).format(a)
      });
      continue;
    }
    var m = c.value;
    if (!(n && m in n))
      throw new MissingValueError(m, r);
    var h = n[m];
    if (isArgumentElement(c)) {
      (!h || typeof h == "string" || typeof h == "number") && (h = typeof h == "string" || typeof h == "number" ? String(h) : ""), l.push({
        type: typeof h == "string" ? PART_TYPE.literal : PART_TYPE.object,
        value: h
      });
      continue;
    }
    if (isDateElement(c)) {
      var _ = typeof c.style == "string" ? i.date[c.style] : isDateTimeSkeleton(c.style) ? c.style.parsedOptions : void 0;
      l.push({
        type: PART_TYPE.literal,
        value: s.getDateTimeFormat(t, _).format(h)
      });
      continue;
    }
    if (isTimeElement(c)) {
      var _ = typeof c.style == "string" ? i.time[c.style] : isDateTimeSkeleton(c.style) ? c.style.parsedOptions : i.time.medium;
      l.push({
        type: PART_TYPE.literal,
        value: s.getDateTimeFormat(t, _).format(h)
      });
      continue;
    }
    if (isNumberElement(c)) {
      var _ = typeof c.style == "string" ? i.number[c.style] : isNumberSkeleton(c.style) ? c.style.parsedOptions : void 0;
      _ && _.scale && (h = h * (_.scale || 1)), l.push({
        type: PART_TYPE.literal,
        value: s.getNumberFormat(t, _).format(h)
      });
      continue;
    }
    if (isTagElement(c)) {
      var b = c.children, j = c.value, I = n[j];
      if (!isFormatXMLElementFn(I))
        throw new InvalidValueTypeError(j, "function", r);
      var E = formatToParts(b, t, s, i, n, a), S = I(E.map(function(f) {
        return f.value;
      }));
      Array.isArray(S) || (S = [S]), l.push.apply(l, S.map(function(f) {
        return {
          type: typeof f == "string" ? PART_TYPE.literal : PART_TYPE.object,
          value: f
        };
      }));
    }
    if (isSelectElement(c)) {
      var y = c.options[h] || c.options.other;
      if (!y)
        throw new InvalidValueError(c.value, h, Object.keys(c.options), r);
      l.push.apply(l, formatToParts(y.value, t, s, i, n));
      continue;
    }
    if (isPluralElement(c)) {
      var y = c.options["=".concat(h)];
      if (!y) {
        if (!Intl.PluralRules)
          throw new FormatError(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, ErrorCode.MISSING_INTL_API, r);
        var A = s.getPluralRules(t, { type: c.pluralType }).select(h - (c.offset || 0));
        y = c.options[A] || c.options.other;
      }
      if (!y)
        throw new InvalidValueError(c.value, h, Object.keys(c.options), r);
      l.push.apply(l, formatToParts(y.value, t, s, i, n, h - (c.offset || 0)));
      continue;
    }
  }
  return mergeLiteral(l);
}
function mergeConfig(e, t) {
  return t ? __assign(__assign(__assign({}, e || {}), t || {}), Object.keys(e).reduce(function(s, i) {
    return s[i] = __assign(__assign({}, e[i]), t[i] || {}), s;
  }, {})) : e;
}
function mergeConfigs(e, t) {
  return t ? Object.keys(e).reduce(function(s, i) {
    return s[i] = mergeConfig(e[i], t[i]), s;
  }, __assign({}, e)) : e;
}
function createFastMemoizeCache$1(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, s) {
          e[t] = s;
        }
      };
    }
  };
}
function createDefaultFormatters(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: memoize(function() {
      for (var t, s = [], i = 0; i < arguments.length; i++)
        s[i] = arguments[i];
      return new ((t = Intl.NumberFormat).bind.apply(t, __spreadArray([void 0], s, !1)))();
    }, {
      cache: createFastMemoizeCache$1(e.number),
      strategy: strategies.variadic
    }),
    getDateTimeFormat: memoize(function() {
      for (var t, s = [], i = 0; i < arguments.length; i++)
        s[i] = arguments[i];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, __spreadArray([void 0], s, !1)))();
    }, {
      cache: createFastMemoizeCache$1(e.dateTime),
      strategy: strategies.variadic
    }),
    getPluralRules: memoize(function() {
      for (var t, s = [], i = 0; i < arguments.length; i++)
        s[i] = arguments[i];
      return new ((t = Intl.PluralRules).bind.apply(t, __spreadArray([void 0], s, !1)))();
    }, {
      cache: createFastMemoizeCache$1(e.pluralRules),
      strategy: strategies.variadic
    })
  };
}
var IntlMessageFormat = (
  /** @class */
  function() {
    function e(t, s, i, n) {
      s === void 0 && (s = e.defaultLocale);
      var a = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(d) {
        var u = a.formatToParts(d);
        if (u.length === 1)
          return u[0].value;
        var c = u.reduce(function(m, h) {
          return !m.length || h.type !== PART_TYPE.literal || typeof m[m.length - 1] != "string" ? m.push(h.value) : m[m.length - 1] += h.value, m;
        }, []);
        return c.length <= 1 ? c[0] || "" : c;
      }, this.formatToParts = function(d) {
        return formatToParts(a.ast, a.locales, a.formatters, a.formats, d, void 0, a.message);
      }, this.resolvedOptions = function() {
        var d;
        return {
          locale: ((d = a.resolvedLocale) === null || d === void 0 ? void 0 : d.toString()) || Intl.NumberFormat.supportedLocalesOf(a.locales)[0]
        };
      }, this.getAst = function() {
        return a.ast;
      }, this.locales = s, this.resolvedLocale = e.resolveLocale(s), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var r = n || {}, l = __rest(r, ["formatters"]);
        this.ast = e.__parse(t, __assign(__assign({}, l), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = mergeConfigs(e.formats, i), this.formatters = n && n.formatters || createDefaultFormatters(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var s = Intl.NumberFormat.supportedLocalesOf(t);
        return s.length > 0 ? new Intl.Locale(s[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = parse, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
), IntlErrorCode;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i, n) {
      var a = this, r = n ? n instanceof Error ? n : new Error(String(n)) : void 0;
      return a = e.call(this, "[@formatjs/intl Error ".concat(s, "] ").concat(i, `
`).concat(r ? `
`.concat(r.message, `
`).concat(r.stack) : "")) || this, a.code = s, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(a, t), a;
    }
    return t;
  }(Error)
), UnsupportedFormatterError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i) {
      return e.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, s, i) || this;
    }
    return t;
  }(IntlError)
), InvalidConfigError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i) {
      return e.call(this, IntlErrorCode.INVALID_CONFIG, s, i) || this;
    }
    return t;
  }(IntlError)
), MissingDataError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i) {
      return e.call(this, IntlErrorCode.MISSING_DATA, s, i) || this;
    }
    return t;
  }(IntlError)
), IntlFormatError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i, n) {
      var a = e.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(s, `
Locale: `).concat(i, `
`), n) || this;
      return a.locale = i, a;
    }
    return t;
  }(IntlError)
), MessageFormatError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i, n, a) {
      var r = e.call(this, "".concat(s, `
MessageID: `).concat(n?.id, `
Default Message: `).concat(n?.defaultMessage, `
Description: `).concat(n?.description, `
`), i, a) || this;
      return r.descriptor = n, r.locale = i, r;
    }
    return t;
  }(IntlFormatError)
), MissingTranslationError = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t(s, i) {
      var n = e.call(this, IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(s.id, '" for locale "').concat(i, '", using ').concat(s.defaultMessage ? "default message (".concat(typeof s.defaultMessage == "string" ? s.defaultMessage : s.defaultMessage.map(function(a) {
        var r;
        return (r = a.value) !== null && r !== void 0 ? r : JSON.stringify(a);
      }).join(), ")") : "id", " as fallback.")) || this;
      return n.descriptor = s, n;
    }
    return t;
  }(IntlError)
);
function filterProps(e, t, s) {
  return s === void 0 && (s = {}), t.reduce(function(i, n) {
    return n in e ? i[n] = e[n] : n in s && (i[n] = s[n]), i;
  }, {});
}
var defaultErrorHandler = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, defaultWarnHandler = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, DEFAULT_INTL_CONFIG$1 = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: defaultErrorHandler,
  onWarn: defaultWarnHandler
};
function createIntlCache() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function createFastMemoizeCache(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, s) {
          e[t] = s;
        }
      };
    }
  };
}
function createFormatters(e) {
  e === void 0 && (e = createIntlCache());
  var t = Intl.RelativeTimeFormat, s = Intl.ListFormat, i = Intl.DisplayNames, n = memoize(function() {
    for (var l, d = [], u = 0; u < arguments.length; u++)
      d[u] = arguments[u];
    return new ((l = Intl.DateTimeFormat).bind.apply(l, __spreadArray([void 0], d, !1)))();
  }, {
    cache: createFastMemoizeCache(e.dateTime),
    strategy: strategies.variadic
  }), a = memoize(function() {
    for (var l, d = [], u = 0; u < arguments.length; u++)
      d[u] = arguments[u];
    return new ((l = Intl.NumberFormat).bind.apply(l, __spreadArray([void 0], d, !1)))();
  }, {
    cache: createFastMemoizeCache(e.number),
    strategy: strategies.variadic
  }), r = memoize(function() {
    for (var l, d = [], u = 0; u < arguments.length; u++)
      d[u] = arguments[u];
    return new ((l = Intl.PluralRules).bind.apply(l, __spreadArray([void 0], d, !1)))();
  }, {
    cache: createFastMemoizeCache(e.pluralRules),
    strategy: strategies.variadic
  });
  return {
    getDateTimeFormat: n,
    getNumberFormat: a,
    getMessageFormat: memoize(function(l, d, u, c) {
      return new IntlMessageFormat(l, d, u, __assign({ formatters: {
        getNumberFormat: a,
        getDateTimeFormat: n,
        getPluralRules: r
      } }, c || {}));
    }, {
      cache: createFastMemoizeCache(e.message),
      strategy: strategies.variadic
    }),
    getRelativeTimeFormat: memoize(function() {
      for (var l = [], d = 0; d < arguments.length; d++)
        l[d] = arguments[d];
      return new (t.bind.apply(t, __spreadArray([void 0], l, !1)))();
    }, {
      cache: createFastMemoizeCache(e.relativeTime),
      strategy: strategies.variadic
    }),
    getPluralRules: r,
    getListFormat: memoize(function() {
      for (var l = [], d = 0; d < arguments.length; d++)
        l[d] = arguments[d];
      return new (s.bind.apply(s, __spreadArray([void 0], l, !1)))();
    }, {
      cache: createFastMemoizeCache(e.list),
      strategy: strategies.variadic
    }),
    getDisplayNames: memoize(function() {
      for (var l = [], d = 0; d < arguments.length; d++)
        l[d] = arguments[d];
      return new (i.bind.apply(i, __spreadArray([void 0], l, !1)))();
    }, {
      cache: createFastMemoizeCache(e.displayNames),
      strategy: strategies.variadic
    })
  };
}
function getNamedFormat(e, t, s, i) {
  var n = e && e[t], a;
  if (n && (a = n[s]), a)
    return a;
  i(new UnsupportedFormatterError("No ".concat(t, " format named: ").concat(s)));
}
function setTimeZoneInOptions(e, t) {
  return Object.keys(e).reduce(function(s, i) {
    return s[i] = __assign({ timeZone: t }, e[i]), s;
  }, {});
}
function deepMergeOptions(e, t) {
  var s = Object.keys(__assign(__assign({}, e), t));
  return s.reduce(function(i, n) {
    return i[n] = __assign(__assign({}, e[n] || {}), t[n] || {}), i;
  }, {});
}
function deepMergeFormatsAndSetTimeZone(e, t) {
  if (!t)
    return e;
  var s = IntlMessageFormat.formats;
  return __assign(__assign(__assign({}, s), e), { date: deepMergeOptions(setTimeZoneInOptions(s.date, t), setTimeZoneInOptions(e.date || {}, t)), time: deepMergeOptions(setTimeZoneInOptions(s.time, t), setTimeZoneInOptions(e.time || {}, t)) });
}
var formatMessage$1 = function(e, t, s, i, n) {
  var a = e.locale, r = e.formats, l = e.messages, d = e.defaultLocale, u = e.defaultFormats, c = e.fallbackOnEmptyString, m = e.onError, h = e.timeZone, _ = e.defaultRichTextElements;
  s === void 0 && (s = { id: "" });
  var b = s.id, j = s.defaultMessage;
  invariant(!!b, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var I = String(b), E = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    l && Object.prototype.hasOwnProperty.call(l, I) && l[I]
  );
  if (Array.isArray(E) && E.length === 1 && E[0].type === TYPE.literal)
    return E[0].value;
  if (!i && E && typeof E == "string" && !_)
    return E.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (i = __assign(__assign({}, _), i || {}), r = deepMergeFormatsAndSetTimeZone(r, h), u = deepMergeFormatsAndSetTimeZone(u, h), !E) {
    if (c === !1 && E === "")
      return E;
    if ((!j || a && a.toLowerCase() !== d.toLowerCase()) && m(new MissingTranslationError(s, a)), j)
      try {
        var S = t.getMessageFormat(j, d, u, n);
        return S.format(i);
      } catch (y) {
        return m(new MessageFormatError('Error formatting default message for: "'.concat(I, '", rendering default message verbatim'), a, s, y)), typeof j == "string" ? j : I;
      }
    return I;
  }
  try {
    var S = t.getMessageFormat(E, a, r, __assign({ formatters: t }, n || {}));
    return S.format(i);
  } catch (y) {
    m(new MessageFormatError('Error formatting message: "'.concat(I, '", using ').concat(j ? "default message" : "id", " as fallback."), a, s, y));
  }
  if (j)
    try {
      var S = t.getMessageFormat(j, d, u, n);
      return S.format(i);
    } catch (y) {
      m(new MessageFormatError('Error formatting the default message for: "'.concat(I, '", rendering message verbatim'), a, s, y));
    }
  return typeof E == "string" ? E : typeof j == "string" ? j : I;
}, DATE_TIME_FORMAT_OPTIONS = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function getFormatter$2(e, t, s, i) {
  var n = e.locale, a = e.formats, r = e.onError, l = e.timeZone;
  i === void 0 && (i = {});
  var d = i.format, u = __assign(__assign({}, l && { timeZone: l }), d && getNamedFormat(a, t, d, r)), c = filterProps(i, DATE_TIME_FORMAT_OPTIONS, u);
  return t === "time" && !c.hour && !c.minute && !c.second && !c.timeStyle && !c.dateStyle && (c = __assign(__assign({}, c), { hour: "numeric", minute: "numeric" })), s(n, c);
}
function formatDate(e, t) {
  for (var s = [], i = 2; i < arguments.length; i++)
    s[i - 2] = arguments[i];
  var n = s[0], a = s[1], r = a === void 0 ? {} : a, l = typeof n == "string" ? new Date(n || 0) : n;
  try {
    return getFormatter$2(e, "date", t, r).format(l);
  } catch (d) {
    e.onError(new IntlFormatError("Error formatting date.", e.locale, d));
  }
  return String(l);
}
function formatTime(e, t) {
  for (var s = [], i = 2; i < arguments.length; i++)
    s[i - 2] = arguments[i];
  var n = s[0], a = s[1], r = a === void 0 ? {} : a, l = typeof n == "string" ? new Date(n || 0) : n;
  try {
    return getFormatter$2(e, "time", t, r).format(l);
  } catch (d) {
    e.onError(new IntlFormatError("Error formatting time.", e.locale, d));
  }
  return String(l);
}
function formatDateTimeRange(e, t) {
  for (var s = [], i = 2; i < arguments.length; i++)
    s[i - 2] = arguments[i];
  var n = s[0], a = s[1], r = s[2], l = r === void 0 ? {} : r, d = e.timeZone, u = e.locale, c = e.onError, m = filterProps(l, DATE_TIME_FORMAT_OPTIONS, d ? { timeZone: d } : {});
  try {
    return t(u, m).formatRange(n, a);
  } catch (h) {
    c(new IntlFormatError("Error formatting date time range.", e.locale, h));
  }
  return String(n);
}
function formatDateToParts(e, t) {
  for (var s = [], i = 2; i < arguments.length; i++)
    s[i - 2] = arguments[i];
  var n = s[0], a = s[1], r = a === void 0 ? {} : a, l = typeof n == "string" ? new Date(n || 0) : n;
  try {
    return getFormatter$2(e, "date", t, r).formatToParts(l);
  } catch (d) {
    e.onError(new IntlFormatError("Error formatting date.", e.locale, d));
  }
  return [];
}
function formatTimeToParts(e, t) {
  for (var s = [], i = 2; i < arguments.length; i++)
    s[i - 2] = arguments[i];
  var n = s[0], a = s[1], r = a === void 0 ? {} : a, l = typeof n == "string" ? new Date(n || 0) : n;
  try {
    return getFormatter$2(e, "time", t, r).formatToParts(l);
  } catch (d) {
    e.onError(new IntlFormatError("Error formatting time.", e.locale, d));
  }
  return [];
}
var DISPLAY_NAMES_OPTONS = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function formatDisplayName(e, t, s, i) {
  var n = e.locale, a = e.onError, r = Intl.DisplayNames;
  r || a(new FormatError(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, ErrorCode.MISSING_INTL_API));
  var l = filterProps(i, DISPLAY_NAMES_OPTONS);
  try {
    return t(n, l).of(s);
  } catch (d) {
    a(new IntlFormatError("Error formatting display name.", n, d));
  }
}
var LIST_FORMAT_OPTIONS = [
  "type",
  "style"
], now = Date.now();
function generateToken(e) {
  return "".concat(now, "_").concat(e, "_").concat(now);
}
function formatList(e, t, s, i) {
  i === void 0 && (i = {});
  var n = formatListToParts(e, t, s, i).reduce(function(a, r) {
    var l = r.value;
    return typeof l != "string" ? a.push(l) : typeof a[a.length - 1] == "string" ? a[a.length - 1] += l : a.push(l), a;
  }, []);
  return n.length === 1 ? n[0] : n.length === 0 ? "" : n;
}
function formatListToParts(e, t, s, i) {
  var n = e.locale, a = e.onError;
  i === void 0 && (i = {});
  var r = Intl.ListFormat;
  r || a(new FormatError(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, ErrorCode.MISSING_INTL_API));
  var l = filterProps(i, LIST_FORMAT_OPTIONS);
  try {
    var d = {}, u = s.map(function(c, m) {
      if (typeof c == "object") {
        var h = generateToken(m);
        return d[h] = c, h;
      }
      return String(c);
    });
    return t(n, l).formatToParts(u).map(function(c) {
      return c.type === "literal" ? c : __assign(__assign({}, c), { value: d[c.value] || c.value });
    });
  } catch (c) {
    a(new IntlFormatError("Error formatting list.", n, c));
  }
  return s;
}
var PLURAL_FORMAT_OPTIONS = ["type"];
function formatPlural(e, t, s, i) {
  var n = e.locale, a = e.onError;
  i === void 0 && (i = {}), Intl.PluralRules || a(new FormatError(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, ErrorCode.MISSING_INTL_API));
  var r = filterProps(i, PLURAL_FORMAT_OPTIONS);
  try {
    return t(n, r).select(s);
  } catch (l) {
    a(new IntlFormatError("Error formatting plural.", n, l));
  }
  return "other";
}
var RELATIVE_TIME_FORMAT_OPTIONS = ["numeric", "style"];
function getFormatter$1(e, t, s) {
  var i = e.locale, n = e.formats, a = e.onError;
  s === void 0 && (s = {});
  var r = s.format, l = !!r && getNamedFormat(n, "relative", r, a) || {}, d = filterProps(s, RELATIVE_TIME_FORMAT_OPTIONS, l);
  return t(i, d);
}
function formatRelativeTime(e, t, s, i, n) {
  n === void 0 && (n = {}), i || (i = "second");
  var a = Intl.RelativeTimeFormat;
  a || e.onError(new FormatError(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, ErrorCode.MISSING_INTL_API));
  try {
    return getFormatter$1(e, t, n).format(s, i);
  } catch (r) {
    e.onError(new IntlFormatError("Error formatting relative time.", e.locale, r));
  }
  return String(s);
}
var NUMBER_FORMAT_OPTIONS = [
  "style",
  "currency",
  "currencyDisplay",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem"
];
function getFormatter(e, t, s) {
  var i = e.locale, n = e.formats, a = e.onError;
  s === void 0 && (s = {});
  var r = s.format, l = r && getNamedFormat(n, "number", r, a) || {}, d = filterProps(s, NUMBER_FORMAT_OPTIONS, l);
  return t(i, d);
}
function formatNumber(e, t, s, i) {
  i === void 0 && (i = {});
  try {
    return getFormatter(e, t, i).format(s);
  } catch (n) {
    e.onError(new IntlFormatError("Error formatting number.", e.locale, n));
  }
  return String(s);
}
function formatNumberToParts(e, t, s, i) {
  i === void 0 && (i = {});
  try {
    return getFormatter(e, t, i).formatToParts(s);
  } catch (n) {
    e.onError(new IntlFormatError("Error formatting number.", e.locale, n));
  }
  return [];
}
function messagesContainString(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function verifyConfigMessages(e) {
  e.onWarn && e.defaultRichTextElements && messagesContainString(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function createIntl$1(e, t) {
  var s = createFormatters(t), i = __assign(__assign({}, DEFAULT_INTL_CONFIG$1), e), n = i.locale, a = i.defaultLocale, r = i.onError;
  return n ? !Intl.NumberFormat.supportedLocalesOf(n).length && r ? r(new MissingDataError('Missing locale data for locale: "'.concat(n, '" in Intl.NumberFormat. Using default locale: "').concat(a, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(n).length && r && r(new MissingDataError('Missing locale data for locale: "'.concat(n, '" in Intl.DateTimeFormat. Using default locale: "').concat(a, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (r && r(new InvalidConfigError('"locale" was not configured, using "'.concat(a, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), i.locale = i.defaultLocale || "en"), verifyConfigMessages(i), __assign(__assign({}, i), {
    formatters: s,
    formatNumber: formatNumber.bind(null, i, s.getNumberFormat),
    formatNumberToParts: formatNumberToParts.bind(null, i, s.getNumberFormat),
    formatRelativeTime: formatRelativeTime.bind(null, i, s.getRelativeTimeFormat),
    formatDate: formatDate.bind(null, i, s.getDateTimeFormat),
    formatDateToParts: formatDateToParts.bind(null, i, s.getDateTimeFormat),
    formatTime: formatTime.bind(null, i, s.getDateTimeFormat),
    formatDateTimeRange: formatDateTimeRange.bind(null, i, s.getDateTimeFormat),
    formatTimeToParts: formatTimeToParts.bind(null, i, s.getDateTimeFormat),
    formatPlural: formatPlural.bind(null, i, s.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: formatMessage$1.bind(null, i, s),
    // @ts-expect-error TODO: will get to this later
    $t: formatMessage$1.bind(null, i, s),
    formatList: formatList.bind(null, i, s.getListFormat),
    formatListToParts: formatListToParts.bind(null, i, s.getListFormat),
    formatDisplayName: formatDisplayName.bind(null, i, s.getDisplayNames)
  });
}
function invariantIntlContext(e) {
  invariant(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG = __assign(__assign({}, DEFAULT_INTL_CONFIG$1), { textComponent: React.Fragment });
function assignUniqueKeysToParts(e) {
  return function(t) {
    return e(React.Children.toArray(t));
  };
}
function shallowEqual(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var s = Object.keys(e), i = Object.keys(t), n = s.length;
  if (i.length !== n)
    return !1;
  for (var a = 0; a < n; a++) {
    var r = s[a];
    if (e[r] !== t[r] || !Object.prototype.hasOwnProperty.call(t, r))
      return !1;
  }
  return !0;
}
var IntlContext = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = React.createContext(null)) : React.createContext(null), IntlProvider$2 = IntlContext.Provider, Provider = IntlProvider$2, Context = IntlContext;
function useIntl() {
  var e = React.useContext(Context);
  return invariantIntlContext(e), e;
}
function processIntlConfig(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements
  };
}
function assignUniqueKeysToFormatXMLElementFnArgument(e) {
  return e && Object.keys(e).reduce(function(t, s) {
    var i = e[s];
    return t[s] = isFormatXMLElementFn(i) ? assignUniqueKeysToParts(i) : i, t;
  }, {});
}
var formatMessage = function(e, t, s, i) {
  for (var n = [], a = 4; a < arguments.length; a++)
    n[a - 4] = arguments[a];
  var r = assignUniqueKeysToFormatXMLElementFnArgument(i), l = formatMessage$1.apply(void 0, __spreadArray([
    e,
    t,
    s,
    r
  ], n, !1));
  return Array.isArray(l) ? React.Children.toArray(l) : l;
}, createIntl = function(e, t) {
  var s = e.defaultRichTextElements, i = __rest(e, ["defaultRichTextElements"]), n = assignUniqueKeysToFormatXMLElementFnArgument(s), a = createIntl$1(__assign(__assign(__assign({}, DEFAULT_INTL_CONFIG), i), { defaultRichTextElements: n }), t), r = {
    locale: a.locale,
    timeZone: a.timeZone,
    fallbackOnEmptyString: a.fallbackOnEmptyString,
    formats: a.formats,
    defaultLocale: a.defaultLocale,
    defaultFormats: a.defaultFormats,
    messages: a.messages,
    onError: a.onError,
    defaultRichTextElements: n
  };
  return __assign(__assign({}, a), {
    // @ts-expect-error fix this
    formatMessage: formatMessage.bind(null, r, a.formatters),
    // @ts-expect-error fix this
    $t: formatMessage.bind(null, r, a.formatters)
  });
}, IntlProvider$1 = (
  /** @class */
  function(e) {
    __extends(t, e);
    function t() {
      var s = e !== null && e.apply(this, arguments) || this;
      return s.cache = createIntlCache(), s.state = {
        cache: s.cache,
        intl: createIntl(processIntlConfig(s.props), s.cache),
        prevConfig: processIntlConfig(s.props)
      }, s;
    }
    return t.getDerivedStateFromProps = function(s, i) {
      var n = i.prevConfig, a = i.cache, r = processIntlConfig(s);
      return shallowEqual(n, r) ? null : {
        intl: createIntl(r, a),
        prevConfig: r
      };
    }, t.prototype.render = function() {
      return invariantIntlContext(this.state.intl), React.createElement(Provider, { value: this.state.intl }, this.props.children);
    }, t.displayName = "IntlProvider", t.defaultProps = DEFAULT_INTL_CONFIG, t;
  }(React.PureComponent)
);
const OriginalIntlProvider = IntlProvider$1;
function areEqual(e, t) {
  var s = e.values, i = __rest(e, ["values"]), n = t.values, a = __rest(t, ["values"]);
  return shallowEqual(n, s) && shallowEqual(i, a);
}
function FormattedMessage(e) {
  var t = useIntl(), s = t.formatMessage, i = t.textComponent, n = i === void 0 ? React.Fragment : i, a = e.id, r = e.description, l = e.defaultMessage, d = e.values, u = e.children, c = e.tagName, m = c === void 0 ? n : c, h = e.ignoreTag, _ = { id: a, description: r, defaultMessage: l }, b = s(_, d, {
    ignoreTag: h
  });
  return typeof u == "function" ? u(Array.isArray(b) ? b : [b]) : m ? React.createElement(m, null, React.Children.toArray(b)) : React.createElement(React.Fragment, null, b);
}
FormattedMessage.displayName = "FormattedMessage";
var MemoizedFormattedMessage = React.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
const FormattedMessage$1 = MemoizedFormattedMessage;
function isUiNodeAnchorAttributes(e) {
  return e.node_type === "a";
}
function isUiNodeImageAttributes(e) {
  return e.node_type === "img";
}
function isUiNodeInputAttributes(e) {
  return e.node_type === "input";
}
function isUiNodeTextAttributes(e) {
  return e.node_type === "text";
}
function isUiNodeScriptAttributes(e) {
  return e.node_type === "script";
}
const getNodeInputType = (e) => e?.type ?? "", filterNodesByGroups = ({
  nodes: e,
  groups: t,
  withoutDefaultGroup: s,
  attributes: i,
  withoutDefaultAttributes: n,
  excludeAttributes: a
}) => {
  const r = (l) => typeof l == "string" ? l.split(",") : l;
  return e.filter(({ group: l, attributes: d }) => {
    if (!t && !i && !a)
      return !0;
    const u = r(t) || [];
    s || u.push("default");
    const c = r(i) || [];
    n || (l.includes("default") && c.push("hidden"), (l.includes("webauthn") || l.includes("totp")) && c.push("input", "script"));
    const m = r(a) || [], h = t ? u.includes(l) : !0, _ = i ? c.includes(getNodeInputType(d)) : !0, b = a ? !m.includes(getNodeInputType(d)) : !0;
    return h && _ && b;
  });
}, Image = ({ header: e, className: t, ...s }) => /* @__PURE__ */ jsxs("div", { className: cn(t, gridStyle({ gap: 4 })), children: [
  e && /* @__PURE__ */ jsx("div", { className: typographyStyle({ size: "small", type: "regular" }), children: e }),
  /* @__PURE__ */ jsx("img", { ...s })
] }), Typography = ({
  children: e,
  size: t,
  type: s,
  color: i,
  className: n,
  ...a
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      typographyStyle({ size: t, type: s }),
      colorSprinkle({ color: i }),
      n
    ),
    ...a,
    children: e
  }
), getNodeLabel = (e) => {
  const t = e.attributes;
  return isUiNodeAnchorAttributes(t) ? t.title : isUiNodeImageAttributes(t) ? e.meta.label : isUiNodeInputAttributes(t) && t.label ? t.label : e.meta.label;
}, uiTextToFormattedMessage = ({ id: e, context: t = {}, text: s }, i) => {
  const n = Object.entries(t).reduce(
    (a, [r, l]) => Array.isArray(l) ? {
      ...a,
      [r]: l,
      [r + "_list"]: i.formatList(l)
    } : r.endsWith("_unix") && typeof l == "number" ? {
      ...a,
      [r]: i.formatDate(new Date(l * 1e3)),
      [r + "_since"]: i.formatDateTimeRange(
        new Date(l),
        /* @__PURE__ */ new Date()
      ),
      [r + "_since_minutes"]: Math.abs(
        (l - (/* @__PURE__ */ new Date()).getTime() / 1e3) / 60
      ).toFixed(2),
      [r + "_until"]: i.formatDateTimeRange(
        /* @__PURE__ */ new Date(),
        new Date(l)
      ),
      [r + "_until_minutes"]: Math.abs(
        ((/* @__PURE__ */ new Date()).getTime() / 1e3 - l) / 60
      ).toFixed(2)
    } : {
      ...a,
      [r]: l
    },
    {}
  );
  return i.formatMessage(
    {
      id: `identities.messages.${e}`,
      defaultMessage: s
    },
    n
  );
};
function dataAttributes(e) {
  return Object.entries(e).reduce(
    (t, [s, i]) => (s.startsWith("data-") && (t[s] = i), t),
    {}
  );
}
const Node = ({
  node,
  className,
  buttonOverrideProps,
  buttonSocialOverrideProps
}) => {
  const intl = useIntl(), formatMessage = (e) => e ? uiTextToFormattedMessage(e, intl) : "";
  if (isUiNodeImageAttributes(node.attributes))
    return /* @__PURE__ */ jsx(
      Image,
      {
        src: node.attributes.src,
        alt: formatMessage(node.meta.label),
        "data-testid": `node/image/${node.attributes.id}`,
        header: formatMessage(node.meta.label),
        width: node.attributes.width,
        height: node.attributes.height,
        ...dataAttributes(node.attributes)
      }
    );
  if (isUiNodeTextAttributes(node.attributes)) {
    const e = node.attributes.id;
    return node.attributes.text.id === 1050015 ? /* @__PURE__ */ jsxs(
      "div",
      {
        className: gridStyle({ gap: 4, direction: "row" }),
        style: {
          display: "inline-flex",
          flexWrap: "wrap",
          gap: pxToRem(48),
          maxWidth: "fit-content",
          alignItems: "center"
        },
        "data-testid": `node/text/${e}`,
        children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body1",
              "data-testid": `node/text/${node.attributes.id}/label`,
              style: { flexBasis: "100%" },
              children: formatMessage(node.meta.label)
            }
          ),
          node.attributes.text.context.secrets.map((t, s) => /* @__PURE__ */ jsx("pre", { "data-testid": "node/text/lookup_secret_codes/text", children: /* @__PURE__ */ jsx("code", { children: formatMessage(t) }) }, s))
        ]
      }
    ) : /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 4 }), "data-testid": `node/text/${e}`, children: [
      /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "body1",
          "data-testid": `node/text/${node.attributes.id}/label`,
          children: formatMessage(node.meta.label)
        }
      ),
      /* @__PURE__ */ jsx("pre", { "data-testid": `node/text/${e}/text`, children: /* @__PURE__ */ jsx("code", { children: formatMessage(node.attributes.text) }) })
    ] });
  } else if (isUiNodeInputAttributes(node.attributes)) {
    const attrs = node.attributes, nodeType = attrs.type, isSocial = (attrs.name === "provider" || attrs.name === "link") && node.group === "oidc", submit = {
      type: attrs.type,
      name: attrs.name,
      ...attrs.value && { value: attrs.value }
    };
    switch (nodeType) {
      case "button":
      case "submit":
        if (isSocial && (submit.formNoValidate = !0, submit.onClick = (e) => {
          e.currentTarget.type = "submit", e.currentTarget.dispatchEvent(
            new Event("submit", { cancelable: !0, bubbles: !0 })
          );
        }), attrs.onclick) {
          const oc = attrs.onclick;
          submit.onClick = () => {
            eval(oc);
          };
        }
        return (node.meta.label?.id === 1070007 || // TODO: remove this once everyone has migrated to the fix (https://github.com/ory/kratos/pull/3067)
        node.meta.label?.id === 1070008) && (submit.formNoValidate = !0), isSocial ? /* @__PURE__ */ jsx(
          ButtonSocial,
          {
            className,
            header: formatMessage(getNodeLabel(node)),
            brand: attrs.value.toLowerCase(),
            variant: "semibold",
            size: "medium",
            fullWidth: !0,
            disabled: attrs.disabled,
            ...buttonSocialOverrideProps && buttonSocialOverrideProps,
            ...submit,
            ...dataAttributes(attrs)
          }
        ) : /* @__PURE__ */ jsx(
          Button,
          {
            className,
            header: formatMessage(getNodeLabel(node)),
            variant: "semibold",
            size: "medium",
            fullWidth: !0,
            disabled: attrs.disabled,
            ...buttonOverrideProps && buttonOverrideProps,
            ...submit,
            ...dataAttributes(attrs)
          }
        );
      case "datetime-local":
      case "checkbox":
        return /* @__PURE__ */ jsx(
          Checkbox,
          {
            className,
            helperMessage: /* @__PURE__ */ jsx(NodeMessages, { nodes: [node], gap: 4, textPosition: "start" }),
            label: formatMessage(getNodeLabel(node)),
            name: attrs.name,
            required: attrs.required,
            defaultValue: attrs.value,
            disabled: attrs.disabled,
            defaultChecked: !!attrs.value,
            dataTestid: `node/input/${attrs.name}`,
            ...dataAttributes(attrs)
          }
        );
      default:
        return /* @__PURE__ */ jsx(
          InputField,
          {
            helperMessage: /* @__PURE__ */ jsx(NodeMessages, { nodes: [node], gap: 4, textPosition: "start" }),
            dataTestid: `node/input/${attrs.name}`,
            className,
            name: attrs.name,
            header: formatMessage(getNodeLabel(node)),
            type: attrs.type,
            autoComplete: attrs.autocomplete ?? (attrs.name === "identifier" ? "username" : ""),
            defaultValue: attrs.value,
            required: attrs.required,
            disabled: attrs.disabled,
            pattern: attrs.pattern,
            ...dataAttributes(attrs)
          }
        );
    }
  } else if (isUiNodeAnchorAttributes(node.attributes))
    return /* @__PURE__ */ jsx(
      ButtonLink,
      {
        href: node.attributes.href,
        title: formatMessage(node.attributes.title),
        "data-testid": `node/anchor/${node.attributes.id}`,
        className,
        position: "center",
        ...dataAttributes(node.attributes),
        children: formatMessage(node.attributes.title)
      }
    );
  return null;
}, nodeMessage = ({ key: e, message: t, ...s }) => {
  const i = useIntl();
  return /* @__PURE__ */ jsx(
    Message,
    {
      "data-testid": `ui/message/${t.id}`,
      severity: t.type,
      ...s,
      children: uiTextToFormattedMessage(t, i)
    },
    e
  );
}, NodeMessages = ({
  nodes: e,
  uiMessages: t,
  ...s
}) => {
  const { gap: i, direction: n, ...a } = s, r = e?.reduce(
    (u, { messages: c }) => (u.push(
      ...c.map((m, h) => nodeMessage({
        message: m,
        key: `node-group-message-${m.id}-${h}`,
        ...a
      })).filter(Boolean)
    ), u),
    []
  ), l = t?.map(
    (u, c) => nodeMessage({ message: u, key: `ui-messsage-${u.id}-${c}` })
  ), d = [...r ?? [], ...l ?? []];
  return d.length > 0 ? /* @__PURE__ */ jsx(
    "div",
    {
      className: gridStyle({
        gap: i ?? 16,
        direction: n
      }),
      children: d
    }
  ) : null;
}, FilterFlowNodes = ({
  filter: e,
  includeCSRF: t,
  ...s
}) => {
  const i = (a) => isUiNodeInputAttributes(a.attributes) ? a.attributes.name : "", n = filterNodesByGroups(e).filter((a) => t || i(a) !== "csrf_token").map((a, r) => ({
    node: /* @__PURE__ */ jsx(
      Node,
      {
        node: a,
        ...s
      },
      isUiNodeInputAttributes(a.attributes) ? a.attributes.name : isUiNodeImageAttributes(a.attributes) ? a.attributes.src : isUiNodeAnchorAttributes(a.attributes) || isUiNodeTextAttributes(a.attributes) || isUiNodeScriptAttributes(a.attributes) ? a.attributes.id : r
    ),
    hidden: getNodeInputType(a.attributes) === "hidden"
  }));
  return n.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
    n.filter((a) => a.hidden).map((a) => a.node),
    /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: n.filter((a) => !a.hidden).map((a) => a.node) })
  ] }) : null;
}, useScriptNodes = ({ nodes: e }) => {
  useEffect(() => {
    const t = filterNodesByGroups({
      nodes: e,
      groups: "webauthn",
      attributes: "text/javascript",
      withoutDefaultGroup: !0,
      withoutDefaultAttributes: !0
    }).map((s) => {
      const i = s.attributes, n = document.createElement("script");
      return n.setAttribute("data-testid", `node/script/${n.id}`), n.src = i.src, n.type = i.type, n.async = i.async, n.referrerPolicy = i.referrerpolicy, n.crossOrigin = i.crossorigin, n.integrity = i.integrity, document.body.appendChild(n), n;
    });
    return () => {
      t.forEach((s) => {
        document.body.removeChild(s);
      });
    };
  }, [e]);
}, UserAuthForm = ({
  flow: e,
  children: t,
  submitOnEnter: s,
  onSubmit: i,
  formFilterOverride: n,
  className: a,
  ...r
}) => /* @__PURE__ */ jsx(
  "form",
  {
    className: cn(a, formStyle),
    action: e.ui.action,
    method: e.ui.method,
    onKeyDown: (l) => {
      l.key === "Enter" && !s && (l.stopPropagation(), l.preventDefault());
    },
    ...i && {
      onSubmit: (l) => {
        l.preventDefault();
        const d = l.currentTarget, u = new FormData(d);
        let c = Object.fromEntries(u);
        if ("submitter" in l.nativeEvent) {
          const m = l.nativeEvent.submitter;
          c = {
            ...c,
            [m.name]: m.value
          };
        }
        i({ body: c, event: l });
      }
    },
    ...r,
    children: /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        FilterFlowNodes,
        {
          filter: n ?? {
            nodes: e.ui.nodes,
            groups: "default",
            // we only want to map hidden default fields here
            attributes: "hidden"
          },
          includeCSRF: !0
        }
      ),
      t
    ] })
  }
), hasGroup = (e) => (t) => t.some(({ type: s, group: i }) => s === "input" && i === e), hasOidc = hasGroup("oidc"), hasPassword = hasGroup("password"), hasWebauthn = hasGroup("webauthn"), hasPasskey = hasGroup("passkey"), hasLookupSecret = hasGroup("lookup_secret"), hasTotp = hasGroup("totp"), hasCode = hasGroup("code"), hasHiddenIdentifier = (e) => e.some(
  ({ attributes: t }) => "name" in t && t.name === "identifier" && t.type === "hidden"
), LinkSection = ({ nodes: e }) => /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
  /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e,
        groups: ["link", "code"],
        excludeAttributes: "submit"
      }
    }
  ) }),
  /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e,
        groups: ["link", "code"],
        attributes: "submit"
      }
    }
  )
] }), LoginSection = ({
  nodes: e,
  forgotPasswordURL: t
}) => hasPassword(e) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
  /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 16 }), children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e,
          groups: ["default", "password"],
          excludeAttributes: ["submit", "hidden"]
        }
      }
    ),
    t && /* @__PURE__ */ jsx(
      ButtonLink,
      {
        "data-testid": "forgot-password-link",
        href: t,
        children: /* @__PURE__ */ jsx(
          FormattedMessage$1,
          {
            id: "login.forgot-password",
            defaultMessage: "Forgot password?"
          }
        )
      }
    )
  ] }),
  /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e,
        groups: ["password"],
        attributes: "submit"
      }
    }
  )
] }) : null, LookupSecretSettingsSection = ({
  flow: e
}) => {
  const t = {
    nodes: e.ui.nodes,
    groups: "lookup_secret",
    withoutDefaultGroup: !0
  };
  return hasLookupSecret(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, excludeAttributes: "submit,button" }
      }
    ),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, attributes: "submit,button" },
        buttonOverrideProps: { fullWidth: !1 }
      }
    )
  ] }) : null;
}, OIDCSection = (e) => {
  const t = filterNodesByGroups({
    nodes: e.ui.nodes,
    groups: "oidc",
    withoutDefaultGroup: !0,
    excludeAttributes: "submit"
  }).length > 0;
  return hasOidc(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    t && /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e.ui.nodes,
          groups: "oidc",
          withoutDefaultGroup: !0,
          excludeAttributes: "submit"
        }
      }
    ) }),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e.ui.nodes,
          groups: "oidc",
          attributes: "submit"
        }
      }
    )
  ] }) : null;
}, OIDCSettingsSection = ({
  flow: e
}) => {
  const t = {
    nodes: e.ui.nodes,
    groups: "oidc",
    withoutDefaultGroup: !0
  };
  return hasOidc(e.ui.nodes) ? /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 32 }), children: /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: t,
      buttonOverrideProps: { fullWidth: !1 }
    }
  ) }) : null;
}, PasswordSettingsSection = ({
  flow: e
}) => {
  const t = {
    nodes: e.ui.nodes,
    groups: "password",
    withoutDefaultGroup: !0
  };
  return hasPassword(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, excludeAttributes: "submit,button" }
      }
    ),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, attributes: "submit,button" },
        buttonOverrideProps: { fullWidth: !1 }
      }
    )
  ] }) : null;
}, PasswordlessSection = (e) => hasWebauthn(e.ui.nodes) || hasPasskey(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
  /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e.ui.nodes,
        // we will also map default fields here but not oidc and password fields
        groups: ["webauthn", "passkey"],
        withoutDefaultAttributes: !0,
        excludeAttributes: ["hidden", "button", "submit"]
        // the form will take care of hidden fields
      }
    }
  ) }),
  /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e.ui.nodes,
        groups: ["webauthn", "passkey"],
        withoutDefaultAttributes: !0,
        attributes: ["button", "submit"]
      }
    }
  )
] }) : null, PasswordlessLoginSection = (e) => hasPasskey(e.ui.nodes) ? /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 32 }), children: /* @__PURE__ */ jsx(
  FilterFlowNodes,
  {
    filter: {
      nodes: e.ui.nodes,
      groups: ["webauthn", "passkey"],
      withoutDefaultAttributes: !0,
      attributes: ["button", "submit"]
    }
  }
) }) : hasWebauthn(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
  /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e.ui.nodes,
        // we will also map default fields here but not oidc and password fields
        groups: ["webauthn"],
        withoutDefaultAttributes: !0,
        excludeAttributes: ["hidden", "button", "submit"]
        // the form will take care of hidden fields
      }
    }
  ) }),
  /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e.ui.nodes,
        groups: ["webauthn"],
        withoutDefaultAttributes: !0,
        attributes: ["button", "submit"]
      }
    }
  )
] }) : null, ProfileSettingsSection = ({
  flow: e
}) => {
  const t = { nodes: e.ui.nodes, groups: "profile" };
  return /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, excludeAttributes: "submit,button" }
      }
    ),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, attributes: "submit,button" },
        buttonOverrideProps: { fullWidth: !1 }
      }
    )
  ] });
}, RegistrationSection = ({
  nodes: e
}) => hasPassword(e) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
  /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e,
        groups: ["password"],
        excludeAttributes: "submit"
      }
    }
  ) }),
  /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e,
        groups: ["password"],
        attributes: "submit"
      }
    }
  )
] }) : null, TOTPSettingsSection = ({
  flow: e
}) => {
  const t = {
    nodes: e.ui.nodes,
    groups: "totp",
    withoutDefaultGroup: !0
  };
  return hasTotp(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, excludeAttributes: "submit,button" }
      }
    ),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, attributes: "submit,button" },
        buttonOverrideProps: { fullWidth: !1 }
      }
    )
  ] }) : null;
}, WebAuthnSettingsSection = ({
  flow: e
}) => {
  const t = {
    nodes: e.ui.nodes,
    groups: "webauthn",
    withoutDefaultGroup: !0
  };
  return hasWebauthn(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, excludeAttributes: "submit,button" }
      }
    ),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, attributes: "submit,button" },
        buttonOverrideProps: { fullWidth: !1 }
      }
    )
  ] }) : null;
}, PasskeySettingsSection = ({
  flow: e
}) => {
  const t = {
    nodes: e.ui.nodes,
    groups: ["passkey", "webauthn"],
    withoutDefaultGroup: !0
  };
  return hasPasskey(e.ui.nodes) ? /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, attributes: "submit,button" },
        buttonOverrideProps: { fullWidth: !1 }
      }
    ),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: { ...t, excludeAttributes: "submit,button" }
      }
    )
  ] }) : null;
}, AuthCodeSection = ({
  nodes: e
}) => hasCode(e) ? /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(
    FilterFlowNodes,
    {
      filter: {
        nodes: e,
        groups: ["code"],
        // we don't want to map the default group twice
        // the form already maps hidden fields under the default group
        // we are only interested in hidden fields that are under the code group
        withoutDefaultGroup: !0,
        withoutDefaultAttributes: !0,
        attributes: ["hidden"]
      }
    }
  ),
  /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
    /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e,
          groups: "code",
          withoutDefaultAttributes: !0,
          excludeAttributes: ["hidden", "button", "submit"]
          // the form will take care of default (csrf) hidden fields
        }
      }
    ) }),
    /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e,
          groups: "code",
          withoutDefaultAttributes: !0,
          attributes: ["button", "submit"]
        }
      }
    )
  ] })
] }) : null, identifier_css_ts_vanilla = "";
var identifierNameStyle = "ory_elements__identifier__kdu3q91", identifierStyle = "ory_elements__identifier__kdu3q90";
const LoggedInInfo = ({ flow: e }) => {
  const t = e.ui.nodes.find(
    (s) => "name" in s.attributes && s.attributes.name === "identifier"
  )?.attributes;
  return !t || !("value" in t) ? null : /* @__PURE__ */ jsxs("div", { className: identifierStyle, children: [
    /* @__PURE__ */ jsx(
      FormattedMessage$1,
      {
        id: "login.logged-in-as-label",
        defaultMessage: "You're logged in as:"
      }
    ),
    /* @__PURE__ */ jsx("div", { className: identifierNameStyle, children: t.value })
  ] });
}, UserAuthCard = ({
  flow: e,
  title: t,
  subtitle: s,
  flowType: i,
  additionalProps: n,
  cardImage: a,
  onSubmit: r,
  includeScripts: l,
  className: d
}) => {
  const u = useIntl();
  if (l && useScriptNodes({ nodes: e.ui.nodes }), !t)
    switch (i) {
      case "login":
        e.refresh ? t = u.formatMessage({
          id: "login.title-refresh",
          defaultMessage: "Confirm it's you"
        }) : e.requested_aal === "aal2" ? t = u.formatMessage({
          id: "login.title-aal2",
          defaultMessage: "Two-Factor Authentication"
        }) : t = u.formatMessage({
          id: "login.title",
          defaultMessage: "Sign in"
        });
        break;
      case "registration":
        t = u.formatMessage({
          id: "registration.title",
          defaultMessage: "Register an account"
        });
        break;
      case "recovery":
        t = u.formatMessage({
          id: "recovery.title",
          defaultMessage: "Recover your account"
        });
        break;
      case "verification":
        t = u.formatMessage({
          id: "verification.title",
          defaultMessage: "Verify your account"
        });
        break;
    }
  if (!s)
    switch (i) {
      case "login":
        e.oauth2_login_request && (s = u.formatMessage(
          {
            id: "login.subtitle-oauth2",
            defaultMessage: "To authenticate {clientName}"
          },
          {
            clientName: e.oauth2_login_request.client?.client_name ?? e.oauth2_login_request.client?.client_uri
          }
        ));
        break;
      case "registration":
        e.oauth2_login_request && (s = u.formatMessage(
          {
            id: "registration.subtitle-oauth2",
            defaultMessage: "To authenticate {clientName}"
          },
          {
            clientName: e.oauth2_login_request.client?.client_name ?? e.oauth2_login_request.client?.client_uri
          }
        ));
        break;
    }
  let c = null, m = null, h = null, _ = null, b = null;
  const j = (A) => A.requested_aal === "aal2" ? !0 : !!A.refresh, I = () => !!_ && (!j(e) || i === "registration"), E = () => i === "login" && j(e) && (hasTotp(e.ui.nodes) || hasWebauthn(e.ui.nodes) || hasPasskey(e.ui.nodes) || hasLookupSecret(e.ui.nodes)), S = hasHiddenIdentifier(e.ui.nodes), y = () => E() && [
    hasWebauthn(e.ui.nodes) && /* @__PURE__ */ jsx(UserAuthForm, { flow: e, "data-testid": "webauthn-flow", children: /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e.ui.nodes,
          groups: "webauthn",
          withoutDefaultGroup: !0
        }
      }
    ) }),
    hasPasskey(e.ui.nodes) && /* @__PURE__ */ jsx(UserAuthForm, { flow: e, "data-testid": "passkey-flow", children: /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e.ui.nodes,
          groups: ["passkey", "webauthn"],
          withoutDefaultGroup: !0
        }
      }
    ) }),
    hasPassword(e.ui.nodes) && /* @__PURE__ */ jsx(UserAuthForm, { flow: e, "data-testid": "password-flow", children: /* @__PURE__ */ jsx(
      FilterFlowNodes,
      {
        filter: {
          nodes: e.ui.nodes,
          groups: "password",
          withoutDefaultGroup: !0
        }
      }
    ) }),
    hasTotp(e.ui.nodes) && /* @__PURE__ */ jsx(
      UserAuthForm,
      {
        flow: e,
        "data-testid": "totp-flow",
        onSubmit: r,
        submitOnEnter: !0,
        children: /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
          /* @__PURE__ */ jsx(
            FilterFlowNodes,
            {
              filter: {
                nodes: e.ui.nodes,
                groups: "totp",
                withoutDefaultGroup: !0,
                excludeAttributes: "submit"
              }
            }
          ),
          /* @__PURE__ */ jsx(
            FilterFlowNodes,
            {
              filter: {
                nodes: e.ui.nodes,
                groups: "totp",
                withoutDefaultGroup: !0,
                attributes: "submit"
              }
            }
          )
        ] })
      }
    ),
    hasLookupSecret(e.ui.nodes) && /* @__PURE__ */ jsx(
      UserAuthForm,
      {
        flow: e,
        "data-testid": "lookup-secret-flow",
        onSubmit: r,
        submitOnEnter: !0,
        children: /* @__PURE__ */ jsx(
          FilterFlowNodes,
          {
            filter: {
              nodes: e.ui.nodes,
              groups: "lookup_secret",
              withoutDefaultGroup: !0
            }
          }
        )
      }
    )
  ].filter(Boolean).map((A, f) => /* @__PURE__ */ jsx("div", { children: f > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Divider, {}),
    " ",
    A
  ] }) : A }, f));
  switch (i) {
    case "login":
      _ = PasswordlessLoginSection(e), m = OIDCSection(e), h = AuthCodeSection({ nodes: e.ui.nodes }), c = LoginSection({
        nodes: e.ui.nodes,
        ...n
      }), j(e) && n?.logoutURL ? b = {
        text: u.formatMessage({
          id: "login.logout-label",
          defaultMessage: "Something's not working?"
        }),
        buttonText: u.formatMessage({
          id: "login.logout-button",
          defaultMessage: "Logout"
        }),
        dataTestId: "logout-link",
        url: n.logoutURL
      } : n?.signupURL && (b = {
        text: u.formatMessage({
          id: "login.registration-label",
          defaultMessage: "Don't have an account?"
        }),
        buttonText: u.formatMessage({
          id: "login.registration-button",
          defaultMessage: "Sign up"
        }),
        url: n.signupURL,
        dataTestId: "signup-link"
      });
      break;
    case "registration":
      _ = PasswordlessSection(e), m = OIDCSection(e), h = AuthCodeSection({ nodes: e.ui.nodes }), c = RegistrationSection({
        nodes: e.ui.nodes
      }), n?.loginURL && (b = {
        text: u.formatMessage({
          id: "registration.login-label",
          defaultMessage: "Already have an account?"
        }),
        url: n.loginURL,
        buttonText: u.formatMessage({
          id: "registration.login-button",
          defaultMessage: "Sign in"
        }),
        dataTestId: "cta-link"
      });
      break;
    case "recovery":
      c = LinkSection({
        nodes: e.ui.nodes
      }), n?.loginURL && (b = {
        text: u.formatMessage({
          id: "recovery.login-label",
          defaultMessage: "Remember your credentials?"
        }),
        buttonText: u.formatMessage({
          id: "recovery.login-button",
          defaultMessage: "Sign in"
        }),
        url: n.loginURL,
        dataTestId: "cta-link"
      });
      break;
    case "verification":
      c = LinkSection({
        nodes: e.ui.nodes
      }), n?.signupURL && (b = {
        text: u.formatMessage({
          id: "verification.registration-label",
          defaultMessage: "Don't have an account?"
        }),
        buttonText: u.formatMessage({
          id: "verification.registration-button",
          defaultMessage: "Sign up"
        }),
        url: n.signupURL,
        dataTestId: "cta-link"
      });
      break;
    default:
      c = null;
  }
  return /* @__PURE__ */ jsx(
    Card,
    {
      className: d,
      heading: /* @__PURE__ */ jsx("h2", { className: typographyStyle({ type: "regular", size: "small" }), children: t }),
      image: a,
      "data-testid": `${i}-auth-card`,
      children: /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
        s && /* @__PURE__ */ jsx(Message, { severity: "default", children: s }),
        /* @__PURE__ */ jsx(NodeMessages, { uiMessages: e.ui.messages }),
        m && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(UserAuthForm, { flow: e, "data-testid": `${i}-flow-oidc`, children: m })
        ] }),
        h && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(UserAuthForm, { flow: e, "data-testid": `${i}-flow-code`, children: h })
        ] }),
        c && !E() && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsxs(
            UserAuthForm,
            {
              flow: e,
              submitOnEnter: !0,
              onSubmit: r,
              "data-testid": `${i}-flow`,
              children: [
                c,
                S && /* @__PURE__ */ jsx(LoggedInInfo, { flow: e })
              ]
            }
          )
        ] }),
        E() && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            NodeMessages,
            {
              nodes: filterNodesByGroups({
                nodes: e.ui.nodes,
                groups: [
                  "password",
                  "webauthn",
                  "passkey",
                  "totp",
                  "lookup_secret"
                ]
              })
            }
          ),
          y(),
          S && /* @__PURE__ */ jsx(LoggedInInfo, { flow: e })
        ] }),
        I() && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(
            UserAuthForm,
            {
              flow: e,
              submitOnEnter: !0,
              onSubmit: r,
              "data-testid": "passwordless-flow",
              formFilterOverride: {
                nodes: e.ui.nodes,
                attributes: "hidden"
              },
              children: _
            }
          )
        ] }),
        b && MessageSection(b)
      ] })
    }
  );
}, UserErrorCard = ({
  title: e,
  error: t,
  backUrl: s,
  cardImage: i,
  contactSupportEmail: n,
  className: a
}) => {
  const r = useIntl(), l = t.error, d = l.code, u = d >= 500;
  if (!e)
    switch (d) {
      case 404:
        e = r.formatMessage({
          id: "error.title-not-found",
          defaultMessage: "404 - Page not found"
        });
        break;
      case 500:
        e = r.formatMessage({
          id: "error.title-internal-server-error",
          defaultMessage: "Internal Server Error"
        });
        break;
      default:
        e = r.formatMessage({
          id: "error.title",
          defaultMessage: "An error occurred"
        });
    }
  return /* @__PURE__ */ jsx(
    Card,
    {
      className: a,
      heading: /* @__PURE__ */ jsx("h2", { className: typographyStyle({ type: "regular", size: "small" }), children: e }),
      image: i,
      size: "wide",
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: gridStyle({ gap: 32, direction: "column" }),
          "data-testid": "ui/error/message",
          children: [
            !u && /* @__PURE__ */ jsxs(Message, { severity: "error", children: [
              /* @__PURE__ */ jsx(
                FormattedMessage$1,
                {
                  id: "error.description",
                  defaultMessage: "An error occurred with the following message:"
                }
              ),
              " ",
              l.reason
            ] }),
            /* @__PURE__ */ jsx(CodeBox, { "data-testid": "code-box", toggleText: "Error details", children: JSON.stringify(t, null, 2) }),
            n && /* @__PURE__ */ jsx(Message, { className: colorSprinkle({ color: "foregroundMuted" }), children: /* @__PURE__ */ jsx(
              FormattedMessage$1,
              {
                id: "error.support-email-link",
                description: "A label and link below the error. The link href is 'mailto:{contactSupportEmail}'.",
                defaultMessage: "If the problem persists, please contact <a>{contactSupportEmail}</a>",
                values: {
                  contactSupportEmail: n,
                  a: (c) => /* @__PURE__ */ jsxs(ButtonLink, { href: `mailto:${n}`, children: [
                    " ",
                    c
                  ] })
                }
              }
            ) }),
            /* @__PURE__ */ jsx(Message, { children: /* @__PURE__ */ jsx(ButtonLink, { href: s, children: /* @__PURE__ */ jsx(FormattedMessage$1, { id: "error.back-button", defaultMessage: "Go Back" }) }) })
          ]
        }
      )
    }
  );
}, UserSettingsCard = ({
  flow: e,
  method: t,
  title: s,
  includeScripts: i,
  onSubmit: n,
  className: a,
  dividerClassName: r
}) => {
  const l = useIntl();
  i && useScriptNodes({ nodes: e.ui.nodes });
  let d = !1, u = null, c = "";
  switch (t) {
    case "profile":
      d = !0, c = s ?? l.formatMessage({
        id: "settings.title-profile",
        defaultMessage: "Profile Settings"
      }), u = /* @__PURE__ */ jsx(ProfileSettingsSection, { flow: e });
      break;
    case "password":
      hasPassword(e.ui.nodes) && (d = !0, c = s ?? l.formatMessage({
        id: "settings.title-password",
        defaultMessage: "Change Password"
      }), u = /* @__PURE__ */ jsx(PasswordSettingsSection, { flow: e }));
      break;
    case "webauthn":
      hasWebauthn(e.ui.nodes) && (d = !0, c = s ?? l.formatMessage({
        id: "settings.title-webauthn",
        defaultMessage: "Manage Hardware Tokens"
      }), u = /* @__PURE__ */ jsx(WebAuthnSettingsSection, { flow: e }));
      break;
    case "passkey":
      hasPasskey(e.ui.nodes) && (d = !0, c = s ?? l.formatMessage({
        id: "settings.title-passkey",
        defaultMessage: "Manage Passkeys"
      }), u = /* @__PURE__ */ jsx(PasskeySettingsSection, { flow: e }));
      break;
    case "lookup_secret":
      hasLookupSecret(e.ui.nodes) && (d = !0, c = s ?? l.formatMessage({
        id: "settings.title-lookup-secret",
        defaultMessage: "Manage 2FA Backup Recovery Codes"
      }), u = /* @__PURE__ */ jsx(LookupSecretSettingsSection, { flow: e }));
      break;
    case "oidc":
      hasOidc(e.ui.nodes) && (d = !0, c = s ?? l.formatMessage({
        id: "settings.title-oidc",
        defaultMessage: "Social Sign In"
      }), u = /* @__PURE__ */ jsx(OIDCSettingsSection, { flow: e }));
      break;
    case "totp":
      hasTotp(e.ui.nodes) && (d = !0, c = s ?? l.formatMessage({
        id: "settings.title-totp",
        defaultMessage: "Manage 2FA TOTP Authenticator App"
      }), u = /* @__PURE__ */ jsx(TOTPSettingsSection, { flow: e }));
      break;
    default:
      u = null;
  }
  return d ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 32 }), children: [
      c && /* @__PURE__ */ jsx(
        "h3",
        {
          className: cn(
            typographyStyle({ size: "headline26", type: "regular" }),
            colorSprinkle({ color: "foregroundDefault" })
          ),
          children: c
        }
      ),
      /* @__PURE__ */ jsx(
        UserAuthForm,
        {
          flow: e,
          onSubmit: n,
          className: a,
          "data-testid": `${t}-settings-card`,
          children: u
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Divider, { fullWidth: !1, className: r })
  ] }) : null;
}, UserConsentCard = ({
  csrfToken: e,
  consent: t,
  cardImage: s,
  client_name: i = "Unnamed Client",
  requested_scope: n = [],
  client: a,
  action: r,
  className: l
}) => {
  const d = useIntl();
  return /* @__PURE__ */ jsx(
    Card,
    {
      className: l,
      heading: /* @__PURE__ */ jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsx(Typography, { type: "bold", children: i }) }),
      image: s,
      children: /* @__PURE__ */ jsxs("form", { action: r, method: "post", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "_csrf", value: e }),
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "hidden",
            name: "consent_challenge",
            value: t?.challenge
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 16 }), children: [
          /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 4 }), style: { marginBottom: 16 }, children: /* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(
            FormattedMessage$1,
            {
              id: "consent.requested-permissions-label",
              defaultMessage: "The application requests access to the following permissions:"
            }
          ) }) }),
          /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 4 }), children: n.map((u) => /* @__PURE__ */ jsx(
            Checkbox,
            {
              label: u,
              value: u,
              name: "grant_scope"
            },
            u
          )) }),
          /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 4 }), children: /* @__PURE__ */ jsx(Typography, { size: "xsmall", children: /* @__PURE__ */ jsx(
            FormattedMessage$1,
            {
              id: "consent.description",
              defaultMessage: "Only grant permissions if you trust this site or app. You do not need to accept all permissions."
            }
          ) }) }),
          /* @__PURE__ */ jsxs("div", { className: gridStyle({ direction: "row" }), children: [
            a?.policy_uri && /* @__PURE__ */ jsx("a", { href: a.policy_uri, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx(Typography, { size: "xsmall", children: /* @__PURE__ */ jsx(
              FormattedMessage$1,
              {
                id: "consent.privacy-policy-label",
                defaultMessage: "Privacy Policy"
              }
            ) }) }),
            a?.tos_uri && /* @__PURE__ */ jsx("a", { href: a.tos_uri, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx(Typography, { size: "xsmall", children: /* @__PURE__ */ jsx(
              FormattedMessage$1,
              {
                id: "consent.terms-of-service-label",
                defaultMessage: "Terms of Service"
              }
            ) }) })
          ] }),
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsxs("div", { className: gridStyle({ gap: 8 }), children: [
            /* @__PURE__ */ jsx(
              Checkbox,
              {
                label: d.formatMessage({
                  id: "consent.remember-tooltip",
                  defaultMessage: "remember my decision"
                }),
                id: "remember",
                name: "remember"
              }
            ),
            /* @__PURE__ */ jsx(Typography, { size: "xsmall", children: /* @__PURE__ */ jsx(
              FormattedMessage$1,
              {
                id: "consent.remember-label",
                defaultMessage: "Remember this decision for next time. The application will not be able to ask for additional permissions without your consent."
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: gridStyle({ direction: "row" }),
              style: { justifyContent: "space-between", alignItems: "center" },
              children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "submit",
                    id: "reject",
                    name: "consent_action",
                    value: "reject",
                    variant: "error",
                    header: d.formatMessage({
                      id: "consent.action-reject",
                      defaultMessage: "Deny"
                    })
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "submit",
                    id: "accept",
                    name: "consent_action",
                    value: "accept",
                    variant: "semibold",
                    header: d.formatMessage({
                      id: "consent.action-accept",
                      defaultMessage: "Allow"
                    })
                  }
                )
              ]
            }
          )
        ] })
      ] })
    }
  );
}, UserLogoutCard = ({
  csrfToken: e,
  challenge: t,
  action: s,
  className: i,
  cardImage: n
}) => {
  const a = useIntl();
  return /* @__PURE__ */ jsx(
    Card,
    {
      className: i,
      heading: /* @__PURE__ */ jsx("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(
        FormattedMessage$1,
        {
          id: "logout.title",
          defaultMessage: "Do you wish to log out?"
        }
      ) }) }),
      image: n,
      children: /* @__PURE__ */ jsxs("form", { action: s, method: "post", children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "_csrf", value: e }),
        /* @__PURE__ */ jsx("input", { type: "hidden", name: "challenge", value: t }),
        /* @__PURE__ */ jsx("div", { className: gridStyle({ gap: 16 }), children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: gridStyle({ direction: "row" }),
            style: { justifyContent: "space-between", alignItems: "center" },
            children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: "submit",
                  id: "reject",
                  value: "No",
                  name: "submit",
                  variant: "error",
                  header: a.formatMessage({
                    id: "logout.reject-button",
                    defaultMessage: "No"
                  })
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: "submit",
                  id: "accept",
                  value: "Yes",
                  name: "submit",
                  variant: "semibold",
                  header: a.formatMessage({
                    id: "logout.accept-button",
                    defaultMessage: "Yes"
                  })
                }
              )
            ]
          }
        ) })
      ] })
    }
  );
}, SettingScreenNavigation = ({
  navClassName: e,
  flow: t,
  logoutUrl: s,
  backUrl: i
}) => {
  const n = useIntl();
  return /* @__PURE__ */ jsx(
    Nav,
    {
      className: e,
      navTitle: n.formatMessage({
        id: "settings.title-navigation",
        defaultMessage: "Account Settings"
      }),
      navSections: [
        ...i ? [
          {
            links: [
              {
                name: n.formatMessage({
                  id: "settings.navigation-back-button",
                  defaultMessage: "Back"
                }),
                href: i,
                iconLeft: "arrow-left",
                testId: "profile"
              }
            ]
          }
        ] : [],
        {
          links: [
            {
              name: n.formatMessage({
                id: "settings.navigation-profile",
                defaultMessage: "Profile"
              }),
              href: "#profile",
              iconLeft: "user",
              testId: "profile"
            },
            hasPassword(t.ui.nodes) && {
              name: n.formatMessage({
                id: "settings.navigation-password",
                defaultMessage: "Password"
              }),
              href: "#password",
              iconLeft: "lock",
              testId: "password"
            },
            hasOidc(t.ui.nodes) && {
              name: n.formatMessage({
                id: "settings.navigation-oidc",
                defaultMessage: "Social Sign In"
              }),
              href: "#oidc",
              iconLeft: "comments",
              testId: "oidc"
            },
            hasLookupSecret(t.ui.nodes) && {
              name: n.formatMessage({
                id: "settings.navigation-backup-codes",
                defaultMessage: "2FA Backup Codes"
              }),
              href: "#lookup_secret",
              iconLeft: "shield",
              testId: "backup-codes"
            },
            hasWebauthn(t.ui.nodes) && {
              name: n.formatMessage({
                id: "settings.navigation-webauthn",
                defaultMessage: "Hardware Tokens"
              }),
              href: "#webauthn",
              iconLeft: "key",
              testId: "webauthn"
            },
            hasPasskey(t.ui.nodes) && {
              name: n.formatMessage({
                id: "settings.navigation-passkey",
                defaultMessage: "Passkeys"
              }),
              href: "#passkey",
              iconLeft: "fingerprint",
              testId: "passkey"
            },
            hasTotp(t.ui.nodes) && {
              name: n.formatMessage({
                id: "settings.navigation-totp",
                defaultMessage: "Authenticator App"
              }),
              href: "#totp",
              iconLeft: "mobile",
              testId: "totp"
            }
          ].filter(Boolean)
        },
        {
          links: [
            {
              name: n.formatMessage({
                id: "settings.navigation-logout",
                defaultMessage: "Logout"
              }),
              href: s,
              iconLeft: "arrow-right-to-bracket",
              testId: "logout"
            }
          ]
        }
      ]
    }
  );
}, settingsScreenMethods = [
  "profile",
  "password",
  "oidc",
  "lookup_secret",
  "webauthn",
  "passkey",
  "totp"
], SettingsScreenBody = ({
  headerContainerClassName: e,
  dividerClassName: t,
  settingsCardContainerClassName: s,
  flow: i
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsxs("div", { className: e, children: [
    /* @__PURE__ */ jsx(Typography, { size: "headline37", color: "foregroundDefault", children: /* @__PURE__ */ jsx(
      FormattedMessage$1,
      {
        id: "settings.title",
        defaultMessage: "Account Settings"
      }
    ) }),
    /* @__PURE__ */ jsx(Typography, { color: "foregroundMuted", size: "small", children: /* @__PURE__ */ jsx(
      FormattedMessage$1,
      {
        id: "settings.subtitle-instructions",
        defaultMessage: "Here you can manage settings related to your account. Keep in mind that certain actions require you to re-authenticate."
      }
    ) }),
    /* @__PURE__ */ jsx(NodeMessages, { uiMessages: i.ui.messages, textPosition: "start" }),
    /* @__PURE__ */ jsx(Divider, { fullWidth: !1, className: t })
  ] }),
  settingsScreenMethods.map((n) => /* @__PURE__ */ jsx(
    "div",
    {
      className: s,
      id: n,
      children: /* @__PURE__ */ jsx(UserSettingsCard, { method: n, flow: i })
    },
    n
  ))
] }), UserSettingsScreen = {
  Nav: SettingScreenNavigation,
  Body: SettingsScreenBody
};
function getVarName(e) {
  var t = e.match(/^var\((.*)\)$/);
  return t ? t[1] : e;
}
function get(e, t) {
  var s = e;
  for (var i of t) {
    if (!(i in s))
      throw new Error("Path ".concat(t.join(" -> "), " does not exist in object"));
    s = s[i];
  }
  return s;
}
function walkObject(e, t) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], i = e.constructor();
  for (var n in e) {
    var a = e[n], r = [...s, n];
    typeof a == "string" || typeof a == "number" || a == null ? i[n] = t(a, r) : typeof a == "object" && !Array.isArray(a) ? i[n] = walkObject(a, t, r) : console.warn('Skipping invalid key "'.concat(r.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(a) ? "Array" : typeof a, '"'));
  }
  return i;
}
function assignInlineVars(e, t) {
  var s = {};
  if (typeof t == "object") {
    var i = e;
    walkObject(t, (r, l) => {
      var d = get(i, l);
      s[getVarName(d)] = String(r);
    });
  } else {
    var n = e;
    for (var a in n)
      s[getVarName(a)] = n[a];
  }
  return Object.defineProperty(s, "toString", {
    value: function() {
      return Object.keys(this).map((l) => "".concat(l, ":").concat(this[l])).join(";");
    },
    writable: !1
  }), s;
}
const themeProvider_css_ts_vanilla = "";
var themeProviderFontRenderingStyle = "ory_elements__theme_provider__m6lo4u1", themeProviderStyle = "ory_elements__theme_provider__m6lo4u0";
const en = {
  "consent.action-accept": "Allow",
  "consent.action-reject": "Deny",
  "consent.description": "Only grant permissions if you trust this site or app. You do not need to accept all permissions.",
  "consent.privacy-policy-label": "Privacy Policy",
  "consent.remember-label": "Remember this decision for next time. The application will not be able to ask for additional permissions without your consent.",
  "consent.remember-tooltip": "remember my decision",
  "consent.requested-permissions-label": "The application requests access to the following permissions:",
  "consent.terms-of-service-label": "Terms of Service",
  "error.back-button": "Go Back",
  "error.description": "An error occurred with the following message:",
  "error.support-email-link": "If the problem persists, please contact <a>{contactSupportEmail}</a>",
  "error.title": "An error occurred",
  "error.title-internal-server-error": "Internal Server Error",
  "error.title-not-found": "404 - Page not found",
  "identities.messages.1010001": "Sign in",
  "identities.messages.1010002": "Sign in with {provider}",
  "identities.messages.1010003": "Please confirm this action by verifying that it is you.",
  "identities.messages.1010004": "Please complete the second authentication challenge.",
  "identities.messages.1010005": "Verify",
  "identities.messages.1010006": "Authentication code",
  "identities.messages.1010007": "Backup recovery code",
  "identities.messages.1010008": "Use security key",
  "identities.messages.1010009": "Use Authenticator",
  "identities.messages.1010010": "Use backup recovery code",
  "identities.messages.1010011": "Continue with security key",
  "identities.messages.1010012": "Prepare your WebAuthn device (e.g. security key, biometrics scanner, ...) and press continue.",
  "identities.messages.1010013": "Continue",
  "identities.messages.1010014": "An email containing a code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and retry the login.",
  "identities.messages.1010015": "Sign in with code",
  "identities.messages.1040001": "Sign up",
  "identities.messages.1040002": "Sign up with {provider}",
  "identities.messages.1040003": "Continue",
  "identities.messages.1040004": "Sign up with security key",
  "identities.messages.1040005": "An email containing a code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and retry the registration.",
  "identities.messages.1040006": "Sign up with code",
  "identities.messages.1050001": "Your changes have been saved!",
  "identities.messages.1050002": "Link {provider}",
  "identities.messages.1050003": "Unlink {provider}",
  "identities.messages.1050004": "Unlink TOTP Authenticator App",
  "identities.messages.1050005": "Authenticator app QR code",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Reveal backup recovery codes",
  "identities.messages.1050008": "Generate new backup recovery codes",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "These are your back up recovery codes. Please keep them in a safe place!",
  "identities.messages.1050011": "Confirm backup recovery codes",
  "identities.messages.1050012": "Add security key",
  "identities.messages.1050013": "Name of the security key",
  "identities.messages.1050014": "<del>Used</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Disable this method",
  "identities.messages.1050017": "This is your authenticator app secret. Use it if you can not scan the QR code.",
  "identities.messages.1050018": 'Remove security key "{display_name}"',
  "identities.messages.1060001": "You successfully recovered your account. Please change your password or set up an alternative login method (e.g. social sign in) within the next {privileged_session_expires_at_unix_until_minutes} minutes.",
  "identities.messages.1060002": "An email containing a recovery link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.1060003": "An email containing a recovery code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.1070001": "Password",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Save",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Submit",
  "identities.messages.1070006": "Verify code",
  "identities.messages.1070007": "Email",
  "identities.messages.1070008": "Resend code",
  "identities.messages.1070009": "Continue",
  "identities.messages.1070010": "Recovery code",
  "identities.messages.1070011": "Verification code",
  "identities.messages.1070012": "Registration code",
  "identities.messages.1070013": "Login code",
  "identities.messages.1080001": "An email containing a verification link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.1080002": "You successfully verified your email address.",
  "identities.messages.1080003": "An email containing a verification code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Property {property} is missing.",
  "identities.messages.4000003": "length must be >= {min_length}, but got {actual_length}",
  "identities.messages.4000004": 'does not match pattern "{pattern}"',
  "identities.messages.4000005": "The password can not be used because {reason}.",
  "identities.messages.4000006": "The provided credentials are invalid, check for spelling mistakes in your password or username, email address, or phone number.",
  "identities.messages.4000007": "An account with the same identifier (email, phone, username, ...) exists already.",
  "identities.messages.4000008": "The provided authentication code is invalid, please try again.",
  "identities.messages.4000009": "Could not find any login identifiers. Did you forget to set them? This could also be caused by a server misconfiguration.",
  "identities.messages.4000010": "Account not active yet. Did you forget to verify your email address?",
  "identities.messages.4000011": "You have no TOTP device set up.",
  "identities.messages.4000012": "This backup recovery code has already been used.",
  "identities.messages.4000013": "You have no WebAuthn device set up.",
  "identities.messages.4000014": "You have no backup recovery codes set up.",
  "identities.messages.4000015": "This account does not exist or has no security key set up.",
  "identities.messages.4000016": "The backup recovery code is not valid.",
  "identities.messages.4000017": "length must be <= {max_length}, but got {actual_length}",
  "identities.messages.4000018": "must be >= {minimum} but found {actual}",
  "identities.messages.4000019": "must be > {minimum} but found {actual}",
  "identities.messages.4000020": "must be <= {maximum} but found {actual}",
  "identities.messages.4000021": "must be < {maximum} but found {actual}",
  "identities.messages.4000022": "{actual} not multipleOf {base}",
  "identities.messages.4000023": "maximum {max_items} items allowed, but found {actual_items} items",
  "identities.messages.4000024": "minimum {min_items} items allowed, but found {actual_items} items",
  "identities.messages.4000025": "items at index {index_a} and {index_b} are equal",
  "identities.messages.4000026": "expected {allowed_types_list}, but got {actual_type}",
  "identities.messages.4000027": "An account with the same identifier (email, phone, username, ...) exists already. Please sign in to your existing account and link your social profile in the settings page.",
  "identities.messages.4000028": "You tried signing in with {credential_identifier_hint} which is already in use by another account. You can sign in using {available_credential_types_list}. You can sign in using one of the following social sign in providers: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "must be equal to constant {expected}",
  "identities.messages.4000030": "const failed",
  "identities.messages.4000031": "The password can not be used because it is too similar to the identifier.",
  "identities.messages.4000032": "The password must be at least {min_length} characters long, but got {actual_length}.",
  "identities.messages.4000033": "The password must be at most {max_length} characters long, but got {actual_length}.",
  "identities.messages.4000034": "The password has been found in data breaches and must no longer be used.",
  "identities.messages.4000035": "This account does not exist or has not setup sign in with code.",
  "identities.messages.4000036": "The provided traits do not match the traits previously associated with this flow.",
  "identities.messages.4010001": "The login flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4010002": "Could not find a strategy to log you in with. Did you fill out the form correctly?",
  "identities.messages.4010003": "Could not find a strategy to sign you up with. Did you fill out the form correctly?",
  "identities.messages.4010004": "Could not find a strategy to update your settings. Did you fill out the form correctly?",
  "identities.messages.4010005": "Could not find a strategy to recover your account with. Did you fill out the form correctly?",
  "identities.messages.4010006": "Could not find a strategy to verify your account with. Did you fill out the form correctly?",
  "identities.messages.4010007": "The request was already completed successfully and can not be retried.",
  "identities.messages.4010008": "The login code is invalid or has already been used. Please try again.",
  "identities.messages.4040001": "The registration flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4040002": "The request was already completed successfully and can not be retried.",
  "identities.messages.4040003": "The registration code is invalid or has already been used. Please try again.",
  "identities.messages.4050001": "The settings flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4060001": "The request was already completed successfully and can not be retried.",
  "identities.messages.4060002": "The recovery flow reached a failure state and must be retried.",
  "identities.messages.4060004": "The recovery token is invalid or has already been used. Please retry the flow.",
  "identities.messages.4060005": "The recovery flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4060006": "The recovery code is invalid or has already been used. Please try again.",
  "identities.messages.4070001": "The verification token is invalid or has already been used. Please retry the flow.",
  "identities.messages.4070002": "The request was already completed successfully and can not be retried.",
  "identities.messages.4070003": "The verification flow reached a failure state and must be retried.",
  "identities.messages.4070005": "The verification flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4070006": "The verification code is invalid or has already been used. Please try again.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Forgot password?",
  "login.logged-in-as-label": "You're logged in as:",
  "login.logout-button": "Logout",
  "login.logout-label": "Something's not working?",
  "login.registration-button": "Sign up",
  "login.registration-label": "Don't have an account?",
  "login.subtitle-oauth2": "To authenticate {clientName}",
  "login.title": "Sign in",
  "login.title-aal2": "Two-Factor Authentication",
  "login.title-refresh": "Confirm it's you",
  "logout.accept-button": "Yes",
  "logout.reject-button": "No",
  "logout.title": "Do you wish to log out?",
  "recovery.login-button": "Sign in",
  "recovery.login-label": "Remember your credentials?",
  "recovery.title": "Recover your account",
  "registration.login-button": "Sign in",
  "registration.login-label": "Already have an account?",
  "registration.subtitle-oauth2": "To authenticate {clientName}",
  "registration.title": "Register an account",
  "settings.navigation-back-button": "Back",
  "settings.navigation-backup-codes": "2FA Backup Codes",
  "settings.navigation-logout": "Logout",
  "settings.navigation-oidc": "Social Sign In",
  "settings.navigation-password": "Password",
  "settings.navigation-profile": "Profile",
  "settings.navigation-totp": "Authenticator App",
  "settings.navigation-webauthn": "Hardware Tokens",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Here you can manage settings related to your account. Keep in mind that certain actions require you to re-authenticate.",
  "settings.title": "Account Settings",
  "settings.title-lookup-secret": "Manage 2FA Backup Recovery Codes",
  "settings.title-navigation": "Account Settings",
  "settings.title-oidc": "Social Sign In",
  "settings.title-password": "Change Password",
  "settings.title-profile": "Profile Settings",
  "settings.title-totp": "Manage 2FA TOTP Authenticator App",
  "settings.title-webauthn": "Manage Hardware Tokens",
  "settings.title-passkey": "Manage Passkeys",
  "verification.registration-button": "Sign up",
  "verification.registration-label": "Don't have an account?",
  "verification.title": "Verify your account"
}, es = {
  "consent.action-accept": "Permitir",
  "consent.action-reject": "Rechazar",
  "consent.description": "Solo otorgue permisos si confía en este sitio o aplicación. No es necesario aceptar todos los permisos.",
  "consent.privacy-policy-label": "Política de Privacidad",
  "consent.remember-label": "Recuerde esta decisión para la próxima vez. La aplicación no podrá solicitar permisos adicionales sin su consentimiento.",
  "consent.remember-tooltip": "recordar mi decisión",
  "consent.requested-permissions-label": "La aplicación solicita acceso a los siguientes permisos:",
  "consent.terms-of-service-label": "Términos de Servicio",
  "error.back-button": "Regresar",
  "error.description": "Ocurrió un error con el siguiente mensaje:",
  "error.support-email-link": "Si el problema persiste, por favor contacte a <a>{contactSupportEmail}</a>",
  "error.title": "Ocurrió un error",
  "error.title-internal-server-error": "Error Interno del Servidor",
  "error.title-not-found": "404 - Página no encontrada",
  "identities.messages.1010001": "Iniciar sesión",
  "identities.messages.1010002": "Iniciar sesión con {provider}",
  "identities.messages.1010003": "Por favor confirme esta acción verificando que es usted.",
  "identities.messages.1010004": "Por favor complete el segundo desafío de autenticación.",
  "identities.messages.1010005": "Verificar",
  "identities.messages.1010006": "Código de autenticación",
  "identities.messages.1010007": "Código de recuperación de respaldo",
  "identities.messages.1010008": "Usar llave de seguridad",
  "identities.messages.1010009": "Usar Autenticador",
  "identities.messages.1010010": "Usar código de recuperación de respaldo",
  "identities.messages.1010011": "Continuar con llave de seguridad",
  "identities.messages.1010012": "Prepare su dispositivo WebAuthn (por ejemplo, llave de seguridad, escáner biométrico, ...) y presione continuar.",
  "identities.messages.1010013": "Continuar",
  "identities.messages.1010014": "Se ha enviado un correo electrónico con un código a la dirección de correo electrónico que proporcionó. Si no ha recibido un correo electrónico, verifique la ortografía de la dirección e intente iniciar sesión nuevamente.",
  "identities.messages.1010015": "Iniciar sesión con código",
  "identities.messages.1040001": "Registrarse",
  "identities.messages.1040002": "Registrarse con {provider}",
  "identities.messages.1040003": "Continuar",
  "identities.messages.1040004": "Registrarse con llave de seguridad",
  "identities.messages.1040005": "Se ha enviado un correo electrónico con un código a la dirección de correo electrónico que proporcionó. Si no ha recibido un correo electrónico, verifique la ortografía de la dirección e intente registrarse nuevamente.",
  "identities.messages.1040006": "Registrarse con código",
  "identities.messages.1050001": "¡Sus cambios han sido guardados!",
  "identities.messages.1050002": "Vincular {provider}",
  "identities.messages.1050003": "Desvincular {provider}",
  "identities.messages.1050004": "Desvincular App Autenticadora TOTP",
  "identities.messages.1050005": "Código QR de la app autenticadora",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Mostrar códigos de recuperación de respaldo",
  "identities.messages.1050008": "Generar nuevos códigos de recuperación de respaldo",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Estos son sus códigos de recuperación de respaldo. ¡Por favor guárdelos en un lugar seguro!",
  "identities.messages.1050011": "Confirmar códigos de recuperación de respaldo",
  "identities.messages.1050012": "Agregar llave de seguridad",
  "identities.messages.1050013": "Nombre de la llave de seguridad",
  "identities.messages.1050014": "<del>Usado</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Deshabilitar este método",
  "identities.messages.1050017": "Este es el secreto de su app autenticadora. Úselo si no puede escanear el código QR.",
  "identities.messages.1050018": 'Eliminar llave de seguridad "{display_name}"',
  "identities.messages.1060001": "Ha recuperado exitosamente su cuenta. Por favor cambie su contraseña o configure un método de inicio de sesión alternativo (por ejemplo, inicio de sesión social) en los próximos {privileged_session_expires_at_unix_until_minutes} minutos.",
  "identities.messages.1060002": "Se ha enviado un correo electrónico con un enlace de recuperación a la dirección de correo electrónico que proporcionó. Si no ha recibido un correo electrónico, verifique la ortografía de la dirección y asegúrese de usar la dirección con la que se registró.",
  "identities.messages.1060003": "Se ha enviado un correo electrónico con un código de recuperación a la dirección de correo electrónico que proporcionó. Si no ha recibido un correo electrónico, verifique la ortografía de la dirección y asegúrese de usar la dirección con la que se registró.",
  "identities.messages.1070001": "Contraseña",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Guardar",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Enviar",
  "identities.messages.1070006": "Verificar código",
  "identities.messages.1070007": "Correo electrónico",
  "identities.messages.1070008": "Reenviar código",
  "identities.messages.1070009": "Continuar",
  "identities.messages.1070010": "Código de recuperación",
  "identities.messages.1070011": "Código de verificación",
  "identities.messages.1070012": "Código de registro",
  "identities.messages.1070013": "Código de inicio de sesión",
  "identities.messages.1080001": "Se ha enviado un correo electrónico con un enlace de verificación a la dirección que proporcionó. Si no ha recibido un correo electrónico, verifique la ortografía de la dirección y asegúrese de usar la dirección con la que se registró.",
  "identities.messages.1080002": "Ha verificado exitosamente su dirección de correo electrónico.",
  "identities.messages.1080003": "Se ha enviado un correo electrónico con un código de verificación a la dirección que proporcionó. Si no ha recibido un correo electrónico, verifique la ortografía de la dirección y asegúrese de usar la dirección con la que se registró.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Falta la propiedad {property}.",
  "identities.messages.4000003": "la longitud debe ser >= {min_length}, pero es {actual_length}",
  "identities.messages.4000004": 'no coincide con el patrón "{pattern}"',
  "identities.messages.4000005": "La contraseña no puede ser utilizada porque {reason}.",
  "identities.messages.4000006": "Las credenciales proporcionadas son inválidas, verifique si hay errores en su contraseña o nombre de usuario, dirección de correo electrónico o número de teléfono.",
  "identities.messages.4000007": "Ya existe una cuenta con el mismo identificador (correo, teléfono, nombre de usuario, ...).",
  "identities.messages.4000008": "El código de autenticación proporcionado es inválido, por favor intente nuevamente.",
  "identities.messages.4000009": "No se encontraron identificadores de inicio de sesión. ¿Olvidó establecerlos? Esto también podría ser causado por una mala configuración del servidor.",
  "identities.messages.4000010": "La cuenta aún no está activa. ¿Olvidó verificar su dirección de correo electrónico?",
  "identities.messages.4000011": "No tiene configurado ningún dispositivo TOTP.",
  "identities.messages.4000012": "Este código de recuperación de respaldo ya ha sido utilizado.",
  "identities.messages.4000013": "No tiene configurado ningún dispositivo WebAuthn.",
  "identities.messages.4000014": "No ha configurado ningún código de recuperación de respaldo.",
  "identities.messages.4000015": "Esta cuenta no existe o no tiene configurada una llave de seguridad.",
  "identities.messages.4000016": "El código de recuperación de respaldo no es válido.",
  "identities.messages.4000017": "la longitud debe ser <= {max_length}, pero es {actual_length}",
  "identities.messages.4000018": "debe ser >= {minimum} pero es {actual}",
  "identities.messages.4000019": "debe ser > {minimum} pero es {actual}",
  "identities.messages.4000020": "debe ser <= {maximum} pero es {actual}",
  "identities.messages.4000021": "debe ser < {maximum} pero es {actual}",
  "identities.messages.4000022": "{actual} no es múltiplo de {base}",
  "identities.messages.4000023": "máximo {max_items} ítems permitidos, pero se encontraron {actual_items} ítems",
  "identities.messages.4000024": "mínimo {min_items} ítems permitidos, pero se encontraron {actual_items} ítems",
  "identities.messages.4000025": "los ítems en los índices {index_a} y {index_b} son iguales",
  "identities.messages.4000026": "se esperaba {allowed_types_list}, pero se obtuvo {actual_type}",
  "identities.messages.4000027": "Ya existe una cuenta con el mismo identificador (correo, teléfono, nombre de usuario, ...). Por favor, inicie sesión en su cuenta existente y vincule su perfil social en la página de configuración.",
  "identities.messages.4000028": "Intentó iniciar sesión con {credential_identifier_hint} que ya está en uso por otra cuenta. Puede iniciar sesión usando {available_credential_types_list}. Puede iniciar sesión usando uno de los siguientes proveedores de inicio de sesión social: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "debe ser igual a la constante {expected}",
  "identities.messages.4000030": "constante fallida",
  "identities.messages.4000031": "La contraseña no puede ser utilizada porque es muy similar al identificador.",
  "identities.messages.4000032": "La contraseña debe tener al menos {min_length} caracteres de longitud, pero tiene {actual_length}.",
  "identities.messages.4000033": "La contraseña debe tener como máximo {max_length} caracteres de longitud, pero tiene {actual_length}.",
  "identities.messages.4000034": "La contraseña ha sido encontrada en brechas de datos y ya no debe ser utilizada.",
  "identities.messages.4000035": "Esta cuenta no existe o no tiene configurado el inicio de sesión con código.",
  "identities.messages.4000036": "Las características proporcionadas no coinciden con las características previamente asociadas con este flujo.",
  "identities.messages.4010001": "El flujo de inicio de sesión expiró hace {expired_at_unix_since_minutes} minutos, por favor intente nuevamente.",
  "identities.messages.4010002": "No se pudo encontrar una estrategia para iniciar sesión. ¿Llenó correctamente el formulario?",
  "identities.messages.4010003": "No se pudo encontrar una estrategia para registrarse. ¿Llenó correctamente el formulario?",
  "identities.messages.4010004": "No se pudo encontrar una estrategia para actualizar sus configuraciones. ¿Llenó correctamente el formulario?",
  "identities.messages.4010005": "No se pudo encontrar una estrategia para recuperar su cuenta. ¿Llenó correctamente el formulario?",
  "identities.messages.4010006": "No se pudo encontrar una estrategia para verificar su cuenta. ¿Llenó correctamente el formulario?",
  "identities.messages.4010007": "La solicitud ya fue completada exitosamente y no puede ser reintentada.",
  "identities.messages.4010008": "El código de inicio de sesión es inválido o ya ha sido utilizado. Por favor, intente nuevamente.",
  "identities.messages.4040001": "El flujo de registro expiró hace {expired_at_unix_since_minutes} minutos, por favor intente nuevamente.",
  "identities.messages.4040002": "La solicitud ya fue completada exitosamente y no puede ser reintentada.",
  "identities.messages.4040003": "El código de registro es inválido o ya ha sido utilizado. Por favor, intente nuevamente.",
  "identities.messages.4050001": "El flujo de configuración expiró hace {expired_at_unix_since_minutes} minutos, por favor intente nuevamente.",
  "identities.messages.4060001": "La solicitud ya fue completada exitosamente y no puede ser reintentada.",
  "identities.messages.4060002": "El flujo de recuperación alcanzó un estado de fallo y debe ser reintentado.",
  "identities.messages.4060004": "El token de recuperación es inválido o ya ha sido utilizado. Por favor, reinicie el flujo.",
  "identities.messages.4060005": "El flujo de recuperación expiró hace {expired_at_unix_since_minutes} minutos, por favor intente nuevamente.",
  "identities.messages.4060006": "El código de recuperación es inválido o ya ha sido utilizado. Por favor, intente nuevamente.",
  "identities.messages.4070001": "El token de verificación es inválido o ya ha sido utilizado. Por favor, reinicie el flujo.",
  "identities.messages.4070002": "La solicitud ya fue completada exitosamente y no puede ser reintentada.",
  "identities.messages.4070003": "El flujo de verificación alcanzó un estado de fallo y debe ser reintentado.",
  "identities.messages.4070005": "El flujo de verificación expiró hace {expired_at_unix_since_minutes} minutos, por favor intente nuevamente.",
  "identities.messages.4070006": "El código de verificación es inválido o ya ha sido utilizado. Por favor, intente nuevamente.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "¿Olvidó su contraseña?",
  "login.logged-in-as-label": "Ha iniciado sesión como:",
  "login.logout-button": "Cerrar sesión",
  "login.logout-label": "¿Algo no funciona correctamente?",
  "login.registration-button": "Registrarse",
  "login.registration-label": "¿No tiene una cuenta?",
  "login.subtitle-oauth2": "Para autenticar a {clientName}",
  "login.title": "Iniciar sesión",
  "login.title-aal2": "Autenticación de Dos Factores",
  "login.title-refresh": "Confirme que es usted",
  "logout.accept-button": "Sí",
  "logout.reject-button": "No",
  "logout.title": "¿Desea cerrar sesión?",
  "recovery.login-button": "Iniciar sesión",
  "recovery.login-label": "¿Recuerda sus credenciales?",
  "recovery.title": "Recuperar su cuenta",
  "registration.login-button": "Iniciar sesión",
  "registration.login-label": "¿Ya tiene una cuenta?",
  "registration.subtitle-oauth2": "Para autenticar a {clientName}",
  "registration.title": "Registrar una cuenta",
  "settings.navigation-back-button": "Regresar",
  "settings.navigation-backup-codes": "Códigos de Respaldo de 2FA",
  "settings.navigation-logout": "Cerrar sesión",
  "settings.navigation-oidc": "Inicio de Sesión Social",
  "settings.navigation-password": "Contraseña",
  "settings.navigation-profile": "Perfil",
  "settings.navigation-totp": "Aplicación Autenticadora",
  "settings.navigation-webauthn": "Tokens de Hardware",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Aquí puede gestionar las configuraciones relacionadas con su cuenta. Tenga en cuenta que ciertas acciones requieren que vuelva a autenticarse.",
  "settings.title": "Configuraciones de la Cuenta",
  "settings.title-lookup-secret": "Gestionar Códigos de Recuperación de Respaldo de 2FA",
  "settings.title-navigation": "Configuraciones de la Cuenta",
  "settings.title-oidc": "Inicio de Sesión Social",
  "settings.title-password": "Cambiar Contraseña",
  "settings.title-profile": "Configuraciones del Perfil",
  "settings.title-totp": "Gestionar Aplicación Autenticadora de 2FA",
  "settings.title-webauthn": "Gestionar Tokens de Hardware",
  "settings.title-passkey": "Gestionar Passkeys",
  "verification.registration-button": "Registrarse",
  "verification.registration-label": "¿No tiene una cuenta?",
  "verification.title": "Verificar su cuenta"
}, de = {
  "consent.action-accept": "Zustimmen",
  "consent.action-reject": "Ablehnen",
  "consent.description": "Geben Sie nur Berechtigungen frei, wenn Sie dieser Website oder App vertrauen. Sie müssen nicht alle Berechtigungen akzeptieren.",
  "consent.privacy-policy-label": "Datenschutzrichtlinie",
  "consent.remember-label": "Diese Entscheidung für das nächste Mal merken. Die Anwendung wird keine zusätzlichen Berechtigungen ohne Ihre Zustimmung anfordern können.",
  "consent.remember-tooltip": "meine Entscheidung merken",
  "consent.requested-permissions-label": "Die Anwendung benötigt Zugriff auf folgende Berechtigungen:",
  "consent.terms-of-service-label": "Nutzungsbedingungen",
  "error.back-button": "Zurück",
  "error.description": "Es ist ein Fehler aufgetreten mit folgender Nachricht:",
  "error.support-email-link": "Wenn das Problem bestehen bleibt, kontaktieren Sie bitte <a>{contactSupportEmail}</a>",
  "error.title": "Ein Fehler ist aufgetreten",
  "error.title-internal-server-error": "Interner Serverfehler",
  "error.title-not-found": "404 - Seite nicht gefunden",
  "identities.messages.1010001": "Anmelden",
  "identities.messages.1010002": "Mit {provider} anmelden",
  "identities.messages.1010003": "Bitte bestätigen Sie diese Aktion, indem Sie überprüfen, dass Sie es sind.",
  "identities.messages.1010004": "Bitte schließen Sie die zweite Authentifizierungsprüfung ab.",
  "identities.messages.1010005": "Verifizieren",
  "identities.messages.1010006": "Authentifizierungscode",
  "identities.messages.1010007": "Backup-Wiederherstellungscode",
  "identities.messages.1010008": "Sicherheitsschlüssel verwenden",
  "identities.messages.1010009": "Authentifizierungs-App verwenden",
  "identities.messages.1010010": "Backup-Wiederherstellungscode verwenden",
  "identities.messages.1010011": "Mit Sicherheitsschlüssel fortfahren",
  "identities.messages.1010012": "Bereiten Sie Ihr WebAuthn-Gerät vor (z. B. Sicherheitsschlüssel, biometrischer Scanner, ...) und drücken Sie auf Weiter.",
  "identities.messages.1010013": "Weiter",
  "identities.messages.1010014": "Eine E-Mail mit einem Code wurde an die von Ihnen angegebene E-Mail-Adresse gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte die Schreibweise der Adresse und versuchen Sie erneut, sich anzumelden.",
  "identities.messages.1010015": "Mit Code anmelden",
  "identities.messages.1040001": "Registrieren",
  "identities.messages.1040002": "Mit {provider} registrieren",
  "identities.messages.1040003": "Fortfahren",
  "identities.messages.1040004": "Mit Sicherheitsschlüssel registrieren",
  "identities.messages.1040005": "Eine E-Mail mit einem Code wurde an die von Ihnen angegebene E-Mail-Adresse gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte die Schreibweise der Adresse und versuchen Sie erneut, sich zu registrieren.",
  "identities.messages.1040006": "Mit Code registrieren",
  "identities.messages.1050001": "Ihre Änderungen wurden gespeichert!",
  "identities.messages.1050002": "{provider} verknüpfen",
  "identities.messages.1050003": "{provider} entknüpfen",
  "identities.messages.1050004": "Authentifizierungs-App entknüpfen",
  "identities.messages.1050005": "Authentifizierungs-App QR-Code",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Backup-Wiederherstellungscode anzeigen",
  "identities.messages.1050008": "Neue Backup-Wiederherstellungscode generieren",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Dies sind Ihre Backup-Wiederherstellungscode. Bewahren Sie sie an einem sicheren Ort auf!",
  "identities.messages.1050011": "Backup-Wiederherstellungscode bestätigen",
  "identities.messages.1050012": "Sicherheitsschlüssel hinzufügen",
  "identities.messages.1050013": "Name des Sicherheitsschlüssels",
  "identities.messages.1050014": "<del>Verwendet</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Diese Methode deaktivieren",
  "identities.messages.1050017": "Dies ist Ihr Authentifizierungs-App-Geheimnis. Verwenden Sie es, wenn Sie den QR-Code nicht scannen können.",
  "identities.messages.1050018": 'Sicherheitsschlüssel "{display_name}" entfernen',
  "identities.messages.1060001": "Sie haben Ihr Konto erfolgreich wiederhergestellt. Bitte ändern Sie Ihr Passwort oder richten Sie eine alternative Anmeldemethode ein (z. B. Anmeldung über soziale Medien) innerhalb der nächsten {privileged_session_expires_at_unix_until_minutes} Minuten ein.",
  "identities.messages.1060002": "Eine E-Mail mit einem Wiederherstellungslink wurde an die von Ihnen angegebene E-Mail-Adresse gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte die Schreibweise der Adresse und stellen Sie sicher, dass Sie die Adresse verwendet haben, mit der Sie sich registriert haben.",
  "identities.messages.1060003": "Eine E-Mail mit einem Wiederherstellungscode wurde an die von Ihnen angegebene E-Mail-Adresse gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte die Schreibweise der Adresse und stellen Sie sicher, dass Sie die Adresse verwendet haben, mit der Sie sich registriert haben.",
  "identities.messages.1070001": "Passwort",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Speichern",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Absenden",
  "identities.messages.1070006": "Verifizierungscode",
  "identities.messages.1070007": "E-Mail",
  "identities.messages.1070008": "Code erneut senden",
  "identities.messages.1070009": "Weiter",
  "identities.messages.1070010": "Wiederherstellungscode",
  "identities.messages.1070011": "Verifikationscode",
  "identities.messages.1070012": "Registrierungscode",
  "identities.messages.1070013": "Anmeldecode",
  "identities.messages.1080001": "Eine E-Mail mit einem Bestätigungslink wurde an die von Ihnen angegebene E-Mail-Adresse gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte die Schreibweise der Adresse und stellen Sie sicher, dass Sie die Adresse verwendet haben, mit der Sie sich registriert haben.",
  "identities.messages.1080002": "Sie haben Ihre E-Mail-Adresse erfolgreich bestätigt.",
  "identities.messages.1080003": "Eine E-Mail mit einem Bestätigungscode wurde an die von Ihnen angegebene E-Mail-Adresse gesendet. Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte die Schreibweise der Adresse und stellen Sie sicher, dass Sie die Adresse verwendet haben, mit der Sie sich registriert haben.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Eigenschaft {property} fehlt.",
  "identities.messages.4000003": "Die Länge muss >= {min_length} sein, wurde jedoch {actual_length} erhalten.",
  "identities.messages.4000004": 'entspricht nicht dem Muster "{pattern}"',
  "identities.messages.4000005": "Das Passwort kann nicht verwendet werden, weil {reason}.",
  "identities.messages.4000006": "Die bereitgestellten Anmeldedaten sind ungültig. Überprüfen Sie auf Rechtschreibfehler in Ihrem Passwort, Benutzernamen, E-Mail-Adresse oder Telefonnummer.",
  "identities.messages.4000007": "Ein Konto mit demselben Identifikator (E-Mail, Telefon, Benutzername, ...) existiert bereits.",
  "identities.messages.4000008": "Der bereitgestellte Authentifizierungscode ist ungültig. Bitte versuchen Sie es erneut.",
  "identities.messages.4000009": "Es konnten keine Anmeldeidentifikatoren gefunden werden. Haben Sie vergessen, diese festzulegen? Dies könnte auch durch eine Serverfehlkonfiguration verursacht werden.",
  "identities.messages.4000010": "Konto ist noch nicht aktiv. Haben Sie vergessen, Ihre E-Mail-Adresse zu bestätigen?",
  "identities.messages.4000011": "Sie haben kein TOTP-Gerät eingerichtet.",
  "identities.messages.4000012": "Dieser Backup-Wiederherstellungscode wurde bereits verwendet.",
  "identities.messages.4000013": "Sie haben kein WebAuthn-Gerät eingerichtet.",
  "identities.messages.4000014": "Sie haben keine Backup-Wiederherstellungscode eingerichtet.",
  "identities.messages.4000015": "Dieses Konto existiert nicht oder hat keinen Sicherheitsschlüssel eingerichtet.",
  "identities.messages.4000016": "Der Backup-Wiederherstellungscode ist ungültig.",
  "identities.messages.4000017": "Die Länge muss <= {max_length} sein, wurde jedoch {actual_length} erhalten.",
  "identities.messages.4000018": "muss >= {minimum} sein, wurde jedoch {actual} gefunden.",
  "identities.messages.4000019": "muss > {minimum} sein, wurde jedoch {actual} gefunden.",
  "identities.messages.4000020": "muss <= {maximum} sein, wurde jedoch {actual} gefunden.",
  "identities.messages.4000021": "muss < {maximum} sein, wurde jedoch {actual} gefunden.",
  "identities.messages.4000022": "{actual} ist nicht ein Vielfaches von {base}",
  "identities.messages.4000023": "maximal {max_items} Elemente erlaubt, wurden jedoch {actual_items} Elemente gefunden.",
  "identities.messages.4000024": "mindestens {min_items} Elemente erforderlich, wurden jedoch {actual_items} Elemente gefunden.",
  "identities.messages.4000025": "Elemente an Index {index_a} und {index_b} sind gleich.",
  "identities.messages.4000026": "erwartete {allowed_types_list}, wurden jedoch {actual_type} gefunden.",
  "identities.messages.4000027": "Ein Konto mit demselben Identifikator (E-Mail, Telefon, Benutzername, ...) existiert bereits. Bitte melden Sie sich in Ihrem bestehenden Konto an und verknüpfen Sie Ihr soziales Profil auf der Einstellungsseite.",
  "identities.messages.4000028": "Sie haben versucht, sich mit {credential_identifier_hint} anzumelden, das bereits von einem anderen Konto verwendet wird. Sie können sich mit {available_credential_types_list} anmelden. Sie können sich mit einem der folgenden sozialen Anmeldeanbieter anmelden: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "muss gleich der Konstanten {expected} sein.",
  "identities.messages.4000030": "const fehlgeschlagen",
  "identities.messages.4000031": "Das Passwort kann nicht verwendet werden, da es zu ähnlich dem Identifikator ist.",
  "identities.messages.4000032": "Das Passwort muss mindestens {min_length} Zeichen lang sein, wurde jedoch {actual_length} erhalten.",
  "identities.messages.4000033": "Das Passwort muss höchstens {max_length} Zeichen lang sein, wurde jedoch {actual_length} erhalten.",
  "identities.messages.4000034": "Das Passwort wurde in Datenlecks gefunden und darf nicht mehr verwendet werden.",
  "identities.messages.4000035": "Dieses Konto existiert nicht oder hat keine Anmeldung per Code eingerichtet.",
  "identities.messages.4000036": "Die bereitgestellten Merkmale stimmen nicht mit den zuvor mit diesem Flow assoziierten Merkmalen überein.",
  "identities.messages.4010001": "Der Anmeldevorgang ist vor {expired_at_unix_since_minutes} Minuten abgelaufen. Bitte versuchen Sie es erneut.",
  "identities.messages.4010002": "Es konnte keine Strategie gefunden werden, um Sie anzumelden. Haben Sie das Formular korrekt ausgefüllt?",
  "identities.messages.4010003": "Es konnte keine Strategie gefunden werden, um Sie zu registrieren. Haben Sie das Formular korrekt ausgefüllt?",
  "identities.messages.4010004": "Es konnte keine Strategie gefunden werden, um Ihre Einstellungen zu aktualisieren. Haben Sie das Formular korrekt ausgefüllt?",
  "identities.messages.4010005": "Es konnte keine Strategie gefunden werden, um Ihr Konto wiederherzustellen. Haben Sie das Formular korrekt ausgefüllt?",
  "identities.messages.4010006": "Es konnte keine Strategie gefunden werden, um Ihr Konto zu verifizieren. Haben Sie das Formular korrekt ausgefüllt?",
  "identities.messages.4010007": "Die Anfrage wurde bereits erfolgreich abgeschlossen und kann nicht erneut versucht werden.",
  "identities.messages.4010008": "Der Anmeldecode ist ungültig oder wurde bereits verwendet. Bitte versuchen Sie es erneut.",
  "identities.messages.4040001": "Der Registrierungsvorgang ist vor {expired_at_unix_since_minutes} Minuten abgelaufen. Bitte versuchen Sie es erneut.",
  "identities.messages.4040002": "Die Anfrage wurde bereits erfolgreich abgeschlossen und kann nicht erneut versucht werden.",
  "identities.messages.4040003": "Der Registrierungscode ist ungültig oder wurde bereits verwendet. Bitte versuchen Sie es erneut.",
  "identities.messages.4050001": "Der Einstellungsvorgang ist vor {expired_at_unix_since_minutes} Minuten abgelaufen. Bitte versuchen Sie es erneut.",
  "identities.messages.4060001": "Die Anfrage wurde bereits erfolgreich abgeschlossen und kann nicht erneut versucht werden.",
  "identities.messages.4060002": "Der Wiederherstellungsvorgang erreichte einen Fehlerzustand und muss erneut versucht werden.",
  "identities.messages.4060004": "Der Wiederherstellungstoken ist ungültig oder wurde bereits verwendet. Bitte wiederholen Sie den Vorgang.",
  "identities.messages.4060005": "Der Wiederherstellungsvorgang ist vor {expired_at_unix_since_minutes} Minuten abgelaufen. Bitte versuchen Sie es erneut.",
  "identities.messages.4060006": "Der Wiederherstellungscode ist ungültig oder wurde bereits verwendet. Bitte versuchen Sie es erneut.",
  "identities.messages.4070001": "Der Verifizierungstoken ist ungültig oder wurde bereits verwendet. Bitte wiederholen Sie den Vorgang.",
  "identities.messages.4070002": "Die Anfrage wurde bereits erfolgreich abgeschlossen und kann nicht erneut versucht werden.",
  "identities.messages.4070003": "Der Verifizierungsvorgang erreichte einen Fehlerzustand und muss erneut versucht werden.",
  "identities.messages.4070005": "Der Verifizierungsvorgang ist vor {expired_at_unix_since_minutes} Minuten abgelaufen. Bitte versuchen Sie es erneut.",
  "identities.messages.4070006": "Der Verifizierungscode ist ungültig oder wurde bereits verwendet. Bitte versuchen Sie es erneut.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Passwort vergessen?",
  "login.logged-in-as-label": "Sie sind angemeldet als:",
  "login.logout-button": "Abmelden",
  "login.logout-label": "Etwas funktioniert nicht?",
  "login.registration-button": "Registrieren",
  "login.registration-label": "Sie haben noch kein Konto?",
  "login.subtitle-oauth2": "Zur Authentifizierung bei {clientName}",
  "login.title": "Anmelden",
  "login.title-aal2": "Zwei-Faktor-Authentifizierung",
  "login.title-refresh": "Bestätigen Sie, dass Sie es sind",
  "logout.accept-button": "Ja",
  "logout.reject-button": "Nein",
  "logout.title": "Möchten Sie sich abmelden?",
  "recovery.login-button": "Anmelden",
  "recovery.login-label": "Erinnern Sie sich an Ihre Anmeldedaten?",
  "recovery.title": "Ihr Konto wiederherstellen",
  "registration.login-button": "Anmelden",
  "registration.login-label": "Sie haben bereits ein Konto?",
  "registration.subtitle-oauth2": "Zur Authentifizierung bei {clientName}",
  "registration.title": "Konto registrieren",
  "settings.navigation-back-button": "Zurück",
  "settings.navigation-backup-codes": "2FA-Backup-Codes",
  "settings.navigation-logout": "Abmelden",
  "settings.navigation-oidc": "Soziale Medien",
  "settings.navigation-password": "Passwort",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Zwei-Faktor App",
  "settings.navigation-webauthn": "Sicherheitsschlüssel",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Hier können Sie Einstellungen zu Ihrem Konto vornehmen. Für manche Einstellungen müssen Sie Ihre Identität erneut bestätigen.",
  "settings.title": "Kontoeinstellungen",
  "settings.title-lookup-secret": "Manage 2FA Backup Recovery Codes",
  "settings.title-navigation": "Konto Einstellungen",
  "settings.title-oidc": "Anmeldung über soziale Medien",
  "settings.title-password": "Passwort ändern",
  "settings.title-profile": "Profil Einstellungen",
  "settings.title-totp": "Zwei-Faktor TOTP App",
  "settings.title-webauthn": "Sicherheitsschlüssel verwalten",
  "settings.title-passkey": "Passkeys verwalten",
  "verification.registration-button": "Registrieren",
  "verification.registration-label": "Sie haben noch kein Konto?",
  "verification.title": "Verifizieren Sie ihr Konto"
}, fr = {
  "consent.action-accept": "Autoriser",
  "consent.action-reject": "Refuser",
  "consent.description": "N'accordez des permissions que si vous faites confiance à ce site ou à cette application. Vous n'avez pas besoin d'accepter toutes les permissions.",
  "consent.privacy-policy-label": "Politique de confidentialité",
  "consent.remember-label": "Mémoriser cette décision pour la prochaine fois. L'application ne pourra pas demander des permissions supplémentaires sans votre consentement.",
  "consent.remember-tooltip": "mémoriser ma décision",
  "consent.requested-permissions-label": "L'application demande l'accès aux permissions suivantes :",
  "consent.terms-of-service-label": "Conditions d'utilisation",
  "error.back-button": "Revenir en arrière",
  "error.description": "Une erreur est survenue avec le message suivant :",
  "error.support-email-link": "Si le problème persiste, veuillez contacter <a>{contactSupportEmail}</a>",
  "error.title": "Une erreur est survenue",
  "error.title-internal-server-error": "Erreur interne du serveur",
  "error.title-not-found": "404 - Page non trouvée",
  "identities.messages.1010001": "Se connecter",
  "identities.messages.1010002": "Se connecter avec {provider}",
  "identities.messages.1010003": "Veuillez confirmer cette action en vérifiant que c'est bien vous.",
  "identities.messages.1010004": "Veuillez terminer le deuxième défi d'authentification.",
  "identities.messages.1010005": "Vérifier",
  "identities.messages.1010006": "Code d'authentification",
  "identities.messages.1010007": "Code de récupération de secours",
  "identities.messages.1010008": "Utiliser une clé de sécurité",
  "identities.messages.1010009": "Utiliser un authentificateur",
  "identities.messages.1010010": "Utiliser un code de récupération de secours",
  "identities.messages.1010011": "Continuer avec la clé de sécurité",
  "identities.messages.1010012": "Préparez votre appareil WebAuthn (par exemple, une clé de sécurité, un scanner biométrique, ...) et appuyez sur Continuer.",
  "identities.messages.1010013": "Continuer",
  "identities.messages.1010014": "Un e-mail contenant un code a été envoyé à l'adresse e-mail que vous avez fournie. Si vous n'avez pas reçu d'e-mail, vérifiez l'orthographe de l'adresse et réessayez la connexion.",
  "identities.messages.1010015": "Se connecter avec un code",
  "identities.messages.1040001": "S'inscrire",
  "identities.messages.1040002": "S'inscrire avec {provider}",
  "identities.messages.1040003": "Continuer",
  "identities.messages.1040004": "S'inscrire avec une clé de sécurité",
  "identities.messages.1040005": "Un e-mail contenant un code a été envoyé à l'adresse e-mail que vous avez fournie. Si vous n'avez pas reçu d'e-mail, vérifiez l'orthographe de l'adresse et réessayez l'inscription.",
  "identities.messages.1040006": "S'inscrire avec un code",
  "identities.messages.1050001": "Vos modifications ont été enregistrées avec succès !",
  "identities.messages.1050002": "Lier {provider}",
  "identities.messages.1050003": "Délier {provider}",
  "identities.messages.1050004": "Délier l'application d'authentification TOTP",
  "identities.messages.1050005": "Code QR de l'application d'authentification",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Afficher les codes de récupération de secours",
  "identities.messages.1050008": "Générer de nouveaux codes de récupération de secours",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Ce sont vos codes de récupération de secours. Veuillez les conserver dans un endroit sûr !",
  "identities.messages.1050011": "Confirmer les codes de récupération de secours",
  "identities.messages.1050012": "Ajouter une clé de sécurité",
  "identities.messages.1050013": "Nom de la clé de sécurité",
  "identities.messages.1050014": "<del>Utilisé</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Désactiver cette méthode",
  "identities.messages.1050017": "Il s'agit de votre code secret de l'application d'authentification. Utilisez-le si vous ne pouvez pas scanner le code QR.",
  "identities.messages.1050018": 'Supprimer la clé de sécurité "{display_name}"',
  "identities.messages.1060001": "Vous avez réussi à récupérer votre compte. Veuillez changer votre mot de passe ou configurer une méthode de connexion alternative (par exemple, une connexion sociale) dans les prochaines {privileged_session_expires_at_unix_until_minutes} minutes.",
  "identities.messages.1060002": "Un e-mail contenant un lien de récupération a été envoyé à l'adresse e-mail que vous avez fournie. Si vous n'avez pas reçu d'e-mail, vérifiez l'orthographe de l'adresse et assurez-vous d'utiliser l'adresse avec laquelle vous vous êtes enregistré.",
  "identities.messages.1060003": "Un e-mail contenant un code de récupération a été envoyé à l'adresse e-mail que vous avez fournie. Si vous n'avez pas reçu d'e-mail, vérifiez l'orthographe de l'adresse et assurez-vous d'utiliser l'adresse avec laquelle vous vous êtes enregistré.",
  "identities.messages.1070001": "Mot de passe",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Enregistrer",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Soumettre",
  "identities.messages.1070006": "Vérifier le code",
  "identities.messages.1070007": "E-mail",
  "identities.messages.1070008": "Renvoyer le code",
  "identities.messages.1070009": "Continuer",
  "identities.messages.1070010": "Code de récupération",
  "identities.messages.1070011": "Code de vérification",
  "identities.messages.1070012": "Code d'inscription",
  "identities.messages.1070013": "Code de connexion",
  "identities.messages.1080001": "Un e-mail contenant un lien de vérification a été envoyé à l'adresse e-mail que vous avez fournie. Si vous n'avez pas reçu d'e-mail, vérifiez l'orthographe de l'adresse et assurez-vous d'utiliser l'adresse avec laquelle vous vous êtes enregistré.",
  "identities.messages.1080002": "Vous avez réussi à vérifier votre adresse e-mail.",
  "identities.messages.1080003": "Un e-mail contenant un code de vérification a été envoyé à l'adresse e-mail que vous avez fournie. Si vous n'avez pas reçu d'e-mail, vérifiez l'orthographe de l'adresse et assurez-vous d'utiliser l'adresse avec laquelle vous vous êtes enregistré.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "La propriété {property} est manquante.",
  "identities.messages.4000003": "La longueur doit être >= {min_length}, mais a été {actual_length}",
  "identities.messages.4000004": 'Ne correspond pas au motif "{pattern}"',
  "identities.messages.4000005": "Le mot de passe ne peut pas être utilisé en raison de {reason}.",
  "identities.messages.4000006": "Les informations d'identification fournies sont invalides. Veuillez vérifier les fautes d'orthographe dans votre mot de passe ou nom d'utilisateur, adresse e-mail ou numéro de téléphone.",
  "identities.messages.4000007": "Un compte avec le même identifiant (e-mail, téléphone, nom d'utilisateur, ...) existe déjà.",
  "identities.messages.4000008": "Le code d'authentification fourni est invalide. Veuillez réessayer.",
  "identities.messages.4000009": "Impossible de trouver des identifiants de connexion. Avez-vous oublié de les configurer ? Cela peut également être dû à une mauvaise configuration du serveur.",
  "identities.messages.4000010": "Le compte n'est pas encore actif. Avez-vous oublié de vérifier votre adresse e-mail ?",
  "identities.messages.4000011": "Vous n'avez pas configuré de dispositif TOTP.",
  "identities.messages.4000012": "Ce code de récupération de secours a déjà été utilisé.",
  "identities.messages.4000013": "Vous n'avez pas configuré de dispositif WebAuthn.",
  "identities.messages.4000014": "Vous n'avez pas configuré de codes de récupération de secours.",
  "identities.messages.4000015": "Ce compte n'existe pas ou n'a pas configuré de clé de sécurité.",
  "identities.messages.4000016": "Le code de récupération de secours n'est pas valide.",
  "identities.messages.4000017": "La longueur doit être <= {max_length}, mais a été {actual_length}",
  "identities.messages.4000018": "Doit être >= {minimum} mais a été {actual}",
  "identities.messages.4000019": "Doit être > {minimum} mais a été {actual}",
  "identities.messages.4000020": "Doit être <= {maximum} mais a été {actual}",
  "identities.messages.4000021": "Doit être < {maximum} mais a été {actual}",
  "identities.messages.4000022": "{actual} n'est pas multiple de {base}",
  "identities.messages.4000023": "Un maximum de {max_items} éléments est autorisé, mais {actual_items} éléments ont été trouvés",
  "identities.messages.4000024": "Un minimum de {min_items} éléments est autorisé, mais {actual_items} éléments ont été trouvés",
  "identities.messages.4000025": "Les éléments aux indices {index_a} et {index_b} sont égaux",
  "identities.messages.4000026": "Les types autorisés étaient {allowed_types_list}, mais le type actuel est {actual_type}",
  "identities.messages.4000027": "Un compte avec le même identifiant (e-mail, téléphone, nom d'utilisateur, ...) existe déjà. Veuillez vous connecter à votre compte existant et lier votre profil social dans la page des paramètres.",
  "identities.messages.4000028": "Vous avez essayé de vous connecter avec {credential_identifier_hint} qui est déjà utilisé par un autre compte. Vous pouvez vous connecter en utilisant {available_credential_types_list}. Vous pouvez vous connecter en utilisant l'un des fournisseurs de connexion sociale suivants : {Available_oidc_providers_list}.",
  "identities.messages.4000029": "Doit être égal à la constante {expected}",
  "identities.messages.4000030": "Échec de la constante",
  "identities.messages.4000031": "Le mot de passe ne peut pas être utilisé car il est trop similaire à l'identifiant.",
  "identities.messages.4000032": "Le mot de passe doit comporter au moins {min_length} caractères, mais en comporte {actual_length}.",
  "identities.messages.4000033": "Le mot de passe doit comporter au plus {max_length} caractères, mais en comporte {actual_length}.",
  "identities.messages.4000034": "Le mot de passe a été trouvé dans des violations de données et ne doit plus être utilisé.",
  "identities.messages.4000035": "Ce compte n'existe pas ou n'a pas configuré de connexion avec code.",
  "identities.messages.4000036": "Les traits fournis ne correspondent pas aux traits associés précédemment à ce flux.",
  "identities.messages.4010001": "Le flux de connexion a expiré il y a {expired_at_unix_since_minutes} minutes, veuillez réessayer.",
  "identities.messages.4010002": "Impossible de trouver une stratégie pour vous connecter. Avez-vous rempli correctement le formulaire ?",
  "identities.messages.4010003": "Impossible de trouver une stratégie pour vous inscrire. Avez-vous rempli correctement le formulaire ?",
  "identities.messages.4010004": "Impossible de trouver une stratégie pour mettre à jour vos paramètres. Avez-vous rempli correctement le formulaire ?",
  "identities.messages.4010005": "Impossible de trouver une stratégie pour récupérer votre compte. Avez-vous rempli correctement le formulaire ?",
  "identities.messages.4010006": "Impossible de trouver une stratégie pour vérifier votre compte. Avez-vous rempli correctement le formulaire ?",
  "identities.messages.4010007": "La demande a déjà été effectuée avec succès et ne peut pas être réessayée.",
  "identities.messages.4010008": "Le code de connexion est invalide ou a déjà été utilisé. Veuillez réessayer.",
  "identities.messages.4040001": "Le flux d'inscription a expiré il y a {expired_at_unix_since_minutes} minutes, veuillez réessayer.",
  "identities.messages.4040002": "La demande a déjà été effectuée avec succès et ne peut pas être réessayée.",
  "identities.messages.4040003": "Le code d'inscription est invalide ou a déjà été utilisé. Veuillez réessayer.",
  "identities.messages.4050001": "Le flux de paramètres a expiré il y a {expired_at_unix_since_minutes} minutes, veuillez réessayer.",
  "identities.messages.4060001": "La demande a déjà été effectuée avec succès et ne peut pas être réessayée.",
  "identities.messages.4060002": "Le flux de récupération a atteint un état d'échec et doit être réessayé.",
  "identities.messages.4060004": "Le jeton de récupération est invalide ou a déjà été utilisé. Veuillez réessayer le flux.",
  "identities.messages.4060005": "Le flux de récupération a expiré il y a {expired_at_unix_since_minutes} minutes, veuillez réessayer.",
  "identities.messages.4060006": "Le code de récupération est invalide ou a déjà été utilisé. Veuillez réessayer.",
  "identities.messages.4070001": "Le jeton de vérification est invalide ou a déjà été utilisé. Veuillez réessayer le flux.",
  "identities.messages.4070002": "La demande a déjà été effectuée avec succès et ne peut pas être réessayée.",
  "identities.messages.4070003": "Le flux de vérification a atteint un état d'échec et doit être réessayé.",
  "identities.messages.4070005": "Le flux de vérification a expiré il y a {expired_at_unix_since_minutes} minutes, veuillez réessayer.",
  "identities.messages.4070006": "Le code de vérification est invalide ou a déjà été utilisé. Veuillez réessayer.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Mot de passe oublié ?",
  "login.logged-in-as-label": "Vous êtes connecté en tant que :",
  "login.logout-button": "Déconnexion",
  "login.logout-label": "Quelque chose ne fonctionne pas ?",
  "login.registration-button": "S'inscrire",
  "login.registration-label": "Vous n'avez pas de compte ?",
  "login.subtitle-oauth2": "Pour vous authentifier sur {clientName}",
  "login.title": "Se connecter",
  "login.title-aal2": "Authentification à deux facteurs",
  "login.title-refresh": "Confirmez que c'est bien vous",
  "logout.accept-button": "Oui",
  "logout.reject-button": "Non",
  "logout.title": "Souhaitez-vous vous déconnecter ?",
  "recovery.login-button": "Se connecter",
  "recovery.login-label": "Vous souvenez-vous de vos informations d'identification ?",
  "recovery.title": "Récupérer votre compte",
  "registration.login-button": "Se connecter",
  "registration.login-label": "Vous avez déjà un compte ?",
  "registration.subtitle-oauth2": "Pour vous authentifier sur {clientName}",
  "registration.title": "Créer un compte",
  "settings.navigation-back-button": "Revenir en arrière",
  "settings.navigation-backup-codes": "Codes de secours 2FA",
  "settings.navigation-logout": "Déconnexion",
  "settings.navigation-oidc": "Connexion sociale",
  "settings.navigation-password": "Mot de passe",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Application d'authentification TOTP",
  "settings.navigation-webauthn": "Tokens matériels",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Ici, vous pouvez gérer les paramètres liés à votre compte. Gardez à l'esprit que certaines actions nécessitent une nouvelle authentification.",
  "settings.title": "Paramètres du compte",
  "settings.title-lookup-secret": "Gérer les codes de récupération 2FA",
  "settings.title-navigation": "Paramètres du compte",
  "settings.title-oidc": "Connexion sociale",
  "settings.title-password": "Changer le mot de passe",
  "settings.title-profile": "Paramètres de profil",
  "settings.title-totp": "Gérer l'application d'authentification TOTP 2FA",
  "settings.title-webauthn": "Gérer les tokens matériels",
  "settings.title-passkey": "Gérer les Passkeys",
  "verification.registration-button": "S'inscrire",
  "verification.registration-label": "Vous n'avez pas de compte ?",
  "verification.title": "Vérifiez votre compte"
}, nl = {
  "consent.action-accept": "Toestaan",
  "consent.action-reject": "Weigeren",
  "consent.description": "Verleen alleen toestemming als u deze site of app vertrouwt. U hoeft niet alle toestemmingen te accepteren.",
  "consent.privacy-policy-label": "Privacybeleid",
  "consent.remember-label": "Onthoud deze beslissing voor de volgende keer. De toepassing kan geen aanvullende toestemming vragen zonder uw toestemming.",
  "consent.remember-tooltip": "Onthoud mijn beslissing",
  "consent.requested-permissions-label": "De toepassing vraagt toegang tot de volgende toestemmingen:",
  "consent.terms-of-service-label": "Gebruiksvoorwaarden",
  "error.back-button": "Ga terug",
  "error.description": "Er is een fout opgetreden met de volgende melding:",
  "error.support-email-link": "Als het probleem aanhoudt, neem dan contact op met <a>{contactSupportEmail}</a>",
  "error.title": "Er is een fout opgetreden",
  "error.title-internal-server-error": "Interne serverfout",
  "error.title-not-found": "404 - Pagina niet gevonden",
  "identities.messages.1010001": "Aanmelden",
  "identities.messages.1010002": "Aanmelden met {provider}",
  "identities.messages.1010003": "Bevestig deze actie door te verifiëren dat u het bent.",
  "identities.messages.1010004": "Voltooi alstublieft de tweede authenticatie-uitdaging.",
  "identities.messages.1010005": "Verifiëren",
  "identities.messages.1010006": "Verificatiecode",
  "identities.messages.1010007": "Back-up herstelcode",
  "identities.messages.1010008": "Beveiligingssleutel gebruiken",
  "identities.messages.1010009": "Authenticator gebruiken",
  "identities.messages.1010010": "Back-up herstelcode gebruiken",
  "identities.messages.1010011": "Doorgaan met beveiligingssleutel",
  "identities.messages.1010012": "Bereid uw WebAuthn-apparaat voor (bijv. beveiligingssleutel, biometrische scanner, ...) en druk op doorgaan.",
  "identities.messages.1010013": "Doorgaan",
  "identities.messages.1010014": "Er is een e-mail met een code verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het adres en probeer opnieuw in te loggen.",
  "identities.messages.1010015": "Aanmelden met code",
  "identities.messages.1040001": "Registreren",
  "identities.messages.1040002": "Registreren met {provider}",
  "identities.messages.1040003": "Doorgaan",
  "identities.messages.1040004": "Registreren met beveiligingssleutel",
  "identities.messages.1040005": "Er is een e-mail met een code verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het adres en probeer opnieuw te registreren.",
  "identities.messages.1040006": "Registreren met code",
  "identities.messages.1050001": "Uw wijzigingen zijn opgeslagen!",
  "identities.messages.1050002": "Koppelen aan {provider}",
  "identities.messages.1050003": "Ontkoppelen van {provider}",
  "identities.messages.1050004": "Ontkoppelen van TOTP Authenticator-app",
  "identities.messages.1050005": "QR-code voor Authenticator-app",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Toon back-up herstelcodes",
  "identities.messages.1050008": "Nieuwe back-up herstelcodes genereren",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Dit zijn uw back-up herstelcodes. Bewaar ze op een veilige plaats!",
  "identities.messages.1050011": "Bevestig back-up herstelcodes",
  "identities.messages.1050012": "Beveiligingssleutel toevoegen",
  "identities.messages.1050013": "Naam van de beveiligingssleutel",
  "identities.messages.1050014": "<del>Gebruikt</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Deze methode uitschakelen",
  "identities.messages.1050017": "Dit is uw geheime Authenticator-app. Gebruik het als u de QR-code niet kunt scannen.",
  "identities.messages.1050018": 'Beveiligingssleutel verwijderen "{display_name}"',
  "identities.messages.1060001": "U heeft met succes uw account hersteld. Wijzig alstublieft uw wachtwoord of stel een alternatieve aanmeldingsmethode in (bijv. sociale aanmelding) binnen de komende {privileged_session_expires_at_unix_until_minutes} minuten.",
  "identities.messages.1060002": "Er is een e-mail met een herstelkoppeling verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat u het e-mailadres gebruikt waarmee u zich heeft geregistreerd.",
  "identities.messages.1060003": "Er is een e-mail met een herstelcode verzonden naar het opgegeven e-mailadres. Als u geen e-mail heeft ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat u het e-mailadres gebruikt waarmee u zich heeft geregistreerd.",
  "identities.messages.1070001": "Wachtwoord",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Opslaan",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Verzenden",
  "identities.messages.1070006": "Verificatiecode controleren",
  "identities.messages.1070007": "E-mail",
  "identities.messages.1070008": "Code opnieuw verzenden",
  "identities.messages.1070009": "Doorgaan",
  "identities.messages.1070010": "Herstelcode",
  "identities.messages.1070011": "Verificatiecode",
  "identities.messages.1070012": "Registratiecode",
  "identities.messages.1070013": "Aanmeldingscode",
  "identities.messages.1080001": "Er is een e-mail met een verificatielink naar het opgegeven e-mailadres gestuurd. Als je geen e-mail hebt ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat je het e-mailadres hebt gebruikt waarmee je hebt geregistreerd.",
  "identities.messages.1080002": "Je hebt succesvol je e-mailadres geverifieerd.",
  "identities.messages.1080003": "Er is een e-mail met een verificatiecode naar het opgegeven e-mailadres gestuurd. Als je geen e-mail hebt ontvangen, controleer dan de spelling van het e-mailadres en zorg ervoor dat je het e-mailadres hebt gebruikt waarmee je hebt geregistreerd.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Eigenschap {property} ontbreekt.",
  "identities.messages.4000003": "lengte moet >= {min_length} zijn, maar is {actual_length}",
  "identities.messages.4000004": 'komt niet overeen met patroon "{pattern}"',
  "identities.messages.4000005": "Het wachtwoord kan niet worden gebruikt vanwege {reason}.",
  "identities.messages.4000006": "De verstrekte referenties zijn ongeldig, controleer op typefouten in je wachtwoord of gebruikersnaam, e-mailadres of telefoonnummer.",
  "identities.messages.4000007": "Er bestaat al een account met dezelfde identificatiegegevens (e-mail, telefoon, gebruikersnaam, ...).",
  "identities.messages.4000008": "De verstrekte verificatiecode is ongeldig, probeer het opnieuw.",
  "identities.messages.4000009": "Kon geen aanmeldingsidentificatoren vinden. Ben je ze vergeten in te stellen? Dit kan ook worden veroorzaakt door een servermisconfiguratie.",
  "identities.messages.4000010": "Account nog niet actief. Ben je vergeten je e-mailadres te verifiëren?",
  "identities.messages.4000011": "Je hebt geen TOTP-apparaat ingesteld.",
  "identities.messages.4000012": "Deze herstelcode is al gebruikt.",
  "identities.messages.4000013": "Je hebt geen WebAuthn-apparaat ingesteld.",
  "identities.messages.4000014": "Je hebt geen herstelcodes ingesteld.",
  "identities.messages.4000015": "Dit account bestaat niet of heeft geen beveiligingssleutel ingesteld.",
  "identities.messages.4000016": "De herstelcode is niet geldig.",
  "identities.messages.4000017": "lengte moet <= {max_length} zijn, maar is {actual_length}",
  "identities.messages.4000018": "moet >= {minimum} zijn, maar is {actual}",
  "identities.messages.4000019": "moet > {minimum} zijn, maar is {actual}",
  "identities.messages.4000020": "moet <= {maximum} zijn, maar is {actual}",
  "identities.messages.4000021": "moet < {maximum} zijn, maar is {actual}",
  "identities.messages.4000022": "{actual} is geen veelvoud van {base}",
  "identities.messages.4000023": "maximaal {max_items} items toegestaan, maar er zijn {actual_items} items gevonden",
  "identities.messages.4000024": "minimaal {min_items} items toegestaan, maar er zijn {actual_items} items gevonden",
  "identities.messages.4000025": "items op index {index_a} en {index_b} zijn gelijk",
  "identities.messages.4000026": "verwacht {allowed_types_list}, maar kreeg {actual_type}",
  "identities.messages.4000027": "Er bestaat al een account met dezelfde identificatiegegevens (e-mail, telefoon, gebruikersnaam, ...). Meld je aan bij je bestaande account en koppel je sociale profiel in de instellingenpagina.",
  "identities.messages.4000028": "Je hebt geprobeerd in te loggen met {credential_identifier_hint}, dat al wordt gebruikt door een ander account. Je kunt inloggen met {available_credential_types_list}. Je kunt inloggen met een van de volgende sociale aanmeldingsproviders: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "moet gelijk zijn aan constante {expected}",
  "identities.messages.4000030": "constante mislukt",
  "identities.messages.4000031": "Het wachtwoord kan niet worden gebruikt omdat het te veel lijkt op de identificatiegegevens.",
  "identities.messages.4000032": "Het wachtwoord moet minstens {min_length} tekens lang zijn, maar is {actual_length}.",
  "identities.messages.4000033": "Het wachtwoord mag hoogstens {max_length} tekens lang zijn, maar is {actual_length}.",
  "identities.messages.4000034": "Het wachtwoord is gevonden in datalekken en mag niet langer worden gebruikt.",
  "identities.messages.4000035": "Dit account bestaat niet of heeft geen aanmelding met code ingesteld.",
  "identities.messages.4000036": "De verstrekte kenmerken komen niet overeen met de eerder geassocieerde kenmerken met deze stroom.",
  "identities.messages.4010001": "De aanmeldingsstroom is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4010002": "Kon geen strategie vinden om mee in te loggen. Heb je het formulier correct ingevuld?",
  "identities.messages.4010003": "Kon geen strategie vinden om je mee aan te melden. Heb je het formulier correct ingevuld?",
  "identities.messages.4010004": "Kon geen strategie vinden om je instellingen bij te werken. Heb je het formulier correct ingevuld?",
  "identities.messages.4010005": "Kon geen strategie vinden om je account mee te herstellen. Heb je het formulier correct ingevuld?",
  "identities.messages.4010006": "Kon geen strategie vinden om je account mee te verifiëren. Heb je het formulier correct ingevuld?",
  "identities.messages.4010007": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4010008": "De aanmeldingscode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.4040001": "De registratie flowis verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4040002": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4040003": "De registratiecode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.4050001": "De instellingen flow is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4060001": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4060002": "De herstel flow heeft een fout bereikt en moet opnieuw worden geprobeerd.",
  "identities.messages.4060004": "De hersteltoken is ongeldig of is al gebruikt. Probeer de flow opnieuw.",
  "identities.messages.4060005": "De herstel flow is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4060006": "De herstelcode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.4070001": "De verificatietoken is ongeldig of is al gebruikt. Probeer de flow opnieuw.",
  "identities.messages.4070002": "Het verzoek is al met succes voltooid en kan niet opnieuw worden geprobeerd.",
  "identities.messages.4070003": "De verificatie flow heeft een fout bereikt en moet opnieuw worden geprobeerd.",
  "identities.messages.4070005": "De verificatie flow is verlopen {expired_at_unix_since_minutes} minuten geleden, probeer het opnieuw.",
  "identities.messages.4070006": "De verificatiecode is ongeldig of is al gebruikt. Probeer het opnieuw.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Wachtwoord vergeten?",
  "login.logged-in-as-label": "Je bent ingelogd als:",
  "login.logout-button": "Uitloggen",
  "login.logout-label": "Er is iets mis?",
  "login.registration-button": "Registreren",
  "login.registration-label": "Heb je nog geen account?",
  "login.subtitle-oauth2": "Om te authenticeren bij {clientName}",
  "login.title": "Inloggen",
  "login.title-aal2": "Twee-Factor Authenticatie",
  "login.title-refresh": "Bevestig dat jij het bent",
  "logout.accept-button": "Ja",
  "logout.reject-button": "Nee",
  "logout.title": "Wil je uitloggen?",
  "recovery.login-button": "Inloggen",
  "recovery.login-label": "Herinner je je inloggegevens?",
  "recovery.title": "Herstel je account",
  "registration.login-button": "Inloggen",
  "registration.login-label": "Heb je al een account?",
  "registration.subtitle-oauth2": "Om te authenticeren bij {clientName}",
  "registration.title": "Registreer een account",
  "settings.navigation-back-button": "Ga terug",
  "settings.navigation-backup-codes": "2FA Backupcodes",
  "settings.navigation-logout": "Uitloggen",
  "settings.navigation-oidc": "Sociaal Inloggen",
  "settings.navigation-password": "Wachtwoord",
  "settings.navigation-profile": "Profiel",
  "settings.navigation-totp": "Authenticator App",
  "settings.navigation-webauthn": "Hardware Tokens",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Hier kun je instellingen beheren die verband houden met je account. Houd er rekening mee dat bepaalde acties vereisen dat je opnieuw wordt geauthenticeerd.",
  "settings.title": "Accountinstellingen",
  "settings.title-lookup-secret": "Beheer 2FA Backup Herstelcodes",
  "settings.title-navigation": "Accountinstellingen",
  "settings.title-oidc": "Sociaal Inloggen",
  "settings.title-password": "Wachtwoord wijzigen",
  "settings.title-profile": "Profielinstellingen",
  "settings.title-totp": "Beheer 2FA TOTP Authenticator App",
  "settings.title-webauthn": "Beheer Hardware Tokens",
  "settings.title-passkey": "Beheer Passkeys",
  "verification.registration-button": "Registreren",
  "verification.registration-label": "Heb je nog geen account?",
  "verification.title": "Verifieer je account"
}, se = {
  "consent.action-accept": "Tillåt",
  "consent.action-reject": "Neka",
  "consent.description": "Ge bara behörigheter om du litar på den här webbplatsen eller appen. Du behöver inte acceptera alla behörigheter.",
  "consent.privacy-policy-label": "Integritetspolicy",
  "consent.remember-label": "Kom ihåg detta val till nästa gång. Applikationen kommer inte att kunna be om ytterligare tillstånd utan ditt medgivande.",
  "consent.remember-tooltip": "kom ihåg mitt val",
  "consent.requested-permissions-label": "Applikationen begär åtkomst till följande behörigheter:",
  "consent.terms-of-service-label": "Användarvillkor",
  "error.back-button": "Tillbaka",
  "error.description": "Ett fel uppstod med följande meddelande:",
  "error.support-email-link": "Om problemet kvarstår, vänligen kontakta <a>{contactSupportEmail}</a>",
  "error.title": "Ett fel uppstod",
  "error.title-internal-server-error": "Internt serverfel",
  "error.title-not-found": "404 - Sidan hittades ej",
  "identities.messages.1010001": "Logga in",
  "identities.messages.1010002": "Logga in med {provider}",
  "identities.messages.1010003": "Bekräfta denna åtgärd genom att verifiera att det är du.",
  "identities.messages.1010004": "Vänligen slutför den andra autentiseringsutmaningen.",
  "identities.messages.1010005": "Verifiera",
  "identities.messages.1010006": "Autentiseringskod",
  "identities.messages.1010007": "Återställningskod för backup",
  "identities.messages.1010008": "Använd säkerhetsnyckel",
  "identities.messages.1010009": "Använd autentiserings-app",
  "identities.messages.1010010": "Använd reservåterställningskod",
  "identities.messages.1010011": "Fortsätt med säkerhetsnyckel",
  "identities.messages.1010012": "Förbered din WebAuthn-enhet (t.ex. säkerhetsnyckel, biometriska skanner, ...) och tryck på fortsätt.",
  "identities.messages.1010013": "Fortsätt",
  "identities.messages.1010014": "Ett e-postmeddelande som innehåller en kod har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen av adressen och försök logga in igen.",
  "identities.messages.1010015": "Logga in med kod",
  "identities.messages.1040001": "Logga in",
  "identities.messages.1040002": "Logga in med {provider}",
  "identities.messages.1040003": "Fortsätt",
  "identities.messages.1040004": "Registrera med säkerhetsnyckel",
  "identities.messages.1040005": "Ett e-postmeddelande som innehåller en kod har skickats till den e-postadress du angett. Om du inte har fått ett e-postmeddelande, kontrollera stavningen av adressen och försök igen med registreringen.",
  "identities.messages.1040006": "Registrera med kod",
  "identities.messages.1050001": "Dina ändringar har sparats!",
  "identities.messages.1050002": "Koppla på {provider}",
  "identities.messages.1050003": "Koppla bort {provider}",
  "identities.messages.1050004": "Koppla bort TOTP Autentisering-App",
  "identities.messages.1050005": "Autentisering-app QR kod",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Visa reservåterställningskoder",
  "identities.messages.1050008": "Generera nya reservåterställningskoder",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Det här är dina reservåterställningskoder. Förvara dem på ett säkert ställe!",
  "identities.messages.1050011": "Bekräfta reservåterställningskoder",
  "identities.messages.1050012": "Lägg till säkerhetsnyckel",
  "identities.messages.1050013": "Säkerhetsnyckelns namn",
  "identities.messages.1050014": "<del>Använd</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Inaktivera den här metoden",
  "identities.messages.1050017": "Det här är din hemlighet för din autentiseringsapp. Använd den om du inte kan skanna QR-koden.",
  "identities.messages.1050018": 'Ta bort säkerhetsnyckel "{display_name}"',
  "identities.messages.1060001": "Du har lyckats återställa ditt konto. Ändra ditt lösenord eller ställ in en alternativ inloggningsmetod (t.ex. social inloggning) inom de närmaste {privileged_session_expires_at_unix_until_minutes} minuterna.",
  "identities.messages.1060002": "Ett e-postmeddelande som innehåller en återställningslänk har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.1060003": "Ett e-postmeddelande som innehåller en återställningskod har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.1070001": "Lösenord",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Spara",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Skicka",
  "identities.messages.1070006": "Verifiera kod",
  "identities.messages.1070007": "E-post",
  "identities.messages.1070008": "Skicka koden igen",
  "identities.messages.1070009": "Fortsätt",
  "identities.messages.1070010": "Återställningskod",
  "identities.messages.1070011": "Verifieringskod",
  "identities.messages.1070012": "Registreringskod",
  "identities.messages.1070013": "Inloggningskod",
  "identities.messages.1080001": "Ett e-postmeddelande med en verifieringslänk har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.1080002": "Du har verifierat din e-postadress.",
  "identities.messages.1080003": "Ett e-postmeddelande som innehåller en verifieringskod har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Egenskap {property} saknas.",
  "identities.messages.4000003": "längd måste vara >= {min_length}, men var {actual_length}",
  "identities.messages.4000004": 'matchar inte mönstret "{pattern}"',
  "identities.messages.4000005": "Lösenordet kan inte användas pga {reason}.",
  "identities.messages.4000006": "De angivna uppgifterna är ogiltiga. Kontrollera om det finns stavfel i ditt lösenord eller användarnamn, e-postadress eller telefonnummer.",
  "identities.messages.4000007": "Ett konto med samma identifierare (e-post, telefon, användarnamn, ...) finns redan.",
  "identities.messages.4000008": "Den angivna autentiseringskoden är ogiltig, försök igen.",
  "identities.messages.4000009": "Det gick inte att hitta några inloggningsidentifierare. Har du glömt att ställa in dem? Detta kan också orsakas av en felaktig serverkonfiguration.",
  "identities.messages.4000010": "Kontot är inte aktivt ännu. Har du glömt att verifiera din e-postadress?",
  "identities.messages.4000011": "Du har ingen TOTP-enhet konfigurerad.",
  "identities.messages.4000012": "Denna backup-återställningskod har redan använts.",
  "identities.messages.4000013": "Du har ingen WebAuthn-enhet konfigurerad.",
  "identities.messages.4000014": "Du har inga backup-återställningskoder konfigurerade.",
  "identities.messages.4000015": "Det här kontot finns inte eller har ingen säkerhetsnyckel konfigurerad.",
  "identities.messages.4000016": "Backup-återställningskoden är inte giltig.",
  "identities.messages.4000017": "längd måste vara <= {max_length}, men var {actual_length}",
  "identities.messages.4000018": "måste vara >= {minimum} men var {actual}",
  "identities.messages.4000019": "måste vara > {minimum} men var {actual}",
  "identities.messages.4000020": "måste vara <= {maximum} men var {actual}",
  "identities.messages.4000021": "måste vara < {maximum} men var {actual}",
  "identities.messages.4000022": "{actual} är inte en multipel av {base}",
  "identities.messages.4000023": "maximalt {max_items} objekt tillåtna, men hittade {actual_items} objekt",
  "identities.messages.4000024": "minst {min_items} objekt tillåtna, men hittade {actual_items} objekt",
  "identities.messages.4000025": "objekt vid index {index_a} och {index_b} är lika",
  "identities.messages.4000026": "förväntade {allowed_types_list}, men var {actual_type}",
  "identities.messages.4000027": "Ett konto med samma identifierare (e-post, telefon, användarnamn, ...) finns redan. Logga in på ditt befintliga konto och länka din sociala profil på inställningssidan.",
  "identities.messages.4000028": "Du försökte logga in med {credential_identifier_hint} som redan används av ett annat konto. Du kan logga in med {available_credential_types_list}. Du kan logga in med någon av följande sociala inloggningsleverantörer: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "måste vara lika med konstant {expected}",
  "identities.messages.4000030": "const misslyckades",
  "identities.messages.4000031": "Lösenordet kan inte användas eftersom det är för likt identifieraren.",
  "identities.messages.4000032": "Lösenordet måste vara minst {min_length} tecken långt, men är {actual_length}.",
  "identities.messages.4000033": "Lösenordet får vara högst {max_length} tecken långt, men är {actual_length}.",
  "identities.messages.4000034": "Lösenordet har hittats vid dataintrång och får inte längre användas.",
  "identities.messages.4000035": "Det här kontot finns inte eller har inte konfigurerat inloggning med kod.",
  "identities.messages.4000036": "De angivna egenskaperna matchar inte de egenskaper som tidigare associerats med detta flöde.",
  "identities.messages.4010001": "Inloggningsflödet upphörde för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4010002": "Kunde inte hitta en strategi att logga in dig med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010003": "Kunde inte hitta en strategi att registrera dig med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010004": "Kunde inte hitta en strategi för att uppdatera dina inställningar. Fyllde du i formuläret korrekt?",
  "identities.messages.4010005": "Kunde inte hitta en strategi att återställa ditt konto med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010006": "Kunde inte hitta en strategi att verifiera ditt konto med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010007": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4010008": "Inloggningskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.4040001": "Registreringsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, försök igen.",
  "identities.messages.4040002": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4040003": "Registreringskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.4050001": "Inställningsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4060001": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4060002": "Återställningsflödet nådde ett feltillstånd och måste försökas igen.",
  "identities.messages.4060004": "Återställningstoken är ogiltig eller har redan använts. Var vänlig försök flödet igen.",
  "identities.messages.4060005": "Återställningsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4060006": "Återställningskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.4070001": "Verifieringstoken är ogiltig eller har redan använts. Var vänlig försök flödet igen.",
  "identities.messages.4070002": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4070003": "Verifieringsflödet nådde ett feltillstånd och måste försökas igen.",
  "identities.messages.4070005": "Verifieringsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4070006": "Verifieringskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Glömt lösenord?",
  "login.logged-in-as-label": "Du är inloggad som:",
  "login.logout-button": "Logga ut",
  "login.logout-label": "Är det något som inte fungerar?",
  "login.registration-button": "Skapa konto",
  "login.registration-label": "Har du inget konto?",
  "login.subtitle-oauth2": "Att autentisera {clientName}",
  "login.title": "Logga in",
  "login.title-aal2": "Tvåfaktorsautentisering",
  "login.title-refresh": "Bekräfta att det är du",
  "logout.accept-button": "Ja",
  "logout.reject-button": "Nej",
  "logout.title": "Vill du logga ut?",
  "recovery.login-button": "Logga in",
  "recovery.login-label": "Kan du ditt inlogg?",
  "recovery.title": "Återställ ditt konto",
  "registration.login-button": "Logga in",
  "registration.login-label": "Har du redan ett konto?",
  "registration.subtitle-oauth2": "Att autentisera {clientName}",
  "registration.title": "Skapa ett konto",
  "settings.navigation-back-button": "Tillbaka",
  "settings.navigation-backup-codes": "2FA backupkoder",
  "settings.navigation-logout": "Logga ut",
  "settings.navigation-oidc": "Social Inloggning",
  "settings.navigation-password": "Lösenord",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Autentiserings App",
  "settings.navigation-webauthn": "Hårdvaru Tokens",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Här kan du hantera inställningar relaterade till ditt konto. Tänk på att vissa åtgärder kräver att du autentiseras på nytt.",
  "settings.title": "Kontoinställningar",
  "settings.title-lookup-secret": "Hantera 2FA backup-återställningskoder",
  "settings.title-navigation": "Kontoinställningar",
  "settings.title-oidc": "Social Inloggning",
  "settings.title-password": "Byt lösenord",
  "settings.title-profile": "Profilinställningar",
  "settings.title-totp": "Hantera 2FA TOTP Autentiserings App",
  "settings.title-webauthn": "Hantera Hårdvaru Tokens",
  "settings.title-passkey": "Hantera Passkeys",
  "verification.registration-button": "Skapa konto",
  "verification.registration-label": "Har du inget konto?",
  "verification.title": "Verifiera ditt konto"
}, pt = {
  "consent.action-accept": "Permitir",
  "consent.action-reject": "Rejeitar",
  "consent.description": "Conceda permissões somente se confiar neste site ou aplicação. Não precisa aceitar todas as permissões.",
  "consent.privacy-policy-label": "Política de Privacidade",
  "consent.remember-label": "Lembrar decisão para a próxima vez. A aplicação não poderá solicitar permissões adicionais sem o seu consentimento.",
  "consent.remember-tooltip": "lembrar minha decisão",
  "consent.requested-permissions-label": "A aplicação solicita acesso às seguintes permissões:",
  "consent.terms-of-service-label": "Termos de Serviço",
  "error.back-button": "Voltar",
  "error.description": "Ocorreu um erro com a seguinte mensagem:",
  "error.support-email-link": "Se o problema persistir, entre em contato com <a>{contactSupportEmail}</a>",
  "error.title": "Ocorreu um erro",
  "error.title-internal-server-error": "Erro Interno do Servidor",
  "error.title-not-found": "404 - Página não encontrada",
  "identities.messages.1010001": "Entrar",
  "identities.messages.1010002": "Entrar com {provider}",
  "identities.messages.1010003": "Confirme esta ação e verifique que é você.",
  "identities.messages.1010004": "Complete o segundo desafio de autenticação, por favor.",
  "identities.messages.1010005": "Verificar",
  "identities.messages.1010006": "Código de Autenticação",
  "identities.messages.1010007": "Código de Recuperação de Backup",
  "identities.messages.1010008": "Usar chave de segurança",
  "identities.messages.1010009": "Usar o Autenticador",
  "identities.messages.1010010": "Usar código de recuperação de backup",
  "identities.messages.1010011": "Continuar com a chave de segurança",
  "identities.messages.1010012": "Prepare o seu dispositivo WebAuthn (por exemplo, chave de segurança, scanner biométrico, ...) e pressione continuar.",
  "identities.messages.1010013": "Continuar",
  "identities.messages.1010014": "Um e-mail com um código foi enviado para o endereço de e-mail introduzido. Não recebeu um e-mail? Verifique o endereço introduzido e efetue novamente o login.",
  "identities.messages.1010015": "Entrar com código",
  "identities.messages.1040001": "Registar",
  "identities.messages.1040002": "Registar com {provider}",
  "identities.messages.1040003": "Continuar",
  "identities.messages.1040004": "Registar com chave de segurança",
  "identities.messages.1040005": "Um e-mail com o código foi enviado para o endereço de e-mail introduzido. Não recebeu um e-mail? Verifique a ortografia do endereço e registe-se novamente.",
  "identities.messages.1040006": "Registar com código",
  "identities.messages.1050001": "Alterações foram salvas com sucesso!",
  "identities.messages.1050002": "Vincular {provider}",
  "identities.messages.1050003": "Desvincular {provider}",
  "identities.messages.1050004": "Desvincular o Aplicação Autenticador TOTP",
  "identities.messages.1050005": "Código QR da aplicação Autenticador",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Revelar códigos de recuperação de backup",
  "identities.messages.1050008": "Gerar novos códigos de recuperação de backup",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Os seus códigos de recuperação de backup. Guarde-os num local seguro!",
  "identities.messages.1050011": "Confirmar códigos de recuperação de backup",
  "identities.messages.1050012": "Adicionar chave de segurança",
  "identities.messages.1050013": "Nome da chave de segurança",
  "identities.messages.1050014": "<del>Usado</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Desativar este método",
  "identities.messages.1050017": "Este é o segredo da sua aplicação autenticador. Use-o se não puder ler o código QR.",
  "identities.messages.1050018": 'Remover chave de segurança "{display_name}"',
  "identities.messages.1060001": "Recuperou com sucesso a sua conta. Por favor, altere a sua password ou configure um método de login alternativo (por exemplo, login social) nos próximos {privileged_session_expires_at_unix_until_minutes} minutos.",
  "identities.messages.1060002": "Um e-mail com um link de recuperação foi enviado para o endereço de e-mail introduzido. Se recebeu um e-mail, verifique a ortografia do endereço e verifique se está usando o endereço com o qual se registou.",
  "identities.messages.1060003": "Um e-mail com um código de recuperação foi enviado para o endereço de e-mail introduzido. Se recebeu um e-mail, verifique a ortografia do endereço e verifique se está usando o endereço com o qual se registou.",
  "identities.messages.1070001": "Password",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Salvar",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Enviar",
  "identities.messages.1070006": "Verificar código",
  "identities.messages.1070007": "E-mail",
  "identities.messages.1070008": "Reenviar código",
  "identities.messages.1070009": "Continuar",
  "identities.messages.1070010": "Código de recuperação",
  "identities.messages.1070011": "Código de verificação",
  "identities.messages.1070012": "Código de registo",
  "identities.messages.1070013": "Código de login",
  "identities.messages.1080001": "Um e-mail com um link de verificação foi enviado para o endereço de e-mail introduzido. Se recebeu um e-mail, verifique a ortografia do endereço e verifique se está usando o endereço com o qual se registou.",
  "identities.messages.1080002": "Endereço de e-mail verificado com sucesso.",
  "identities.messages.1080003": "Um e-mail com um código de verificação foi enviado para o endereço de e-mail introduzido. Se recebeu um e-mail, verifique a ortografia do endereço e verifique se está usando o endereço com o qual se registou.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "A propriedade {property} não foi encontrada.",
  "identities.messages.4000003": "O comprimento deve ser >= {min_length}, mas foi {actual_length}",
  "identities.messages.4000004": 'não corresponde ao padrão "{pattern}"',
  "identities.messages.4000005": "A password não pode ser utilizada porque {reason}.",
  "identities.messages.4000006": "As credenciais fornecidas são inválidas, verifique erros na definição da password ou no nome de usuário, endereço de e-mail ou número de telefone.",
  "identities.messages.4000007": "Já existe uma conta com o mesmo username (e-mail, telefone, nome de usuário, ...).",
  "identities.messages.4000008": "O código de autenticação fornecido é inválido, tente novamente.",
  "identities.messages.4000009": "Não foi possível encontrar nenhum username de login. Esqueceu-se de defini-los? Isso também pode ser causado por uma má configuração do servidor.",
  "identities.messages.4000010": "Conta ainda não está ativa. Esqueceu-se de verificar o seu endereço de e-mail?",
  "identities.messages.4000011": "Não tem um dispositivo TOTP configurado.",
  "identities.messages.4000012": "Este código de recuperação de backup já foi usado.",
  "identities.messages.4000013": "Não tem um dispositivo WebAuthn configurado.",
  "identities.messages.4000014": "Não tem códigos de recuperação de backup configurados.",
  "identities.messages.4000015": "Esta conta não existe ou não tem uma chave de segurança configurada.",
  "identities.messages.4000016": "O código de recuperação de backup não é válido.",
  "identities.messages.4000017": "O comprimento deve ser <= {max_length}, mas foi {actual_length}",
  "identities.messages.4000018": "deve ser >= {minimum} mas foi encontrado {actual}",
  "identities.messages.4000019": "deve ser > {minimum} mas foi encontrado {actual}",
  "identities.messages.4000020": "deve ser <= {maximum} mas foi encontrado {actual}",
  "identities.messages.4000021": "deve ser < {maximum} mas foi encontrado {actual}",
  "identities.messages.4000022": "{actual} não é múltiplo de {base}",
  "identities.messages.4000023": "máximo de {max_items} itens permitidos, mas foram encontrados {actual_items} itens",
  "identities.messages.4000024": "mínimo de {min_items} itens permitidos, mas foram encontrados {actual_items} itens",
  "identities.messages.4000025": "itens nos índices {index_a} e {index_b} são iguais",
  "identities.messages.4000026": "esperado {allowed_types_list}, mas foi {actual_type}",
  "identities.messages.4000027": "Já existe uma conta com o mesmo username (e-mail, telefone, nome de usuário, ...). Faça login na sua conta existente e vincule seu perfil social na página de configurações.",
  "identities.messages.4000028": "Tentou fazer login com {credential_identifier_hint}, que já está sendo usado por outra conta. Pode fazer login usando {available_credential_types_list}. Pode fazer login usando um dos seguintes provedores de login social: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "deve ser igual a constante {expected}",
  "identities.messages.4000030": "constante falhou",
  "identities.messages.4000031": "A password não pode ser utilizada porque é muito semelhante ao username.",
  "identities.messages.4000032": "A password deve conter ter pelo menos {min_length} caracteres, mas contém {actual_length}.",
  "identities.messages.4000033": "A password deve conter ter no máximo {max_length} caracteres, mas contém {actual_length}.",
  "identities.messages.4000034": "A password foi encontrada em violações de dados e não deve mais ser utilizada.",
  "identities.messages.4000035": "Esta conta não existe ou não configurou o login com código.",
  "identities.messages.4000036": "Os traços fornecidos não correspondem aos traços associados anteriormente a este fluxo.",
  "identities.messages.4010001": "O fluxo de login expirou {expired_at_unix_since_minutes} minutos atrás, tente novamente.",
  "identities.messages.4010002": "Não foi encontrada uma estratégia para fazer login. Preencheu o formulário corretamente?",
  "identities.messages.4010003": "Não foi encontrada uma estratégia para Registar. Preencheu o formulário corretamente?",
  "identities.messages.4010004": "Não foi encontrada uma estratégia para atualizar suas configurações. Preencheu o formulário corretamente?",
  "identities.messages.4010005": "Não foi encontrada uma estratégia para recuperar sua conta. Preencheu o formulário corretamente?",
  "identities.messages.4010006": "Não foi encontrada uma estratégia para verificar sua conta. Preencheu o formulário corretamente?",
  "identities.messages.4010007": "A solicitação já foi concluída com sucesso e não pode ser tentada novamente.",
  "identities.messages.4010008": "O código de login é inválido ou já foi usado. Tente novamente.",
  "identities.messages.4040001": "O fluxo de registo expirou {expired_at_unix_since_minutes} minutos atrás, tente novamente.",
  "identities.messages.4040002": "A solicitação já foi concluída com sucesso e não pode ser tentada novamente.",
  "identities.messages.4040003": "O código de registo é inválido ou já foi usado. Tente novamente.",
  "identities.messages.4050001": "O fluxo de configurações expirou {expired_at_unix_since_minutes} minutos atrás, tente novamente.",
  "identities.messages.4060001": "A solicitação já foi concluída com sucesso e não pode ser tentada novamente.",
  "identities.messages.4060002": "O fluxo de recuperação atingiu um estado de falha e deve ser tentado novamente.",
  "identities.messages.4060004": "O token de recuperação é inválido ou já foi usado. Por favor, tente o fluxo novamente.",
  "identities.messages.4060005": "O fluxo de recuperação expirou {expired_at_unix_since_minutes} minutos atrás, tente novamente.",
  "identities.messages.4060006": "O código de recuperação é inválido ou já foi usado. Tente novamente.",
  "identities.messages.4070001": "O token de verificação é inválido ou já foi usado. Tente novamente.",
  "identities.messages.4070002": "A solicitação já foi concluída com sucesso e não pode ser solicitada novamente.",
  "identities.messages.4070003": "O fluxo de verificação atingiu um estado de falha e deve ser tentado novamente.",
  "identities.messages.4070005": "O fluxo de verificação expirou {expired_at_unix_since_minutes} minutos atrás, tente novamente.",
  "identities.messages.4070006": "O código de verificação é inválido ou já foi usado. Tente novamente.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Esqueceu a password?",
  "login.logged-in-as-label": "Está conectado como:",
  "login.logout-button": "Sair",
  "login.logout-label": "Algo não está a funcionar?",
  "login.registration-button": "Registar",
  "login.registration-label": "Não tem uma conta?",
  "login.subtitle-oauth2": "Para autenticar {clientName}",
  "login.title": "Entrar",
  "login.title-aal2": "Autenticação de Dois Fatores",
  "login.title-refresh": "Confirme que é você",
  "logout.accept-button": "Sim",
  "logout.reject-button": "Não",
  "logout.title": "Deseja sair?",
  "recovery.login-button": "Entrar",
  "recovery.login-label": "Lembrar credenciais?",
  "recovery.title": "Recuperar conta",
  "registration.login-button": "Entrar",
  "registration.login-label": "Já tem uma conta?",
  "registration.subtitle-oauth2": "Para autenticar {clientName}",
  "registration.title": "Registar uma conta",
  "settings.navigation-back-button": "Voltar",
  "settings.navigation-backup-codes": "Códigos de Backup de 2FA",
  "settings.navigation-logout": "Sair",
  "settings.navigation-oidc": "login social",
  "settings.navigation-password": "Password",
  "settings.navigation-profile": "Perfil",
  "settings.navigation-totp": "Aplicação Autenticador 2FA",
  "settings.navigation-webauthn": "Tokens de Hardware",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Aqui pode gerar configurações relacionadas com a sua conta. Lembre-se de que certas ações exigem que efetue novamente login.",
  "settings.title": "Configurações da Conta",
  "settings.title-lookup-secret": "Gerar Códigos de Recuperação de Backup de 2FA",
  "settings.title-navigation": "Configurações da Conta",
  "settings.title-oidc": "login social",
  "settings.title-password": "Alterar password",
  "settings.title-profile": "Configurações de Perfil",
  "settings.title-totp": "Gerar Aplicação Autenticador 2FA",
  "settings.title-webauthn": "Gerar Tokens de Hardware",
  "settings.title-passkey": "Gerar Passkeys",
  "verification.registration-button": "Registar",
  "verification.registration-label": "Não tem uma conta?",
  "verification.title": "Verifique a sua conta"
}, pl = {
  "consent.action-accept": "Zezwól",
  "consent.action-reject": "Odmów",
  "consent.description": "Udzielaj uprawnień tylko wtedy, gdy ufasz tej witrynie lub aplikacji. Nie musisz akceptować wszystkich uprawnień.",
  "consent.privacy-policy-label": "Polityka Prywatności",
  "consent.remember-label": "Zapamiętaj tę decyzję. Aplikacja nie będzie mogła prosić o dodatkowe uprawnienia bez Twojej zgody.",
  "consent.remember-tooltip": "zapamiętaj moją decyzję",
  "consent.requested-permissions-label": "Aplikacja żąda dostępu do następujących uprawnień:",
  "consent.terms-of-service-label": "Warunki świadczenia usług",
  "error.back-button": "Cofnij",
  "error.description": "Wystąpił błąd z następującym komunikatem:",
  "error.support-email-link": "Jeżeli problem nie ustępuje skontaktuj się z <a>{contactSupportEmail}</a>",
  "error.title": "Wystąpił błąd",
  "error.title-internal-server-error": "Wewnętrzny błąd serwera",
  "error.title-not-found": "404 - Nie odnaleziono takiej strony",
  "identities.messages.1010001": "Zaloguj się",
  "identities.messages.1010002": "Zaloguj się za pomocą {provider}",
  "identities.messages.1010003": "Potwierdź tę czynność, potwierdzając, że to Ty.",
  "identities.messages.1010004": "Ukończ drugi etap uwierzytelnienia.",
  "identities.messages.1010005": "Zweryifkuj",
  "identities.messages.1010006": "Kod autentykacyjny",
  "identities.messages.1010007": "Zapasowe kody odzyskiwania",
  "identities.messages.1010008": "Użyj klucza bezpieczeństwa",
  "identities.messages.1010009": "Użyj Autentykatora",
  "identities.messages.1010010": "Użyj zapasowych kodów odzyskiwania",
  "identities.messages.1010011": "Kontynuuj za pomocą klucza bezpieczeństwa",
  "identities.messages.1010012": "Przygotuj swoje urządzenie WebAuthn (np. klucz bezpieczeństwa, czytnik biometryczny, ...) a następnie kliknij kontynuuj.",
  "identities.messages.1010013": "Kontynuuj",
  "identities.messages.1010014": "Email zawierający kod został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i spróbuj zalogować się ponownie.",
  "identities.messages.1010015": "Zaloguj się kodem",
  "identities.messages.1040001": "Zarejestruj się",
  "identities.messages.1040002": "Zarejestruj się za pomocą {provider}",
  "identities.messages.1040003": "Kontynuuj",
  "identities.messages.1040004": "Zarejestruj się kluczem bezpieczeństwa",
  "identities.messages.1040005": "Email zawierający kod został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i ponów rejestrację.",
  "identities.messages.1040006": "Zarejestruj się kodem",
  "identities.messages.1050001": "Twoje zmiany zostały zapisane!",
  "identities.messages.1050002": "Połącz {provider}",
  "identities.messages.1050003": "Odłącz {provider}",
  "identities.messages.1050004": "Odłącz Apikację Autentykator TOTP",
  "identities.messages.1050005": "Kod QR aplikacji Autentykator",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Pokaż zapasowe kody odzyskiwania",
  "identities.messages.1050008": "Wygeneruj nowe zapasowe kody odzyskiwania",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "To są Twoje zapasowe kody odzyskiwania. Trzymaj je w bezpiecznym miejscu!",
  "identities.messages.1050011": "Potwierdź zapasowe kody odzyskiwania",
  "identities.messages.1050012": "Dodaj klucz bezpieczeństwa",
  "identities.messages.1050013": "Nazwa klucza bezpieczeństwa",
  "identities.messages.1050014": "<del>Wykorzystany</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Wyłącz tą metodę",
  "identities.messages.1050017": "To jest sekret twojej aplikacji autentykator. Użyj go jeżeli nie możesz zeskanować kodu QR.",
  "identities.messages.1050018": 'Usuń klucz bezpieczeństwa "{display_name}"',
  "identities.messages.1060001": "Pomyślnie odzyskałeś swoje konto. Proszę zmień swoję hasło lub ustanowić alternatywną methodę logowania (np. logowanie zewnętrzne) w ciągu najbliższych {privileged_session_expires_at_unix_until_minutes} minut.",
  "identities.messages.1060002": "Email zawierający link odzyskiwania został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.1060003": "Email zawierający kod odzyskiwania został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.1070001": "Hasło",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Zapisz",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Wyślij",
  "identities.messages.1070006": "Zweryfikuj kod",
  "identities.messages.1070007": "Email",
  "identities.messages.1070008": "Wyślij kod ponownie",
  "identities.messages.1070009": "Kontynuuj",
  "identities.messages.1070010": "Kod odzyskiwania",
  "identities.messages.1070011": "Kod weryfikacyjny",
  "identities.messages.1070012": "Kod rejestracji",
  "identities.messages.1070013": "Kod logowania",
  "identities.messages.1080001": "Email zawierający link weryfikacyjny został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.1080002": "Poprawnie zweryfikowano adres email.",
  "identities.messages.1080003": "Email zawierający kod weryfikacyjny został wysłany na wskazany adres email. Jeżeli nie otrzymasz wiadomości to sprawdź pisownię adresu i upewnij się że używasz adresu użytego do rejestracji.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Brakuje pola {property}.",
  "identities.messages.4000003": "długość musi być >= {min_length}, otrzymano {actual_length}",
  "identities.messages.4000004": 'nie pasuje do wzoru "{pattern}"',
  "identities.messages.4000005": "Hasło nie może być użyte ponieważ {reason}.",
  "identities.messages.4000006": "Podane poświadczenia są nieprawidłowe, sprawdź czy nie ma literówek w twoim haśle, nazwie użytkownika, adresie email lub numerze telefonu.",
  "identities.messages.4000007": "Istnieje już konto o takim samym identyfikatorze (email, telefon, nazwa użytkownika, ...).",
  "identities.messages.4000008": "Podany kod autentykacyjny jest nieprawidłowy, spróbuj ponownie.",
  "identities.messages.4000009": "Nie odnaleziono żadnych identyfikatorów logowania. Czy zapomniałeś je ustawić? Może też być to spowodowane nieprawidłową konfiguracją serwera.",
  "identities.messages.4000010": "Konto nie jest jeszcze aktywne. Czy zapomniałeś/łaś zweryfikować swój adres email?",
  "identities.messages.4000011": "Nie ustanowiono urządzenia TOTP.",
  "identities.messages.4000012": "Ten kod odzyskiwania jest już wykorzystany.",
  "identities.messages.4000013": "Nie ustanowiono urządzenia WebAuthn.",
  "identities.messages.4000014": "Nie ustanowiono kodów odzyskiwania.",
  "identities.messages.4000015": "To konto nie istnieje lub nie zezwala na logowanie kluczem odzyskiwania.",
  "identities.messages.4000016": "Kod odzyskiwania jest nieprawidłowy.",
  "identities.messages.4000017": "długośc musi być <= {max_length}, otrzymano {actual_length}",
  "identities.messages.4000018": "musi być >= {minimum} otrzymano {actual}",
  "identities.messages.4000019": "musi być > {minimum} otrzymano {actual}",
  "identities.messages.4000020": "musi być <= {maximum} otrzymano {actual}",
  "identities.messages.4000021": "musi być < {maximum} otrzymano {actual}",
  "identities.messages.4000022": "{actual} nie jest wielokrotnością {base}",
  "identities.messages.4000023": "maksymalnie {max_items} wpisów, otrzymano {actual_items} wpisów",
  "identities.messages.4000024": "minimum {min_items} wpisów, otrzymano {actual_items} wpisów",
  "identities.messages.4000025": "wpisów w indeksie {index_a} i {index_b} są takie same",
  "identities.messages.4000026": "spodziewano {allowed_types_list}, otrzymano {actual_type}",
  "identities.messages.4000027": "Istnieje już konto o takim samym identyfikatorze (email, telefon, nazwa użytkownika, ...). Zaloguj się do swojego konta i połącz swój profil zewnętrzny na stronie ustawień.",
  "identities.messages.4000028": "Próbowano się zalogować za pomocą {credential_identifier_hint} który jest już używany przez inne konto. Możesz się zalogować za pomocą {available_credential_types_list}. Możesz się zalogować za pomocą następujących zewnętrznch dostawców logowania: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "musi być równe stałej {expected}",
  "identities.messages.4000030": "const nie powiodła się",
  "identities.messages.4000031": "Hasło nie może być użytę ponieważ jest zbyt podobne do identyfikatora.",
  "identities.messages.4000032": "Hasło musi być długie na co najmniej {min_length} znaków, wprowadzono {actual_length} znaków.",
  "identities.messages.4000033": "Hasło musi być nie dłuższe niż {max_length} znaków, wprowadzono {actual_length} znaków.",
  "identities.messages.4000034": "Hasło wyciekło w wyniku naruszenia danych i nie może być użyte.",
  "identities.messages.4000035": "To konto nie istnieje lub nie pozwala na logowanie kodem.",
  "identities.messages.4000036": "Podane atrybuty nie odpowiadają atrybutom wcześniej powiązanym z tym procesem.",
  "identities.messages.4010001": "Proces logowania wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4010002": "Nie odnaleziono strategii do logowania. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010003": "Nie odnaleziono strategii do rejestracji. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010004": "Nie odnaleziono strategii do aktualizacji ustawień. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010005": "Nie odnaleziono strategii do odzyskiwania konta. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010006": "Nie odnaleziono strategii do weryfikacj konta. Czy formularz został poprawnie wypełniony?",
  "identities.messages.4010007": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4010008": "Kod logowania jest niepoprawny lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.4040001": "Proces rejestracji wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4040002": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4040003": "Kod rejestracji jest niepoprawny lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.4050001": "Proces ustawień wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4060001": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4060002": "Proces odzyskiwania jest niepoprawny i musi zostać ponowiony.",
  "identities.messages.4060004": "Token odzyskiwania jest niepoprawny lub został wykorzystany. Proszę ponowić proces.",
  "identities.messages.4060005": "Proces odzyskiwania wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4060006": "Kod odzyskiwania jest nieprawidłowy lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.4070001": "Token weryfikacyjny jest nieprawidłowy lub został wykorzystany. Proszę ponowić proces.",
  "identities.messages.4070002": "Żądanie zostało poprawnie zakończone i nie może być ponowione.",
  "identities.messages.4070003": "Proces weryfikacyjny jest nieprawidłowy i musi zostać ponowiony.",
  "identities.messages.4070005": "Proces weryfikacyjny wygasł {expired_at_unix_since_minutes} minut temu, spróbuj ponownie.",
  "identities.messages.4070006": "Kod weryfikacyjny jest nieprawidłowy lub został wykorzystany. Spróbuj ponownie.",
  "identities.messages.5000001": "{reason}",
  "login.forgot-password": "Zapomniałeś/łaś hasła?",
  "login.logged-in-as-label": "Jesteś zalogowany jako:",
  "login.logout-button": "Wyloguj",
  "login.logout-label": "Coś nie działa?",
  "login.registration-button": "Zarejestruj się",
  "login.registration-label": "Nie posiadasz konta?",
  "login.subtitle-oauth2": "Do autentykacji {clientName}",
  "login.title": "Zaloguj się",
  "login.title-aal2": "Autentykacja Dwu-Etapowa",
  "login.title-refresh": "Potwierdź że to Ty",
  "logout.accept-button": "Tak",
  "logout.reject-button": "Nie",
  "logout.title": "Czy chcesz się wylogować?",
  "recovery.login-button": "Zaloguj się",
  "recovery.login-label": "Pamiętasz dane logowania?",
  "recovery.title": "Odzyskaj konto",
  "registration.login-button": "Zaloguj się",
  "registration.login-label": "Posiadasz już konto?",
  "registration.subtitle-oauth2": "Do autentykacji {clientName}",
  "registration.title": "Zarejestruj konto",
  "settings.navigation-back-button": "Cofnij",
  "settings.navigation-backup-codes": "Kody zapasowe 2FA",
  "settings.navigation-logout": "Wyloguj",
  "settings.navigation-oidc": "Zewnętrzne logowanie",
  "settings.navigation-password": "Hasło",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Aplikacja Autentykator",
  "settings.navigation-webauthn": "Tokeny Sprzętowe",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Tutaj możesz zarządzać ustawieniami związanymi z Twoim kontem. Miej na uwadze że niektóre akcje mogą wymagać ponownej uwierzytelnienia.",
  "settings.title": "Ustawienia Konta",
  "settings.title-lookup-secret": "Zarządzaj kodami odzyskiwania 2FA",
  "settings.title-navigation": "Ustawienia Konta",
  "settings.title-oidc": "Zewnętrzne logowanie",
  "settings.title-password": "Zmień Hasło",
  "settings.title-profile": "Ustawienia Profilu",
  "settings.title-totp": "Zarządzaj aplikacją autentykator 2FA TOTP",
  "settings.title-webauthn": "Zarządzaj tokenami sprzętowymi",
  "settings.title-passkey": "Zarządzaj Passkeys",
  "verification.registration-button": "Zarejestruj się",
  "verification.registration-label": "Nie posiadasz konta?",
  "verification.title": "Zweryfikuj konto"
}, locales = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  de,
  en,
  es,
  fr,
  nl,
  pl,
  pt,
  se
}, Symbol.toStringTag, { value: "Module" })), ThemeProvider = ({
  children: e,
  theme: t,
  themeOverrides: s,
  enableFontSmoothing: i
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      themeProviderStyle,
      i && themeProviderFontRenderingStyle
    ),
    style: assignInlineVars(oryTheme, {
      ...t === "dark" ? defaultDarkTheme : defaultLightTheme,
      ...s
    }),
    children: e
  }
), LanguageCodes = [
  "ab",
  "aa",
  "af",
  "sq",
  "am",
  "ar",
  "hy",
  "as",
  "ay",
  "az",
  "ba",
  "eu",
  "bn",
  "dz",
  "bh",
  "bi",
  "br",
  "bg",
  "my",
  "be",
  "km",
  "ca",
  "zh",
  "co",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "eo",
  "et",
  "fo",
  "fj",
  "fi",
  "fr",
  "fy",
  "gd",
  "gl",
  "ka",
  "de",
  "el",
  "kl",
  "gn",
  "gu",
  "ha",
  "iw",
  "hi",
  "hu",
  "is",
  "in",
  "ia",
  "ie",
  "ik",
  "ga",
  "it",
  "ja",
  "jw",
  "kn",
  "ks",
  "kk",
  "rw",
  "ky",
  "rn",
  "ko",
  "ku",
  "lo",
  "la",
  "lv",
  "ln",
  "lt",
  "mk",
  "mg",
  "ms",
  "ml",
  "mt",
  "mi",
  "mr",
  "mo",
  "mn",
  "na",
  "ne",
  "no",
  "oc",
  "or",
  "om",
  "ps",
  "fa",
  "pl",
  "pt",
  "pa",
  "qu",
  "rm",
  "ro",
  "ru",
  "sm",
  "sg",
  "sa",
  "sr",
  "sh",
  "st",
  "tn",
  "sn",
  "sd",
  "si",
  "ss",
  "sk",
  "sl",
  "so",
  "es",
  "su",
  "sw",
  "sv",
  "tl",
  "tg",
  "ta",
  "tt",
  "te",
  "th",
  "bo",
  "ti",
  "to",
  "ts",
  "tr",
  "tk",
  "tw",
  "uk",
  "ur",
  "uz",
  "vi",
  "vo",
  "cy",
  "wo",
  "xh",
  "ji",
  "yo",
  "zu"
], isCustomTranslations = (e) => e.customTranslations !== void 0, IntlProvider = ({
  children: e,
  ...t
}) => {
  let s = en;
  t.locale && t.locale in locales && (s = locales[t.locale]);
  const i = isCustomTranslations(t) ? {
    locale: t.locale,
    defaultLocale: t.defaultLocale,
    messages: t.customTranslations[t.locale]
  } : {
    locale: t.locale ?? "en",
    defaultLocale: t.defaultLocale ?? "en",
    messages: s
  };
  return /* @__PURE__ */ jsx(
    OriginalIntlProvider,
    {
      ...i,
      onWarn: () => ({}),
      defaultRichTextElements: {
        del: (n) => /* @__PURE__ */ jsx("del", { children: n })
      },
      children: e
    }
  );
};
export {
  Button,
  ButtonLink,
  ButtonSocial,
  Card,
  CardGradient,
  Checkbox,
  CodeBox,
  Divider,
  FilterFlowNodes,
  InputField,
  IntlProvider,
  LanguageCodes,
  LinkSection,
  LoginSection,
  LookupSecretSettingsSection,
  MenuLink,
  Message,
  MessageSection,
  Nav,
  Node,
  NodeMessages,
  OIDCSection,
  OIDCSettingsSection,
  PasskeySettingsSection,
  PasswordSettingsSection,
  PasswordlessLoginSection,
  PasswordlessSection,
  ProfileSettingsSection,
  RegistrationSection,
  TOTPSettingsSection,
  ThemeProvider,
  Typography,
  UserAuthCard,
  UserAuthForm,
  UserConsentCard,
  UserErrorCard,
  UserLogoutCard,
  UserSettingsCard,
  UserSettingsScreen,
  WebAuthnSettingsSection,
  buttonLinkContainerStyle,
  buttonLinkIconStyle,
  buttonLinkStyle,
  buttonSocialIconEndStyle,
  buttonSocialIconStartStyle,
  buttonSocialStyle,
  buttonStyle,
  cardStyle,
  cardTitleImage,
  cardTitleStyle,
  checkboxInputStyle,
  checkboxStyle,
  codeboxContentStyle,
  codeboxHeaderStyle,
  codeboxStyle,
  colorProperties,
  colorSprinkle,
  defaultBreakpoints,
  defaultDarkTheme,
  defaultFont,
  defaultLightTheme,
  dividerStyle,
  dividerTextStyle,
  formStyle,
  getNodeLabel,
  gridStyle,
  hasCode,
  hasGroup,
  hasHiddenIdentifier,
  hasLookupSecret,
  hasOidc,
  hasPasskey,
  hasPassword,
  hasTotp,
  hasWebauthn,
  inputFieldStyle,
  inputFieldTitleStyle,
  inputFieldVisibilityToggleLabelStyle,
  inputTypographyStyle,
  locales,
  menuLinkIconLeftStyle,
  menuLinkStyle,
  menuLinkTextStyle,
  messageStyle,
  navMainSectionStyle,
  navMenuLinkSelectedStyle,
  navMenuSectionStyle,
  navSectionBottom,
  navSectionTitleStyle,
  navStyle,
  oryTheme,
  pxToEm,
  pxToRem,
  typographyStyle,
  uiTextToFormattedMessage,
  useScriptNodes
};
